import { api } from '../api';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  JsonAsString: { input: any; output: any; }
  UnixTimestamp: { input: any; output: any; }
};

/** Autogenerated input type of AcceptBundle */
export type AcceptBundleInput = {
  bundleId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  schedulingDetails?: InputMaybe<Array<SchedulingDetail>>;
};

/** Autogenerated return type of AcceptBundle. */
export type AcceptBundlePayload = {
  __typename?: 'AcceptBundlePayload';
  bundle?: Maybe<BundleType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  jobs?: Maybe<Array<JobType>>;
};

/** Access information about a specific access method */
export type AccessInformationType = Record & {
  __typename?: 'AccessInformationType';
  code?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  humanReadableSummary?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  lockboxBrand?: Maybe<Scalars['String']['output']>;
  mlsId?: Maybe<Scalars['String']['output']>;
  mlsName?: Maybe<Scalars['String']['output']>;
  /** Associated Order. */
  order?: Maybe<OrderType>;
  orderId: Scalars['ID']['output'];
  /** Associated OrderUnit. */
  orderUnit?: Maybe<OrderUnitType>;
  orderUnitId?: Maybe<Scalars['ID']['output']>;
  type: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** An active storage bob referencing a file */
export type ActiveStorageBlob = Record & {
  __typename?: 'ActiveStorageBlob';
  byteSize: Scalars['BigInt']['output'];
  cdnUrl: Scalars['String']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  filename: Scalars['String']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  url: Scalars['String']['output'];
};

/** Autogenerated input type of AgreeMsa */
export type AgreeMsaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractorId: Scalars['ID']['input'];
};

/** Autogenerated return type of AgreeMsa. */
export type AgreeMsaPayload = {
  __typename?: 'AgreeMsaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
};

/** Defines the content of a user alert to be displayed in app */
export type AlertCampaignType = Record & {
  __typename?: 'AlertCampaignType';
  /** When this campaign was shown to inspectors */
  activatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Paragraph of text inside the alert */
  body?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Header of the alert */
  title?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Link to additional information */
  url?: Maybe<Scalars['String']['output']>;
};

/** Appliance Brand */
export type ApplianceBrandType = {
  __typename?: 'ApplianceBrandType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** A ApplianceInformation */
export type ApplianceInformationInput = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  modelNumber?: InputMaybe<Scalars['String']['input']>;
  monthManufactured?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
  reportInformationId: Scalars['ID']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Possible values: pending_data, source7_ready, source7_retrieved, source7_verified, inspector_skipped, inspector_verified, inspectify_fixed */
  status?: InputMaybe<Scalars['String']['input']>;
  subProductId?: InputMaybe<Scalars['Int']['input']>;
  subProductName?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['UnixTimestamp']['input'];
  yearManufactured?: InputMaybe<Scalars['Int']['input']>;
};

/** Appliance Product Type from Source7 */
export type ApplianceProductType = {
  __typename?: 'ApplianceProductType';
  brands: Array<ApplianceBrandType>;
  productTypeId: Scalars['Int']['output'];
  productTypeName: Scalars['String']['output'];
  subProducts: Array<ApplianceSubProductType>;
};

/** Appliance Sub Product Type from Source7 */
export type ApplianceSubProductType = {
  __typename?: 'ApplianceSubProductType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Assignment = Record & {
  __typename?: 'Assignment';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Associated User. */
  user?: Maybe<UserType>;
  userId: Scalars['ID']['output'];
};

/** A ReportAttachment */
export type AttachmentInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
  itemType: Scalars['String']['input'];
  mediaType?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JsonAsString']['input']>;
  reportId: Scalars['ID']['input'];
  reportSystemGroupId?: InputMaybe<Scalars['ID']['input']>;
  s3ObjectKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['UnixTimestamp']['input'];
};

export enum BackgroundJobStatus {
  /** The background job ran successfully. */
  Completed = 'completed',
  /** The background job failed with an error. */
  Failed = 'failed',
  /** The background job is currently running. */
  Running = 'running',
  /** The background job is scheduled and is waiting for execution. */
  Scheduled = 'scheduled'
}

/** The status of a background job */
export type BackgroundJobStatusType = {
  __typename?: 'BackgroundJobStatusType';
  status: BackgroundJobStatus;
};

/** A BaseCatalogSystemsForCatalogSystem */
export type BaseCatalogSystemsForCatalogSystemType = Record & {
  __typename?: 'BaseCatalogSystemsForCatalogSystemType';
  baseCatalogSystemIds: Array<Scalars['ID']['output']>;
  catalogSystemId: Scalars['ID']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for BaseCatalogSystemsForCatalogSystemType. */
export type BaseCatalogSystemsForCatalogSystemTypeConnection = {
  __typename?: 'BaseCatalogSystemsForCatalogSystemTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BaseCatalogSystemsForCatalogSystemTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BaseCatalogSystemsForCatalogSystemType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BaseCatalogSystemsForCatalogSystemTypeEdge = {
  __typename?: 'BaseCatalogSystemsForCatalogSystemTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseCatalogSystemsForCatalogSystemType>;
};

/** An inspection within a bundle */
export type BundleInspection = Record & {
  __typename?: 'BundleInspection';
  /** When an order on the bundle is appointment-based, describes when the tenant accepts the contractor's visit. */
  appointmentAvailabilities?: Maybe<Array<Scalars['UnixTimestamp']['output']>>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Associated Inspection. */
  inspection?: Maybe<InspectionType>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** An offer of a bundle to this contractor */
export type BundleOffer = Record & {
  __typename?: 'BundleOffer';
  /** Associated Bundle. */
  bundle?: Maybe<BundleType>;
  contractorId: Scalars['String']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** The status of this offer: pending, offered, accepted, declined, expired, unavailable */
  status: Scalars['String']['output'];
  /** The total amount of money the Contractor will receive when they complete the bundle */
  totalPay: Scalars['Float']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for BundleOffer. */
export type BundleOfferConnection = {
  __typename?: 'BundleOfferConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BundleOfferEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BundleOffer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BundleOfferEdge = {
  __typename?: 'BundleOfferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BundleOffer>;
};

/** A bundle of inspections offered as a single unit to contractors */
export type BundleType = Record & {
  __typename?: 'BundleType';
  /** Query related BundleInspections with filters. */
  bundleInspections: Array<BundleInspection>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Query related Offers with filters. */
  offers: Array<BundleOffer>;
  /** When was this bundle offered to the first inspector */
  requestedAt: Scalars['UnixTimestamp']['output'];
  /** The status of this bundle: draft, offered, accepted, declined, or unavailable. Does not reflect the status of the offer for a given contractor. */
  status: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A CatalogDeficiency */
export type CatalogDeficiencyType = Record & {
  __typename?: 'CatalogDeficiencyType';
  catalogSystemId?: Maybe<Scalars['ID']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  /** valid values: "safety", "repair", "monitor" */
  severity: Scalars['String']['output'];
  teamId?: Maybe<Scalars['ID']['output']>;
  /** Types::Records::Rehab::TemplateWorkItemType */
  templateWorkItem?: Maybe<TemplateWorkItemType>;
  title: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for CatalogDeficiencyType. */
export type CatalogDeficiencyTypeConnection = {
  __typename?: 'CatalogDeficiencyTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CatalogDeficiencyTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CatalogDeficiencyType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CatalogDeficiencyTypeEdge = {
  __typename?: 'CatalogDeficiencyTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CatalogDeficiencyType>;
};

/** A CatalogInformation */
export type CatalogInformationType = Record & {
  __typename?: 'CatalogInformationType';
  allowsOther: Scalars['Boolean']['output'];
  autoDeficiencyCondition?: Maybe<Scalars['JsonAsString']['output']>;
  autoDeficiencyDetail?: Maybe<Scalars['String']['output']>;
  autoDeficiencyMediaRequired: Scalars['Int']['output'];
  autoDeficiencyTitle?: Maybe<Scalars['String']['output']>;
  conditionalFollowupLogic?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  dataName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  isMultiSelect: Scalars['Boolean']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  questionType: Scalars['String']['output'];
  requiresDeficiencyCondition?: Maybe<Scalars['JsonAsString']['output']>;
  requiresLimitationCondition?: Maybe<Scalars['JsonAsString']['output']>;
  requiresLocations: Scalars['Boolean']['output'];
  /** Valid values: any_orientation, portrait, landscape */
  requiresMediaOrientation: Scalars['String']['output'];
  /** Valid values: any_media_type, video, photo, photo_sphere */
  requiresMediaType: Scalars['String']['output'];
  requiresMedias: Scalars['Int']['output'];
  tags?: Maybe<Scalars['JsonAsString']['output']>;
  title: Scalars['String']['output'];
  units?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  visualAidImageUrl?: Maybe<Scalars['String']['output']>;
  visualAidKbaUrl?: Maybe<Scalars['String']['output']>;
  visualAidTitle?: Maybe<Scalars['String']['output']>;
};

/** A CatalogLimitation */
export type CatalogLimitationType = Record & {
  __typename?: 'CatalogLimitationType';
  catalogSystemId?: Maybe<Scalars['ID']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for CatalogLimitationType. */
export type CatalogLimitationTypeConnection = {
  __typename?: 'CatalogLimitationTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CatalogLimitationTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CatalogLimitationType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CatalogLimitationTypeEdge = {
  __typename?: 'CatalogLimitationTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CatalogLimitationType>;
};

/** A CatalogLocationType */
export type CatalogLocationTypeType = Record & {
  __typename?: 'CatalogLocationTypeType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  groupName: Scalars['String']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for CatalogLocationTypeType. */
export type CatalogLocationTypeTypeConnection = {
  __typename?: 'CatalogLocationTypeTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CatalogLocationTypeTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CatalogLocationTypeType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CatalogLocationTypeTypeEdge = {
  __typename?: 'CatalogLocationTypeTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CatalogLocationTypeType>;
};

/** A CatalogSubsystem */
export type CatalogSubsystemType = Record & {
  __typename?: 'CatalogSubsystemType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for CatalogSubsystemType. */
export type CatalogSubsystemTypeConnection = {
  __typename?: 'CatalogSubsystemTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CatalogSubsystemTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CatalogSubsystemType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CatalogSubsystemTypeEdge = {
  __typename?: 'CatalogSubsystemTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CatalogSubsystemType>;
};

/** A CatalogSystem */
export type CatalogSystemType = Record & {
  __typename?: 'CatalogSystemType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for CatalogSystemType. */
export type CatalogSystemTypeConnection = {
  __typename?: 'CatalogSystemTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CatalogSystemTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CatalogSystemType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CatalogSystemTypeEdge = {
  __typename?: 'CatalogSystemTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CatalogSystemType>;
};

/** Autogenerated input type of CheckVerificationSms */
export type CheckVerificationSmsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  verificationCode: Scalars['String']['input'];
};

/** Autogenerated return type of CheckVerificationSms. */
export type CheckVerificationSmsPayload = {
  __typename?: 'CheckVerificationSmsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  token?: Maybe<Scalars['String']['output']>;
};

/** A list of commonly used deficiencies by template subsystem */
export type CommonlyUsedDeficienciesType = {
  __typename?: 'CommonlyUsedDeficienciesType';
  catalogDeficiencyIds: Array<Scalars['ID']['output']>;
  templateSubsystemId: Scalars['ID']['output'];
};

/** A Company */
export type CompanyType = Record & {
  __typename?: 'CompanyType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** The name of the Company. */
  name?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

export enum ContractorPaymentPlatform {
  /**
   * Brex
   * @deprecated Stopped doing payment via Brex in June 2023
   */
  BrexPayment = 'brex_payment',
  /** Direct */
  DirectPayment = 'direct_payment',
  /** Showami */
  ShowamiPayment = 'showami_payment',
  /** Tipalti */
  TipaltiPayment = 'tipalti_payment'
}

/** Tracks whether a service is configured and allows custom pricing */
export type ContractorPricing = {
  __typename?: 'ContractorPricing';
  active: Scalars['Boolean']['output'];
  allowCustomPricing: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** A contractor pricing */
export type ContractorPricingInput = {
  customPricing?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subContracted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contains enough information to embed Metabase iframe URLs */
export type ContractorScorecardType = {
  __typename?: 'ContractorScorecardType';
  /** True if there were enough jobs completed within the time frame to have a valid report. "Enough jobs" is at least 1 inspection in the time period. */
  hasEnoughData: Scalars['Boolean']['output'];
  /** A Metabase URL designed to be embedded in an iframe, showing the inspector scorecard dashboard, or NULL when has_enough_data is false. */
  inspectorScorecardDashboardUrl?: Maybe<Scalars['String']['output']>;
  /** A Metabase URL designed to be embedded in an iframe, showing the inspector scorecard dashboard reliability score, or NULL when has_enough_data is false. */
  inspectorScorecardReliabilityScoreUrl?: Maybe<Scalars['String']['output']>;
};

/** A Contractor */
export type ContractorType = Record & {
  __typename?: 'ContractorType';
  /** The threshold for the Android Blurry Frequency to alert the inspector */
  androidBlurryFreqThreshold?: Maybe<Scalars['Int']['output']>;
  /** License number as part of ASHI association */
  ashiLicenseNumber?: Maybe<Scalars['String']['output']>;
  /** If this Contractor can receive job offer through Automated Scheduling */
  automatedSchedulingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Physical address of the Contractor */
  businessAddress?: Maybe<Scalars['String']['output']>;
  /** The name of the business contact */
  businessContactName?: Maybe<Scalars['String']['output']>;
  /** Main email address of the Contractor */
  businessEmail?: Maybe<Scalars['String']['output']>;
  /** Business name of this contractor */
  businessName?: Maybe<Scalars['String']['output']>;
  /** Main phone number of the Contractor */
  businessPhone?: Maybe<Scalars['String']['output']>;
  /** Website of this contractor */
  businessSite?: Maybe<Scalars['String']['output']>;
  /** ZIP code of the Contractor business address */
  businessZipCode?: Maybe<Scalars['String']['output']>;
  /** Text with all the certification this Contractor has */
  certifications?: Maybe<Scalars['String']['output']>;
  /** Physical address city */
  city?: Maybe<Scalars['String']['output']>;
  /** Possible values: text, call, email */
  communicationPreference?: Maybe<Scalars['String']['output']>;
  /** Possesses a contractor license */
  contractorLicenseHeld?: Maybe<Scalars['Boolean']['output']>;
  /** Information about configurable services and pricing */
  contractorPricings: Array<ContractorPricing>;
  /** The Type of Contractor (inspector, team_internal, showami, redfin, etc.) */
  contractorType?: Maybe<Scalars['String']['output']>;
  /** Physical address country */
  country?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Types::Records::Saga::InspectorOnboardingType */
  currentInspectorOnboarding?: Maybe<InspectorOnboardingType>;
  /** Types::Records::Saga::SurveyorOnboardingType */
  currentOnboarding?: Maybe<SurveyorOnboardingType>;
  /** Number of inspector at this inspection company */
  employeeCount?: Maybe<Scalars['Int']['output']>;
  /** Query related FileAttachments with filters. */
  fileAttachments: Array<FileAttachment>;
  /** If the inspector has access to the Sentrilock system */
  hasSentrilock?: Maybe<Scalars['Boolean']['output']>;
  /** If the inspector has access to the Supra system */
  hasSupra?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** When this Contractor started their business */
  inBusinessSince?: Maybe<Scalars['Int']['output']>;
  /** Possesses an inspector license */
  inspectorLicenseHeld?: Maybe<Scalars['Boolean']['output']>;
  /** This contractor is offered to be booked instantly */
  instantBookingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** License number as part of Internachi association */
  internachiLicenseNumber?: Maybe<Scalars['String']['output']>;
  /** All Teams that have this Contractor setup as Internal Contractor */
  internalTeams: Array<TeamType>;
  /** The threshold for the iOS Blurry Frequency to alert the inspector */
  iosBlurryFreqThreshold?: Maybe<Scalars['Int']['output']>;
  /** Physical address latitude */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Attached Logo. */
  logo?: Maybe<ActiveStorageBlob>;
  /** Physical address longitude */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** If the inspector has signed the most recent version of the MSA */
  msaSigned?: Maybe<Scalars['Boolean']['output']>;
  /** Other License number than ASHI/Internachi */
  otherLicenseNumber?: Maybe<Scalars['String']['output']>;
  /** This contractor is an Inspectify Preferred contractor */
  preferredInspectorStatus?: Maybe<Scalars['String']['output']>;
  /** Possesses a real estate agent license */
  realEstateLicenseHeld?: Maybe<Scalars['Boolean']['output']>;
  /** Which Report Writing software the inspector use outside of Inspectify App */
  reportWritingSoftware?: Maybe<Scalars['String']['output']>;
  /** Main email address of the scheduler person at the Contractor */
  schedulerEmail?: Maybe<Scalars['String']['output']>;
  /** The name of the scheduler person at Contractor */
  schedulerName?: Maybe<Scalars['String']['output']>;
  /** Main phone number of the scheduler person at the Contractor */
  schedulerPhone?: Maybe<Scalars['String']['output']>;
  /** Allowed to received Text message */
  sendAutomatedSms?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum driving mileage to accept jobs */
  serviceAreaRadiusMileage?: Maybe<Scalars['Int']['output']>;
  /** Zip codes this contractor serves */
  serviceZipCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Physical address state */
  state?: Maybe<Scalars['String']['output']>;
  /** State specific license number */
  stateLicenseNumber?: Maybe<Scalars['String']['output']>;
  /** Street address of the Contractor business address */
  street?: Maybe<Scalars['String']['output']>;
  /** Unit or apartment number of the Contractor business address */
  street2?: Maybe<Scalars['String']['output']>;
  /** If this inspector has completed Tipalti onboarding and ready to be paid */
  tipaltiIsPayable?: Maybe<Scalars['Boolean']['output']>;
  /** Token (Old Authentication system) for this Contractor */
  token?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for ContractorType. */
export type ContractorTypeConnection = {
  __typename?: 'ContractorTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContractorTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ContractorType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContractorTypeEdge = {
  __typename?: 'ContractorTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContractorType>;
};

/** Autogenerated input type of CreateInspectorOnboarding */
export type CreateInspectorOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateInspectorOnboarding. */
export type CreateInspectorOnboardingPayload = {
  __typename?: 'CreateInspectorOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  inspectorOnboarding?: Maybe<InspectorOnboardingType>;
};

/** Autogenerated input type of CreateItemAccessLog */
export type CreateItemAccessLogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['ID']['input'];
  itemType: Scalars['String']['input'];
  stakeholderTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateItemAccessLog. */
export type CreateItemAccessLogPayload = {
  __typename?: 'CreateItemAccessLogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  itemAccessLog?: Maybe<ItemAccessLogType>;
};

/** Autogenerated input type of CreateProject */
export type CreateProjectInput = {
  address: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inspectionDocumentId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
  teamId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateProject. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  project?: Maybe<ProjectType>;
};

/** Autogenerated input type of CreateReportAsync */
export type CreateReportAsyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inspectionIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateReportAsync. */
export type CreateReportAsyncPayload = {
  __typename?: 'CreateReportAsyncPayload';
  backgroundJobId: Scalars['ID']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
};

/** Autogenerated input type of CreateReportAttachment */
export type CreateReportAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  itemId: Scalars['ID']['input'];
  itemType: Scalars['String']['input'];
  mediaType?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JsonAsString']['input']>;
  reportId: Scalars['ID']['input'];
  reportSystemGroupId?: InputMaybe<Scalars['ID']['input']>;
  s3ObjectKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['UnixTimestamp']['input'];
};

/** Autogenerated return type of CreateReportAttachment. */
export type CreateReportAttachmentPayload = {
  __typename?: 'CreateReportAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  reportAttachment?: Maybe<ReportAttachmentType>;
};

/** Autogenerated input type of CreateReport */
export type CreateReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inspectionIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateReport. */
export type CreateReportPayload = {
  __typename?: 'CreateReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  report: ReportType;
};

/** Autogenerated input type of CreateSurveyorOnboarding */
export type CreateSurveyorOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSurveyorOnboarding. */
export type CreateSurveyorOnboardingPayload = {
  __typename?: 'CreateSurveyorOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  surveyorOnboarding?: Maybe<SurveyorOnboardingType>;
};

/** Autogenerated input type of CreateUser */
export type CreateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Unique token for contractor, can be used to create the first user of a Contractor */
  contractorToken?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  grantedPermissions: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  /** In which team should the new User be added? */
  teamId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateUser. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  user?: Maybe<UserType>;
};

/** Autogenerated input type of CreateUserPushToken */
export type CreateUserPushTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expoPushToken: Scalars['String']['input'];
};

/** Autogenerated return type of CreateUserPushToken. */
export type CreateUserPushTokenPayload = {
  __typename?: 'CreateUserPushTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  userPushToken?: Maybe<UserPushTokenType>;
};

/** Autogenerated input type of CreateWorkItemAssociation */
export type CreateWorkItemAssociationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JsonAsString']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  workItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateWorkItemAssociation. */
export type CreateWorkItemAssociationPayload = {
  __typename?: 'CreateWorkItemAssociationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItemAssociation?: Maybe<WorkItemAssociationType>;
};

/** Autogenerated input type of CreateWorkItemAttachment */
export type CreateWorkItemAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  s3ObjectKey?: InputMaybe<Scalars['String']['input']>;
  workItemAssociationId?: InputMaybe<Scalars['ID']['input']>;
  workItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateWorkItemAttachment. */
export type CreateWorkItemAttachmentPayload = {
  __typename?: 'CreateWorkItemAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItemAttachment?: Maybe<WorkItemAttachmentType>;
};

/** Autogenerated input type of CreateWorkItemContributor */
export type CreateWorkItemContributorInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateWorkItemContributor. */
export type CreateWorkItemContributorPayload = {
  __typename?: 'CreateWorkItemContributorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItemContributor?: Maybe<WorkItemContributorType>;
};

/** Autogenerated input type of CreateWorkItem */
export type CreateWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  details: Scalars['String']['input'];
  displayIndex?: InputMaybe<Scalars['Int']['input']>;
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
  pricingExternalId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  saveToLibrary?: InputMaybe<Scalars['Boolean']['input']>;
  subsystemName?: InputMaybe<Scalars['String']['input']>;
  systemName: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  teamMarketId?: InputMaybe<Scalars['ID']['input']>;
  templateWorkItemPricingId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateWorkItem. */
export type CreateWorkItemPayload = {
  __typename?: 'CreateWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItem?: Maybe<WorkItemType>;
};

/** Autogenerated input type of DeclineBundle */
export type DeclineBundleInput = {
  bundleId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeclineBundle. */
export type DeclineBundlePayload = {
  __typename?: 'DeclineBundlePayload';
  bundle?: Maybe<BundleType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
};

/** A ReportDeficiencyInformation */
export type DeficiencyInformationInput = {
  allowsOther: Scalars['Boolean']['input'];
  cannotAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  catalogDeficiencyInformationId: Scalars['ID']['input'];
  dataName: Scalars['String']['input'];
  detail?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isMultiSelect: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  questionType: Scalars['String']['input'];
  reportDeficiencyId: Scalars['ID']['input'];
  requiresLocations: Scalars['Boolean']['input'];
  requiresMedias: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  units?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['UnixTimestamp']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A ReportDeficiency */
export type DeficiencyInput = {
  catalogDeficiencyId?: InputMaybe<Scalars['ID']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reInspectionStatus?: InputMaybe<Scalars['String']['input']>;
  recommendationDescription?: InputMaybe<Scalars['String']['input']>;
  recommendationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  reportInformationId?: InputMaybe<Scalars['ID']['input']>;
  reportSubsystemId: Scalars['ID']['input'];
  severity: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt: Scalars['UnixTimestamp']['input'];
};

/** Autogenerated input type of DeleteReportAttachment */
export type DeleteReportAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteReportAttachment. */
export type DeleteReportAttachmentPayload = {
  __typename?: 'DeleteReportAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  reportAttachment?: Maybe<ReportAttachmentType>;
};

/** Autogenerated input type of DeleteTeamCustomSystem */
export type DeleteTeamCustomSystemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTeamCustomSystem. */
export type DeleteTeamCustomSystemPayload = {
  __typename?: 'DeleteTeamCustomSystemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  teamCustomSystem?: Maybe<TeamCustomSystemType>;
};

/** Autogenerated input type of DeleteUserPushToken */
export type DeleteUserPushTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteUserPushToken. */
export type DeleteUserPushTokenPayload = {
  __typename?: 'DeleteUserPushTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  userPushToken?: Maybe<UserPushTokenType>;
};

/** Autogenerated input type of DeleteWorkItemAssociation */
export type DeleteWorkItemAssociationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteWorkItemAssociation. */
export type DeleteWorkItemAssociationPayload = {
  __typename?: 'DeleteWorkItemAssociationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItemAssociation?: Maybe<WorkItemAssociationType>;
};

/** Autogenerated input type of DeleteWorkItemAttachment */
export type DeleteWorkItemAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteWorkItemAttachment. */
export type DeleteWorkItemAttachmentPayload = {
  __typename?: 'DeleteWorkItemAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItemAttachment?: Maybe<WorkItemAttachmentType>;
};

/** Autogenerated input type of DeleteWorkItemContributor */
export type DeleteWorkItemContributorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteWorkItemContributor. */
export type DeleteWorkItemContributorPayload = {
  __typename?: 'DeleteWorkItemContributorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItemContributor?: Maybe<WorkItemContributorType>;
};

/** Autogenerated input type of DeleteWorkItem */
export type DeleteWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteWorkItem. */
export type DeleteWorkItemPayload = {
  __typename?: 'DeleteWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItem?: Maybe<WorkItemType>;
};

/** A Report record that was deleted by the App */
export type DeletionInput = {
  /** When it was deleted */
  deletedAt: Scalars['UnixTimestamp']['input'];
  /** The id of the record */
  itemId: Scalars['ID']['input'];
  /** The type of record (example: "ReportAttachment", "ReportDeficiency", etc.) */
  itemType: Scalars['String']['input'];
};

/** Autogenerated input type of DirectUpload */
export type DirectUploadInput = {
  byteSize: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JsonAsString']['input']>;
};

/** Autogenerated return type of DirectUpload. */
export type DirectUploadPayload = {
  __typename?: 'DirectUploadPayload';
  blobSignedId: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contentMd5: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  url: Scalars['String']['output'];
};

export enum DrawSummaryTableDisplay {
  /** Summary is show with disbursement and total */
  DisplayWithDisbursementAndTotal = 'display_with_disbursement_and_total',
  /** Summary is shown without disbursement and total */
  DisplayWithoutDisbursementAndTotal = 'display_without_disbursement_and_total',
  /** Summary is hidden */
  Hidden = 'hidden'
}

/** A FileAttachment */
export type FileAttachment = Record & {
  __typename?: 'FileAttachment';
  /** Attached Attachment. */
  attachment?: Maybe<ActiveStorageBlob>;
  /** Possible values: w9, insurance_certificate, contract, pricing_sheet, other */
  category: Scalars['String']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A FloorPlanAnchor */
export type FloorPlanAnchorInput = {
  reportAttachmentId: Scalars['ID']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/** A floor plan anchor */
export type FloorPlanAnchorType = Record & {
  __typename?: 'FloorPlanAnchorType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Associated FloorPlanLevel. */
  floorPlanLevel?: Maybe<FloorPlanLevelType>;
  floorPlanLevelId: Scalars['ID']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Associated ReportAttachment. */
  reportAttachment?: Maybe<ReportAttachmentType>;
  reportAttachmentId: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/** A floor plan inspection */
export type FloorPlanInspectionType = Record & {
  __typename?: 'FloorPlanInspectionType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Query related FloorPlanLevels with filters. */
  floorPlanLevels: Array<FloorPlanLevelType>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Associated Inspection. */
  inspection?: Maybe<InspectionType>;
  inspectionId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A floor plan level */
export type FloorPlanLevelType = Record & {
  __typename?: 'FloorPlanLevelType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  floorName: Scalars['String']['output'];
  /** Query related FloorPlanAnchors with filters. */
  floorPlanAnchors: Array<FloorPlanAnchorType>;
  /** Associated FloorPlanInspection. */
  floorPlanInspection?: Maybe<FloorPlanInspectionType>;
  floorPlanInspectionId: Scalars['ID']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  image: ActiveStorageBlob;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** Autogenerated input type of GenerateDrawReportCsv */
export type GenerateDrawReportCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateDrawReportCsv. */
export type GenerateDrawReportCsvPayload = {
  __typename?: 'GenerateDrawReportCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  drawCsvActiveStorageBlob: ActiveStorageBlob;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
};

/** Autogenerated input type of GeneratePdfReport */
export type GeneratePdfReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
  systemGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of GeneratePdfReport. */
export type GeneratePdfReportPayload = {
  __typename?: 'GeneratePdfReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  pdfReportActiveStorageBlob: ActiveStorageBlob;
};

/** Autogenerated input type of GeneratePhotoSphereImagesZip */
export type GeneratePhotoSphereImagesZipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportAttachmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of GeneratePhotoSphereImagesZip. */
export type GeneratePhotoSphereImagesZipPayload = {
  __typename?: 'GeneratePhotoSphereImagesZipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  photoSphereImagesZipActiveStorageBlob: ActiveStorageBlob;
};

/** Autogenerated input type of GenerateProjectCsv */
export type GenerateProjectCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of GenerateProjectCsv. */
export type GenerateProjectCsvPayload = {
  __typename?: 'GenerateProjectCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  rehabProjectCsvActiveStorageBlob: ActiveStorageBlob;
};

/** Autogenerated input type of GenerateProjectPdf */
export type GenerateProjectPdfInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contributors?: InputMaybe<Array<Scalars['String']['input']>>;
  projectId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of GenerateProjectPdf. */
export type GenerateProjectPdfPayload = {
  __typename?: 'GenerateProjectPdfPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  rehabProjectPdfActiveStorageBlob: ActiveStorageBlob;
};

/** Autogenerated input type of GeneratePropertyPermitPdfReport */
export type GeneratePropertyPermitPdfReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  propertyId: Scalars['ID']['input'];
};

/** Autogenerated return type of GeneratePropertyPermitPdfReport. */
export type GeneratePropertyPermitPdfReportPayload = {
  __typename?: 'GeneratePropertyPermitPdfReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  permitPdfReportActiveStorageBlob: ActiveStorageBlob;
};

/** Autogenerated input type of GenerateTipaltiIframeUrl */
export type GenerateTipaltiIframeUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractorId: Scalars['ID']['input'];
  /** Options: setup_process, invoice_history, payment_history */
  iframeType: Scalars['String']['input'];
};

/** Autogenerated return type of GenerateTipaltiIframeUrl. */
export type GenerateTipaltiIframeUrlPayload = {
  __typename?: 'GenerateTipaltiIframeUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  iframeUrl: Scalars['String']['output'];
};

/** A ReportInformation */
export type InformationInput = {
  allowsOther: Scalars['Boolean']['input'];
  cannotAnswerReason?: InputMaybe<ReportInformationCannotAnswerReason>;
  catalogInformationId: Scalars['ID']['input'];
  conditionalFollowupLogic?: InputMaybe<Scalars['String']['input']>;
  dataName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  displayIndex: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  isMultiSelect: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  questionType: Scalars['String']['input'];
  reportLimitationId?: InputMaybe<Scalars['ID']['input']>;
  reportSubsystemId: Scalars['ID']['input'];
  requiresDeficiencyCatalogDeficiencyId?: InputMaybe<Scalars['ID']['input']>;
  requiresDeficiencyCondition?: InputMaybe<Scalars['JsonAsString']['input']>;
  requiresLimitationCondition?: InputMaybe<Scalars['JsonAsString']['input']>;
  requiresLocations: Scalars['Boolean']['input'];
  /** Valid values: any_orientation, portrait, landscape */
  requiresMediaOrientation?: InputMaybe<Scalars['String']['input']>;
  /** Valid values: any_media_type, video, photo, photo_sphere */
  requiresMediaType?: InputMaybe<Scalars['String']['input']>;
  requiresMedias: Scalars['Int']['input'];
  status?: InputMaybe<ReportInformationStatus>;
  tags?: InputMaybe<Scalars['JsonAsString']['input']>;
  title: Scalars['String']['input'];
  units?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['UnixTimestamp']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** An appointment for an inspection inside a bundle */
export type InspectionAppointment = {
  inspectionId: Scalars['ID']['input'];
  scheduledTime: Scalars['UnixTimestamp']['input'];
};

/** A InspectionDocument */
export type InspectionDocumentType = Record & {
  __typename?: 'InspectionDocumentType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Attached Document. */
  document?: Maybe<ActiveStorageBlob>;
  /** Possible values: document, spectora_web_report, inspectify_app_report, inspectify_app_no_deficiencies_report, inspectify_app_appliances_only_report, inspectify_app_data_csv, inspectify_app_images_zip, inspectify_app_denver_rental_pdf, youtube, vimeo, matterport */
  documentType: Scalars['String']['output'];
  externalDocumentUrl: Scalars['String']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Associated Report. */
  report?: Maybe<ReportType>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** An inspection proposal */
export type InspectionProposalType = Record & {
  __typename?: 'InspectionProposalType';
  /** Query related Assignments with filters. */
  assignments: Array<Assignment>;
  /** @deprecated Replaced by scheduled_at */
  availability?: Maybe<Scalars['UnixTimestamp']['output']>;
  contractorFee?: Maybe<Scalars['Float']['output']>;
  contractorId: Scalars['ID']['output'];
  contractorPaidAt?: Maybe<Scalars['ISO8601Date']['output']>;
  contractorPaymentPlatform: ContractorPaymentPlatform;
  /** @deprecated Unused, use Business Name instead */
  contractorRepresentative?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** @deprecated Unused, could be brought back using the InspectionDurationService */
  durationHour?: Maybe<Scalars['Float']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  inspectionId: Scalars['ID']['output'];
  isGoAnytime?: Maybe<Scalars['Boolean']['output']>;
  scheduledAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  teamInternalUserTypeId?: Maybe<Scalars['ID']['output']>;
  totalFee?: Maybe<Scalars['Float']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A InspectionReport */
export type InspectionReportType = Record & {
  __typename?: 'InspectionReportType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Associated Inspection. */
  inspection?: Maybe<InspectionType>;
  /** Associated Report. */
  report?: Maybe<ReportType>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** An inspection scope item */
export type InspectionScopeItemType = Record & {
  __typename?: 'InspectionScopeItemType';
  budget?: Maybe<Scalars['Float']['output']>;
  clientDisbursement?: Maybe<Scalars['Float']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disbursement?: Maybe<Scalars['Float']['output']>;
  displayIndex: Scalars['Int']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Associated Inspection. */
  inspection?: Maybe<InspectionType>;
  name?: Maybe<Scalars['String']['output']>;
  /** Associated OrderUnit. */
  orderUnit?: Maybe<OrderUnitType>;
  orderUnitId?: Maybe<Scalars['String']['output']>;
  previousDisbursement?: Maybe<Scalars['Float']['output']>;
  previousInspectionScopeItem?: Maybe<InspectionScopeItemType>;
  progress?: Maybe<Scalars['Float']['output']>;
  tags?: Maybe<Scalars['JsonAsString']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for InspectionScopeItemType. */
export type InspectionScopeItemTypeConnection = {
  __typename?: 'InspectionScopeItemTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InspectionScopeItemTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InspectionScopeItemType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InspectionScopeItemTypeEdge = {
  __typename?: 'InspectionScopeItemTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InspectionScopeItemType>;
};

/** An inspection */
export type InspectionType = Record & {
  __typename?: 'InspectionType';
  /** @deprecated Should not be used anymore */
  appRequirement?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  customerFacingName: Scalars['String']['output'];
  dueOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Query related FloorPlanInspections with filters. */
  floorPlanInspections: Array<FloorPlanInspectionType>;
  geotaggingRequired: Scalars['Boolean']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Query related InspectionReports with filters. */
  inspectionReports: Array<InspectionReportType>;
  /** Query related InspectionScopeItems with filters. */
  inspectionScopeItems: Array<InspectionScopeItemType>;
  inspectionScopeNumber?: Maybe<Scalars['Int']['output']>;
  inspectionSubtype?: Maybe<Scalars['String']['output']>;
  inspectionType: Scalars['String']['output'];
  /** Associated InspectionWarranty. */
  inspectionWarranty?: Maybe<InspectionWarrantyType>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  /** Associated Order. */
  order?: Maybe<OrderType>;
  orderId: Scalars['ID']['output'];
  photoSphereRequired: Scalars['Boolean']['output'];
  /** Associated ScheduledProposal. */
  scheduledProposal?: Maybe<InspectionProposalType>;
  scheduledProposalId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** Associated TemplateReport. */
  templateReport?: Maybe<TemplateReportType>;
  templateReportId?: Maybe<Scalars['ID']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A InspectionWarranty */
export type InspectionWarrantyType = Record & {
  __typename?: 'InspectionWarrantyType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  expirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Associated Inspection. */
  inspection?: Maybe<InspectionType>;
  inspectionId: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  status: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** Data provided by on onboarding user */
export type InspectorOnboardingFormInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  ashiLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  businessName: Scalars['String']['input'];
  businessSite?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  internachiLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  isMultiInspectorFirm: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  otherLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  stateLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Tracks the progress data of an inspector onboarding process */
export type InspectorOnboardingType = Record & {
  __typename?: 'InspectorOnboardingType';
  appLoggedIn: Scalars['Boolean']['output'];
  canSetPassword: Scalars['Boolean']['output'];
  completedStep: Scalars['String']['output'];
  /** Associated Contractor. */
  contractor?: Maybe<ContractorType>;
  contractorServicesAdded: Scalars['Boolean']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  insuranceCertificateUploaded: Scalars['Boolean']['output'];
  isMultiInspectorFirm: Scalars['Boolean']['output'];
  misaSigned: Scalars['Boolean']['output'];
  onboardingTrackerDismissedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  paymentDetailsFilled: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  usersAdded: Scalars['Boolean']['output'];
};

/** The connection type for InspectorOnboardingType. */
export type InspectorOnboardingTypeConnection = {
  __typename?: 'InspectorOnboardingTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InspectorOnboardingTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InspectorOnboardingType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InspectorOnboardingTypeEdge = {
  __typename?: 'InspectorOnboardingTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InspectorOnboardingType>;
};

export type IsAllowedType = {
  __typename?: 'IsAllowedType';
  isAllowed: Scalars['Boolean']['output'];
};

/** An ItemAccessLog */
export type ItemAccessLogType = Record & {
  __typename?: 'ItemAccessLogType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  item: Record;
  itemId: Scalars['ID']['output'];
  itemType: Scalars['String']['output'];
  requestId?: Maybe<Scalars['String']['output']>;
  stakeholderTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  user?: Maybe<UserType>;
  userAgent?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export enum JobStatus {
  /** Job is completed (Report published) */
  Completed = 'completed',
  /** Job is scheduled, report is not published */
  Scheduled = 'scheduled'
}

/** A Job for an inspector to complete */
export type JobType = {
  __typename?: 'JobType';
  id: Scalars['ID']['output'];
  inspections: Array<InspectionType>;
  isFee: Scalars['Boolean']['output'];
  isGoAnytime: Scalars['Boolean']['output'];
  isMock: Scalars['Boolean']['output'];
  order: OrderType;
  reports: Array<ReportType>;
  scheduledTime: Scalars['UnixTimestamp']['output'];
  status: JobStatus;
};

/** The connection type for JobType. */
export type JobTypeConnection = {
  __typename?: 'JobTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JobTypeEdge = {
  __typename?: 'JobTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<JobType>;
};

/** A ReportLimitation */
export type LimitationInput = {
  catalogLimitationId?: InputMaybe<Scalars['ID']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reportInformationId?: InputMaybe<Scalars['ID']['input']>;
  reportSubsystemId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  updatedAt: Scalars['UnixTimestamp']['input'];
};

/** A ReportLocation */
export type LocationInput = {
  catalogLocationTypeId: Scalars['ID']['input'];
  groupName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
  itemType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reportId: Scalars['ID']['input'];
  updatedAt: Scalars['UnixTimestamp']['input'];
};

/** Autogenerated input type of MarkUserAlertsAsViewed */
export type MarkUserAlertsAsViewedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAlertIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of MarkUserAlertsAsViewed. */
export type MarkUserAlertsAsViewedPayload = {
  __typename?: 'MarkUserAlertsAsViewedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  userAlerts: Array<UserAlertType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptBundle?: Maybe<AcceptBundlePayload>;
  agreeMsa?: Maybe<AgreeMsaPayload>;
  checkVerificationSms?: Maybe<CheckVerificationSmsPayload>;
  createInspectorOnboarding?: Maybe<CreateInspectorOnboardingPayload>;
  createItemAccessLog?: Maybe<CreateItemAccessLogPayload>;
  createRehabProject?: Maybe<CreateProjectPayload>;
  createRehabWorkItem?: Maybe<CreateWorkItemPayload>;
  createRehabWorkItemAssociation?: Maybe<CreateWorkItemAssociationPayload>;
  createRehabWorkItemAttachment?: Maybe<CreateWorkItemAttachmentPayload>;
  createRehabWorkItemContributor?: Maybe<CreateWorkItemContributorPayload>;
  createReport?: Maybe<CreateReportPayload>;
  createReportAsync?: Maybe<CreateReportAsyncPayload>;
  createReportAttachment?: Maybe<CreateReportAttachmentPayload>;
  createSurveyorOnboarding?: Maybe<CreateSurveyorOnboardingPayload>;
  createUser?: Maybe<CreateUserPayload>;
  createUserPushToken?: Maybe<CreateUserPushTokenPayload>;
  declineBundle?: Maybe<DeclineBundlePayload>;
  deleteRehabWorkItem?: Maybe<DeleteWorkItemPayload>;
  deleteRehabWorkItemAssociation?: Maybe<DeleteWorkItemAssociationPayload>;
  deleteRehabWorkItemAttachment?: Maybe<DeleteWorkItemAttachmentPayload>;
  deleteRehabWorkItemContributor?: Maybe<DeleteWorkItemContributorPayload>;
  deleteReportAttachment?: Maybe<DeleteReportAttachmentPayload>;
  deleteTeamCustomSystem?: Maybe<DeleteTeamCustomSystemPayload>;
  deleteUserPushToken?: Maybe<DeleteUserPushTokenPayload>;
  directUpload?: Maybe<DirectUploadPayload>;
  generateDrawReportCsv?: Maybe<GenerateDrawReportCsvPayload>;
  generatePdfReport?: Maybe<GeneratePdfReportPayload>;
  generatePhotoSphereImagesZip?: Maybe<GeneratePhotoSphereImagesZipPayload>;
  generatePropertyPermitPdfReport?: Maybe<GeneratePropertyPermitPdfReportPayload>;
  generateRehabProjectCsv?: Maybe<GenerateProjectCsvPayload>;
  generateRehabProjectPdf?: Maybe<GenerateProjectPdfPayload>;
  generateTipaltiIframeUrl?: Maybe<GenerateTipaltiIframeUrlPayload>;
  markUserAlertsAsViewed?: Maybe<MarkUserAlertsAsViewedPayload>;
  populateReportSystemsFromInspectionTemplates?: Maybe<PopulateReportSystemsFromInspectionTemplatesPayload>;
  populateTeamCustomSystem?: Maybe<PopulateTeamCustomSystemPayload>;
  publishAppraisal?: Maybe<PublishAppraisalPayload>;
  publishRehabProject?: Maybe<PublishProjectPayload>;
  publishReport?: Maybe<PublishReportPayload>;
  reassignJob?: Maybe<ReassignJobPayload>;
  resendInvite?: Maybe<ResendInvitePayload>;
  runFixMissingS3ObjectKeysOnReportAttachment?: Maybe<RunFixMissingS3ObjectKeysOnReportAttachmentsPayload>;
  scheduleInternalInspection?: Maybe<ScheduleInternalInspectionPayload>;
  sendTestNotification?: Maybe<SendTestNotificationPayload>;
  sendVerificationSms?: Maybe<SendVerificationSmsPayload>;
  submitFeedback?: Maybe<UserFeedback>;
  syncReport?: Maybe<SyncReportPayload>;
  transformReportAttachment?: Maybe<TransformReportAttachmentPayload>;
  updateContractor?: Maybe<UpdateContractorPayload>;
  updateFloorPlanLevel?: Maybe<UpdateFloorPlanLevelPayload>;
  updateInspectionScopeItem?: Maybe<UpdateInspectionScopeItemPayload>;
  updateInspectorOnboarding?: Maybe<UpdateInspectorOnboardingPayload>;
  updateRehabProject?: Maybe<UpdateProjectPayload>;
  updateRehabWorkItem?: Maybe<UpdateWorkItemPayload>;
  updateRehabWorkItemAssociation?: Maybe<UpdateWorkItemAssociationPayload>;
  updateRehabWorkItemAttachment?: Maybe<UpdateWorkItemAttachmentPayload>;
  updateRehabWorkItemContributor?: Maybe<UpdateWorkItemContributorPayload>;
  updateReportApplianceInformation?: Maybe<UpdateReportApplianceInformationPayload>;
  updateSurveyorOnboarding?: Maybe<UpdateSurveyorOnboardingPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  warrantyClaim?: Maybe<WarrantyClaimPayload>;
  warrantyProveOwnership?: Maybe<WarrantyProveOwnershipPayload>;
};


export type MutationAcceptBundleArgs = {
  input: AcceptBundleInput;
};


export type MutationAgreeMsaArgs = {
  input: AgreeMsaInput;
};


export type MutationCheckVerificationSmsArgs = {
  input: CheckVerificationSmsInput;
};


export type MutationCreateInspectorOnboardingArgs = {
  input: CreateInspectorOnboardingInput;
};


export type MutationCreateItemAccessLogArgs = {
  input: CreateItemAccessLogInput;
};


export type MutationCreateRehabProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateRehabWorkItemArgs = {
  input: CreateWorkItemInput;
};


export type MutationCreateRehabWorkItemAssociationArgs = {
  input: CreateWorkItemAssociationInput;
};


export type MutationCreateRehabWorkItemAttachmentArgs = {
  input: CreateWorkItemAttachmentInput;
};


export type MutationCreateRehabWorkItemContributorArgs = {
  input: CreateWorkItemContributorInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateReportAsyncArgs = {
  input: CreateReportAsyncInput;
};


export type MutationCreateReportAttachmentArgs = {
  input: CreateReportAttachmentInput;
};


export type MutationCreateSurveyorOnboardingArgs = {
  input: CreateSurveyorOnboardingInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserPushTokenArgs = {
  input: CreateUserPushTokenInput;
};


export type MutationDeclineBundleArgs = {
  input: DeclineBundleInput;
};


export type MutationDeleteRehabWorkItemArgs = {
  input: DeleteWorkItemInput;
};


export type MutationDeleteRehabWorkItemAssociationArgs = {
  input: DeleteWorkItemAssociationInput;
};


export type MutationDeleteRehabWorkItemAttachmentArgs = {
  input: DeleteWorkItemAttachmentInput;
};


export type MutationDeleteRehabWorkItemContributorArgs = {
  input: DeleteWorkItemContributorInput;
};


export type MutationDeleteReportAttachmentArgs = {
  input: DeleteReportAttachmentInput;
};


export type MutationDeleteTeamCustomSystemArgs = {
  input: DeleteTeamCustomSystemInput;
};


export type MutationDeleteUserPushTokenArgs = {
  input: DeleteUserPushTokenInput;
};


export type MutationDirectUploadArgs = {
  input: DirectUploadInput;
};


export type MutationGenerateDrawReportCsvArgs = {
  input: GenerateDrawReportCsvInput;
};


export type MutationGeneratePdfReportArgs = {
  input: GeneratePdfReportInput;
};


export type MutationGeneratePhotoSphereImagesZipArgs = {
  input: GeneratePhotoSphereImagesZipInput;
};


export type MutationGeneratePropertyPermitPdfReportArgs = {
  input: GeneratePropertyPermitPdfReportInput;
};


export type MutationGenerateRehabProjectCsvArgs = {
  input: GenerateProjectCsvInput;
};


export type MutationGenerateRehabProjectPdfArgs = {
  input: GenerateProjectPdfInput;
};


export type MutationGenerateTipaltiIframeUrlArgs = {
  input: GenerateTipaltiIframeUrlInput;
};


export type MutationMarkUserAlertsAsViewedArgs = {
  input: MarkUserAlertsAsViewedInput;
};


export type MutationPopulateReportSystemsFromInspectionTemplatesArgs = {
  input: PopulateReportSystemsFromInspectionTemplatesInput;
};


export type MutationPopulateTeamCustomSystemArgs = {
  input: PopulateTeamCustomSystemInput;
};


export type MutationPublishAppraisalArgs = {
  input: PublishAppraisalInput;
};


export type MutationPublishRehabProjectArgs = {
  input: PublishProjectInput;
};


export type MutationPublishReportArgs = {
  input: PublishReportInput;
};


export type MutationReassignJobArgs = {
  input: ReassignJobInput;
};


export type MutationResendInviteArgs = {
  input: ResendInviteInput;
};


export type MutationRunFixMissingS3ObjectKeysOnReportAttachmentArgs = {
  input: RunFixMissingS3ObjectKeysOnReportAttachmentsInput;
};


export type MutationScheduleInternalInspectionArgs = {
  input: ScheduleInternalInspectionInput;
};


export type MutationSendTestNotificationArgs = {
  input: SendTestNotificationInput;
};


export type MutationSendVerificationSmsArgs = {
  input: SendVerificationSmsInput;
};


export type MutationSubmitFeedbackArgs = {
  input: SubmitFeedbackInput;
};


export type MutationSyncReportArgs = {
  input: SyncReportInput;
};


export type MutationTransformReportAttachmentArgs = {
  input: TransformReportAttachmentInput;
};


export type MutationUpdateContractorArgs = {
  input: UpdateContractorInput;
};


export type MutationUpdateFloorPlanLevelArgs = {
  input: UpdateFloorPlanLevelInput;
};


export type MutationUpdateInspectionScopeItemArgs = {
  input: UpdateInspectionScopeItemInput;
};


export type MutationUpdateInspectorOnboardingArgs = {
  input: UpdateInspectorOnboardingInput;
};


export type MutationUpdateRehabProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateRehabWorkItemArgs = {
  input: UpdateWorkItemInput;
};


export type MutationUpdateRehabWorkItemAssociationArgs = {
  input: UpdateWorkItemAssociationInput;
};


export type MutationUpdateRehabWorkItemAttachmentArgs = {
  input: UpdateWorkItemAttachmentInput;
};


export type MutationUpdateRehabWorkItemContributorArgs = {
  input: UpdateWorkItemContributorInput;
};


export type MutationUpdateReportApplianceInformationArgs = {
  input: UpdateReportApplianceInformationInput;
};


export type MutationUpdateSurveyorOnboardingArgs = {
  input: UpdateSurveyorOnboardingInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationWarrantyClaimArgs = {
  input: WarrantyClaimInput;
};


export type MutationWarrantyProveOwnershipArgs = {
  input: WarrantyProveOwnershipInput;
};

/** An error related to a record operation */
export type MutationError = {
  __typename?: 'MutationError';
  /** A code for the error */
  code: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Object changes for a Version record */
export type ObjectChangeType = {
  __typename?: 'ObjectChangeType';
  fieldName?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

/** A OrderStakeholder */
export type OrderStakeholderInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  stakeholderType: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** OrderStakeholderType */
export type OrderStakeholderType = Record & {
  __typename?: 'OrderStakeholderType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  isClient?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  stakeholderType: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** An order */
export type OrderType = Record & {
  __typename?: 'OrderType';
  accessInformation?: Maybe<Scalars['String']['output']>;
  /** Query related AccessInformationss with filters. */
  accessInformations: Array<AccessInformationType>;
  communityName?: Maybe<Scalars['String']['output']>;
  contingencyDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  earliestInspectionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  floorPlanName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  inspectionSchedulingDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Query related Inspections with filters. */
  inspections: Array<InspectionType>;
  inspectorInstructions?: Maybe<Scalars['String']['output']>;
  isAppointmentBased: Scalars['Boolean']['output'];
  isMock: Scalars['Boolean']['output'];
  isPaywall?: Maybe<Scalars['Boolean']['output']>;
  occupancyInfo?: Maybe<Scalars['String']['output']>;
  /** Query related OrderStakeholders with filters. */
  orderStakeholders: Array<OrderStakeholderType>;
  /** Query related OrderUnits with filters. */
  orderUnits: Array<OrderUnitType>;
  /** Associated Property. */
  property?: Maybe<PropertyType>;
  propertyId: Scalars['ID']['output'];
  readOnlyToken?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  /** Associated Team. */
  team?: Maybe<TeamType>;
  teamExternalId?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** An order unit */
export type OrderUnitType = Record & {
  __typename?: 'OrderUnitType';
  /** Query related AccessInformationss with filters. */
  accessInformations: Array<AccessInformationType>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Contains the password and password confirmation for a newly onboarded user */
export type PasswordSetInput = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

/** A Property Permit Contractor */
export type PermitContractorType = Record & {
  __typename?: 'PermitContractorType';
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  license?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Query related Permits with filters. */
  permits: Array<PermitType>;
  phone?: Maybe<Scalars['String']['output']>;
  shovelsContractorId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNo?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

/** A Property Permit */
export type PermitType = Record & {
  __typename?: 'PermitType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Scalars['String']['output']>;
  fileDate?: Maybe<Scalars['String']['output']>;
  finalDate?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  issueDate?: Maybe<Scalars['String']['output']>;
  jobValue?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  /** Associated PermitContractor. */
  permitContractor?: Maybe<PermitContractorType>;
  permitContractorId?: Maybe<Scalars['String']['output']>;
  permitSubtype?: Maybe<Scalars['String']['output']>;
  permitType?: Maybe<Scalars['String']['output']>;
  /** Associated Property. */
  property?: Maybe<PropertyType>;
  shovelsContractorId?: Maybe<Scalars['String']['output']>;
  shovelsPermitId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A health check to ping the marketplace backend */
export type PingType = {
  __typename?: 'PingType';
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of PopulateReportSystemsFromInspectionTemplates */
export type PopulateReportSystemsFromInspectionTemplatesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};

/** Autogenerated return type of PopulateReportSystemsFromInspectionTemplates. */
export type PopulateReportSystemsFromInspectionTemplatesPayload = {
  __typename?: 'PopulateReportSystemsFromInspectionTemplatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  report: ReportType;
};

/** Autogenerated input type of PopulateTeamCustomSystem */
export type PopulateTeamCustomSystemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subsystemNames?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId: Scalars['ID']['input'];
};

/** Autogenerated return type of PopulateTeamCustomSystem. */
export type PopulateTeamCustomSystemPayload = {
  __typename?: 'PopulateTeamCustomSystemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  populateTeamCustomSystem?: Maybe<TeamCustomSystemType>;
};

/** Rehab Project history */
export type ProjectHistoryType = Record & {
  __typename?: 'ProjectHistoryType';
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  itemId?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  objectChanges?: Maybe<Array<ObjectChangeType>>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  user?: Maybe<UserType>;
};

/** The connection type for ProjectHistoryType. */
export type ProjectHistoryTypeConnection = {
  __typename?: 'ProjectHistoryTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectHistoryTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectHistoryType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProjectHistoryTypeEdge = {
  __typename?: 'ProjectHistoryTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectHistoryType>;
};

/** A single rehab project */
export type ProjectType = Record & {
  __typename?: 'ProjectType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  inspectionDocumentId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  /** Associated Property. */
  property?: Maybe<PropertyType>;
  propertyId?: Maybe<Scalars['ID']['output']>;
  publishedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Associated Report. */
  report?: Maybe<ReportType>;
  reportId?: Maybe<Scalars['ID']['output']>;
  /** Associated Team. */
  team?: Maybe<TeamType>;
  teamId?: Maybe<Scalars['ID']['output']>;
  teamMarketId?: Maybe<Scalars['ID']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Query related WorkItems with filters. */
  workItems: Array<WorkItemType>;
};

/** The connection type for ProjectType. */
export type ProjectTypeConnection = {
  __typename?: 'ProjectTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProjectTypeEdge = {
  __typename?: 'ProjectTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectType>;
};

/** An Property */
export type PropertyType = Record & {
  __typename?: 'PropertyType';
  address: Scalars['String']['output'];
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  homeType?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Query related Permits with filters. */
  permits: Array<PermitType>;
  /** Attached Photo. */
  photo?: Maybe<ActiveStorageBlob>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  totalSquareFeet?: Maybe<Scalars['Int']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  yearBuilt?: Maybe<Scalars['Int']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PublishAppraisal */
export type PublishAppraisalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderToken: Scalars['String']['input'];
  presignedUrl: Scalars['String']['input'];
  toolkitOrderId: Scalars['String']['input'];
};

/** Autogenerated return type of PublishAppraisal. */
export type PublishAppraisalPayload = {
  __typename?: 'PublishAppraisalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
};

/** Autogenerated input type of PublishProject */
export type PublishProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishProject. */
export type PublishProjectPayload = {
  __typename?: 'PublishProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  project?: Maybe<ProjectType>;
};

/** Autogenerated input type of PublishReport */
export type PublishReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishReport. */
export type PublishReportPayload = {
  __typename?: 'PublishReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  report: ReportType;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve Appliance Sub types from Source7 */
  applianceProductTypes: Array<ApplianceProductType>;
  /** Retrieve all users for account */
  availableUsers: Array<UserType>;
  /** Check the status of a background job */
  backgroundJobStatus?: Maybe<BackgroundJobStatusType>;
  /** Query BankCatalogDeficiencies with filters. */
  bankCatalogDeficiencies: CatalogDeficiencyTypeConnection;
  /** Find BankCatalogDeficiency. */
  bankCatalogDeficiency?: Maybe<CatalogDeficiencyType>;
  /** Find BankCatalogLimitation. */
  bankCatalogLimitation?: Maybe<CatalogLimitationType>;
  /** Query BankCatalogLimitations with filters. */
  bankCatalogLimitations: CatalogLimitationTypeConnection;
  /** Find BankCatalogLocationType. */
  bankCatalogLocationType?: Maybe<CatalogLocationTypeType>;
  /** Query BankCatalogLocationTypes with filters. */
  bankCatalogLocationTypes: CatalogLocationTypeTypeConnection;
  /** Find BaseCatalogSystemsForCatalogSystem. */
  baseCatalogSystemsForCatalogSystem?: Maybe<BaseCatalogSystemsForCatalogSystemType>;
  /** Query BaseCatalogSystemsForCatalogSystems with filters. */
  baseCatalogSystemsForCatalogSystems: BaseCatalogSystemsForCatalogSystemTypeConnection;
  /** Find BundleOffer. */
  bundleOffer?: Maybe<BundleOffer>;
  /** Query BundleOffers with filters. */
  bundleOffers: BundleOfferConnection;
  /** Find CatalogSubsystem. */
  catalogSubsystem?: Maybe<CatalogSubsystemType>;
  /** Query CatalogSubsystems with filters. */
  catalogSubsystems: CatalogSubsystemTypeConnection;
  /** Find CatalogSystem. */
  catalogSystem?: Maybe<CatalogSystemType>;
  /** Query CatalogSystems with filters. */
  catalogSystems: CatalogSystemTypeConnection;
  /** Retrieve commonly used deficiencies by template subsystem */
  commonlyUsedDeficiencies: Array<CommonlyUsedDeficienciesType>;
  /** Find Contractor. */
  contractor?: Maybe<ContractorType>;
  /** Check if allowed to create a user using the contractor token */
  contractorAllowInitialUserCreation: IsAllowedType;
  /** Returns Metabase URLs that can be used to embed an iframe to show the Contractor report cards */
  contractorScorecard: ContractorScorecardType;
  /** Query Contractors with filters. */
  contractors: ContractorTypeConnection;
  /** Retrieve the current user */
  currentUser?: Maybe<UserType>;
  /** Retrieve TemplateReport based on the Draw CSV attached to the inspection */
  drawSowTemplateReport: TemplateReportType;
  /** Find InspectionScopeItem. */
  inspectionScopeItem?: Maybe<InspectionScopeItemType>;
  /** Query InspectionScopeItems with filters. */
  inspectionScopeItems: InspectionScopeItemTypeConnection;
  /** Find InspectorOnboarding. */
  inspectorOnboarding?: Maybe<InspectorOnboardingType>;
  /** Query InspectorOnboardings with filters. */
  inspectorOnboardings: InspectorOnboardingTypeConnection;
  /** Retrieve jobs for an inspector */
  jobs?: Maybe<JobTypeConnection>;
  /** Retrieve order by order token or read only token */
  orderByToken?: Maybe<OrderType>;
  /** Check if the backend is online */
  ping: PingType;
  /** Retrieve object changes for a rehab project's work items */
  projectHistory: ProjectHistoryTypeConnection;
  /** Find RehabProject. */
  rehabProject?: Maybe<ProjectType>;
  /** Query RehabProjects with filters. */
  rehabProjects: ProjectTypeConnection;
  /** Find Report. */
  report?: Maybe<ReportType>;
  /** Query Reports with filters. */
  reports: ReportTypeConnection;
  /** Find SurveyorOnboarding. */
  surveyorOnboarding?: Maybe<SurveyorOnboardingType>;
  /** Query SurveyorOnboardings with filters. */
  surveyorOnboardings: SurveyorOnboardingTypeConnection;
  /** Find TemplateReport. */
  templateReport?: Maybe<TemplateReportType>;
  /** Find TemplateReportEstimatedDuration. */
  templateReportEstimatedDuration?: Maybe<TemplateReportEstimatedDurationType>;
  /** Query TemplateReportEstimatedDurations with filters. */
  templateReportEstimatedDurations: TemplateReportEstimatedDurationTypeConnection;
  /** Query TemplateReports with filters. */
  templateReports: TemplateReportTypeConnection;
  /** Find TemplateWorkItem. */
  templateWorkItem?: Maybe<TemplateWorkItemType>;
  /** Query TemplateWorkItems with filters. */
  templateWorkItems: TemplateWorkItemTypeConnection;
  /** Find User. */
  user?: Maybe<UserType>;
  /** Find UserAlert. */
  userAlert?: Maybe<UserAlertType>;
  /** Query UserAlerts with filters. */
  userAlerts: UserAlertTypeConnection;
  /** Query Users with filters. */
  users: UserTypeConnection;
};


export type QueryAvailableUsersArgs = {
  onlyContractors: Scalars['Boolean']['input'];
};


export type QueryBackgroundJobStatusArgs = {
  backgroundJobId: Scalars['ID']['input'];
};


export type QueryBankCatalogDeficienciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  catalogSystemId?: InputMaybe<Scalars['ID']['input']>;
  catalogSystemIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  catalogSystemIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  detail?: InputMaybe<Scalars['String']['input']>;
  detailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  detailNin?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  keywordsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  keywordsNin?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  severityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  severityNin?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  teamIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleNin?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryBankCatalogDeficiencyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankCatalogLimitationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankCatalogLimitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  catalogSystemId?: InputMaybe<Scalars['ID']['input']>;
  catalogSystemIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  catalogSystemIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  detail?: InputMaybe<Scalars['String']['input']>;
  detailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  detailNin?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  keywordsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  keywordsNin?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  teamIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleNin?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryBankCatalogLocationTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankCatalogLocationTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  groupNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  groupNameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryBaseCatalogSystemsForCatalogSystemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBaseCatalogSystemsForCatalogSystemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  catalogSystemId?: InputMaybe<Scalars['ID']['input']>;
  catalogSystemIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  catalogSystemIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryBundleOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBundleOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  bundleIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  bundleIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractorId?: InputMaybe<Scalars['String']['input']>;
  contractorIdIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contractorIdNin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusNin?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryCatalogSubsystemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCatalogSubsystemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryCatalogSystemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCatalogSystemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryCommonlyUsedDeficienciesArgs = {
  templateReportId: Scalars['ID']['input'];
};


export type QueryContractorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractorAllowInitialUserCreationArgs = {
  contractorToken: Scalars['String']['input'];
};


export type QueryContractorScorecardArgs = {
  endDate: Scalars['UnixTimestamp']['input'];
  startDate: Scalars['UnixTimestamp']['input'];
};


export type QueryContractorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ashiLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  ashiLicenseNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ashiLicenseNumberNin?: InputMaybe<Array<Scalars['String']['input']>>;
  automatedSchedulingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  businessAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  businessAddressNin?: InputMaybe<Array<Scalars['String']['input']>>;
  businessContactName?: InputMaybe<Scalars['String']['input']>;
  businessContactNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  businessContactNameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  businessEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  businessEmailNin?: InputMaybe<Array<Scalars['String']['input']>>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  businessNameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  businessPhoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  businessPhoneNin?: InputMaybe<Array<Scalars['String']['input']>>;
  businessSite?: InputMaybe<Scalars['String']['input']>;
  businessSiteIn?: InputMaybe<Array<Scalars['String']['input']>>;
  businessSiteNin?: InputMaybe<Array<Scalars['String']['input']>>;
  businessZipCode?: InputMaybe<Scalars['String']['input']>;
  businessZipCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  businessZipCodeNin?: InputMaybe<Array<Scalars['String']['input']>>;
  certifications?: InputMaybe<Scalars['String']['input']>;
  certificationsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  certificationsNin?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityNin?: InputMaybe<Array<Scalars['String']['input']>>;
  communicationPreference?: InputMaybe<Scalars['String']['input']>;
  communicationPreferenceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  communicationPreferenceNin?: InputMaybe<Array<Scalars['String']['input']>>;
  contractorLicenseHeld?: InputMaybe<Scalars['Boolean']['input']>;
  contractorType?: InputMaybe<Scalars['String']['input']>;
  contractorTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contractorTypeNin?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryNin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  employeeCount?: InputMaybe<Scalars['Int']['input']>;
  employeeCountGt?: InputMaybe<Scalars['Int']['input']>;
  employeeCountGte?: InputMaybe<Scalars['Int']['input']>;
  employeeCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  employeeCountLt?: InputMaybe<Scalars['Int']['input']>;
  employeeCountLte?: InputMaybe<Scalars['Int']['input']>;
  employeeCountNin?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasSentrilock?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupra?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  inBusinessSince?: InputMaybe<Scalars['Int']['input']>;
  inBusinessSinceGt?: InputMaybe<Scalars['Int']['input']>;
  inBusinessSinceGte?: InputMaybe<Scalars['Int']['input']>;
  inBusinessSinceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  inBusinessSinceLt?: InputMaybe<Scalars['Int']['input']>;
  inBusinessSinceLte?: InputMaybe<Scalars['Int']['input']>;
  inBusinessSinceNin?: InputMaybe<Array<Scalars['Int']['input']>>;
  inspectorLicenseHeld?: InputMaybe<Scalars['Boolean']['input']>;
  instantBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  internachiLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  internachiLicenseNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  internachiLicenseNumberNin?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  latitudeGt?: InputMaybe<Scalars['Float']['input']>;
  latitudeGte?: InputMaybe<Scalars['Float']['input']>;
  latitudeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  latitudeLt?: InputMaybe<Scalars['Float']['input']>;
  latitudeLte?: InputMaybe<Scalars['Float']['input']>;
  latitudeNin?: InputMaybe<Array<Scalars['Float']['input']>>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  longitudeGt?: InputMaybe<Scalars['Float']['input']>;
  longitudeGte?: InputMaybe<Scalars['Float']['input']>;
  longitudeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  longitudeLt?: InputMaybe<Scalars['Float']['input']>;
  longitudeLte?: InputMaybe<Scalars['Float']['input']>;
  longitudeNin?: InputMaybe<Array<Scalars['Float']['input']>>;
  otherLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  otherLicenseNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  otherLicenseNumberNin?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredInspectorStatus?: InputMaybe<Scalars['String']['input']>;
  preferredInspectorStatusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredInspectorStatusNin?: InputMaybe<Array<Scalars['String']['input']>>;
  realEstateLicenseHeld?: InputMaybe<Scalars['Boolean']['input']>;
  reportWritingSoftware?: InputMaybe<Scalars['String']['input']>;
  reportWritingSoftwareIn?: InputMaybe<Array<Scalars['String']['input']>>;
  reportWritingSoftwareNin?: InputMaybe<Array<Scalars['String']['input']>>;
  schedulerEmail?: InputMaybe<Scalars['String']['input']>;
  schedulerEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  schedulerEmailNin?: InputMaybe<Array<Scalars['String']['input']>>;
  schedulerName?: InputMaybe<Scalars['String']['input']>;
  schedulerNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  schedulerNameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  schedulerPhone?: InputMaybe<Scalars['String']['input']>;
  schedulerPhoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  schedulerPhoneNin?: InputMaybe<Array<Scalars['String']['input']>>;
  sendAutomatedSms?: InputMaybe<Scalars['Boolean']['input']>;
  serviceAreaRadiusMileage?: InputMaybe<Scalars['Int']['input']>;
  serviceAreaRadiusMileageGt?: InputMaybe<Scalars['Int']['input']>;
  serviceAreaRadiusMileageGte?: InputMaybe<Scalars['Int']['input']>;
  serviceAreaRadiusMileageIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  serviceAreaRadiusMileageLt?: InputMaybe<Scalars['Int']['input']>;
  serviceAreaRadiusMileageLte?: InputMaybe<Scalars['Int']['input']>;
  serviceAreaRadiusMileageNin?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  stateLicenseNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateLicenseNumberNin?: InputMaybe<Array<Scalars['String']['input']>>;
  stateNin?: InputMaybe<Array<Scalars['String']['input']>>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetIn?: InputMaybe<Array<Scalars['String']['input']>>;
  streetNin?: InputMaybe<Array<Scalars['String']['input']>>;
  tipaltiIsPayable?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenNin?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryDrawSowTemplateReportArgs = {
  inspectionId: Scalars['ID']['input'];
};


export type QueryInspectionScopeItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInspectionScopeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  budgetGt?: InputMaybe<Scalars['Float']['input']>;
  budgetGte?: InputMaybe<Scalars['Float']['input']>;
  budgetIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  budgetLt?: InputMaybe<Scalars['Float']['input']>;
  budgetLte?: InputMaybe<Scalars['Float']['input']>;
  budgetNin?: InputMaybe<Array<Scalars['Float']['input']>>;
  clientDisbursement?: InputMaybe<Scalars['Float']['input']>;
  clientDisbursementGt?: InputMaybe<Scalars['Float']['input']>;
  clientDisbursementGte?: InputMaybe<Scalars['Float']['input']>;
  clientDisbursementIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  clientDisbursementLt?: InputMaybe<Scalars['Float']['input']>;
  clientDisbursementLte?: InputMaybe<Scalars['Float']['input']>;
  clientDisbursementNin?: InputMaybe<Array<Scalars['Float']['input']>>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNin?: InputMaybe<Array<Scalars['String']['input']>>;
  disbursement?: InputMaybe<Scalars['Float']['input']>;
  disbursementGt?: InputMaybe<Scalars['Float']['input']>;
  disbursementGte?: InputMaybe<Scalars['Float']['input']>;
  disbursementIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  disbursementLt?: InputMaybe<Scalars['Float']['input']>;
  disbursementLte?: InputMaybe<Scalars['Float']['input']>;
  disbursementNin?: InputMaybe<Array<Scalars['Float']['input']>>;
  displayIndex?: InputMaybe<Scalars['Int']['input']>;
  displayIndexGt?: InputMaybe<Scalars['Int']['input']>;
  displayIndexGte?: InputMaybe<Scalars['Int']['input']>;
  displayIndexIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  displayIndexLt?: InputMaybe<Scalars['Int']['input']>;
  displayIndexLte?: InputMaybe<Scalars['Int']['input']>;
  displayIndexNin?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  inspectionId?: InputMaybe<Scalars['ID']['input']>;
  inspectionIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  inspectionIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  orderUnitId?: InputMaybe<Scalars['String']['input']>;
  orderUnitIdIn?: InputMaybe<Array<Scalars['String']['input']>>;
  orderUnitIdNin?: InputMaybe<Array<Scalars['String']['input']>>;
  previousDisbursement?: InputMaybe<Scalars['Float']['input']>;
  previousDisbursementGt?: InputMaybe<Scalars['Float']['input']>;
  previousDisbursementGte?: InputMaybe<Scalars['Float']['input']>;
  previousDisbursementIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  previousDisbursementLt?: InputMaybe<Scalars['Float']['input']>;
  previousDisbursementLte?: InputMaybe<Scalars['Float']['input']>;
  previousDisbursementNin?: InputMaybe<Array<Scalars['Float']['input']>>;
  progress?: InputMaybe<Scalars['Float']['input']>;
  progressGt?: InputMaybe<Scalars['Float']['input']>;
  progressGte?: InputMaybe<Scalars['Float']['input']>;
  progressIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  progressLt?: InputMaybe<Scalars['Float']['input']>;
  progressLte?: InputMaybe<Scalars['Float']['input']>;
  progressNin?: InputMaybe<Array<Scalars['Float']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['JsonAsString']['input']>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryInspectorOnboardingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInspectorOnboardingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  completedStep?: InputMaybe<Scalars['String']['input']>;
  completedStepIn?: InputMaybe<Array<Scalars['String']['input']>>;
  completedStepNin?: InputMaybe<Array<Scalars['String']['input']>>;
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  contractorIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractorIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  isMultiInspectorFirm?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onboardingTrackerDismissedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  onboardingTrackerDismissedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  onboardingTrackerDismissedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  onboardingTrackerDismissedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  onboardingTrackerDismissedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  onboardingTrackerDismissedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  onboardingTrackerDismissedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusNin?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeAllGoAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  isFee?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scheduledOnGte?: InputMaybe<Scalars['ISO8601Date']['input']>;
  scheduledOnLte?: InputMaybe<Scalars['ISO8601Date']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobStatus>;
};


export type QueryOrderByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryProjectHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryRehabProjectArgs = {
  id: Scalars['ID']['input'];
  resizedAttachmentWidths?: InputMaybe<Array<Scalars['Int']['input']>>;
  rotatedAttachmentDegrees?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryRehabProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  inspectionDocumentId?: InputMaybe<Scalars['ID']['input']>;
  inspectionDocumentIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  inspectionDocumentIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
  propertyIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  propertyIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  publishedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  publishedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  publishedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  publishedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  publishedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  publishedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  publishedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  reportIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  reportIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  resizedAttachmentWidths?: InputMaybe<Array<Scalars['Int']['input']>>;
  rotatedAttachmentDegrees?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  teamIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamMarketId?: InputMaybe<Scalars['ID']['input']>;
  teamMarketIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamMarketIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryReportArgs = {
  id: Scalars['ID']['input'];
  resizedAttachmentWidths?: InputMaybe<Array<Scalars['Int']['input']>>;
  rotatedAttachmentDegrees?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  autoDeficiencyLocationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  complianceText?: InputMaybe<Scalars['String']['input']>;
  complianceTextIn?: InputMaybe<Array<Scalars['String']['input']>>;
  complianceTextNin?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  geotaggingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeDrawDisbursementFields?: InputMaybe<Scalars['Boolean']['input']>;
  includePermitData?: InputMaybe<Scalars['Boolean']['input']>;
  includeWideAnglePhotos?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noDeficienciesAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  noLimitationsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  orderIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  originalReportId?: InputMaybe<Scalars['ID']['input']>;
  originalReportIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  originalReportIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  publishedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  publishedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  publishedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  publishedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  publishedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  publishedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  publishedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  resizedAttachmentWidths?: InputMaybe<Array<Scalars['Int']['input']>>;
  rotatedAttachmentDegrees?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  startedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  startedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  startedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  startedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  startedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  startedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  videoCaptureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySurveyorOnboardingArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySurveyorOnboardingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  backgroundCheckRequired?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundCheckSubmittedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  backgroundCheckSubmittedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  backgroundCheckSubmittedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  backgroundCheckSubmittedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  backgroundCheckSubmittedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  backgroundCheckSubmittedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  backgroundCheckSubmittedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  completedStep?: InputMaybe<Scalars['String']['input']>;
  completedStepIn?: InputMaybe<Array<Scalars['String']['input']>>;
  completedStepNin?: InputMaybe<Array<Scalars['String']['input']>>;
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  contractorIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractorIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onboardingTrackerDismissedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  onboardingTrackerDismissedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  onboardingTrackerDismissedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  onboardingTrackerDismissedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  onboardingTrackerDismissedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  onboardingTrackerDismissedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  onboardingTrackerDismissedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusNin?: InputMaybe<Array<Scalars['String']['input']>>;
  submitBackgroundCheckUrl?: InputMaybe<Scalars['String']['input']>;
  submitBackgroundCheckUrlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  submitBackgroundCheckUrlNin?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryTemplateReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemplateReportEstimatedDurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemplateReportEstimatedDurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplateReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  autoDeficiencyLocationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  baseTemplateReportId?: InputMaybe<Scalars['ID']['input']>;
  baseTemplateReportIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseTemplateReportIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNin?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  inspectionType?: InputMaybe<Scalars['String']['input']>;
  inspectionTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  inspectionTypeNin?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  noDeficienciesAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  noLimitationsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  reInspectionTemplateReportId?: InputMaybe<Scalars['ID']['input']>;
  reInspectionTemplateReportIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  reInspectionTemplateReportIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryTemplateWorkItemArgs = {
  id: Scalars['ID']['input'];
  marketId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTemplateWorkItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  systemName?: InputMaybe<Scalars['String']['input']>;
  systemNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  systemNameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  teamIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleNin?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserAlertArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserAlertsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryUsersArgs = {
  activatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  activatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  activatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  activatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  activatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  activatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  activatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  archivedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  archivedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  archivedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  archivedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  archivedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  archivedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  contractorIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractorIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  createdAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  createdAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNin?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNin?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumberNin?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  teamAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  teamIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIdNin?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtGte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
  updatedAtLt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtLte?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAtNin?: InputMaybe<Array<Scalars['UnixTimestamp']['input']>>;
};

/** Autogenerated input type of ReassignJob */
export type ReassignJobInput = {
  assignUserIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReassignJob. */
export type ReassignJobPayload = {
  __typename?: 'ReassignJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  job: JobType;
};

export type Record = {
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A ReportApplianceInformation */
export type ReportApplianceInformationType = Record & {
  __typename?: 'ReportApplianceInformationType';
  age?: Maybe<Scalars['Float']['output']>;
  brandId?: Maybe<Scalars['Int']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  expectedLife?: Maybe<Scalars['Float']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  modelNumber?: Maybe<Scalars['String']['output']>;
  monthManufactured?: Maybe<Scalars['Int']['output']>;
  possibleYearsManufactured?: Maybe<Array<Scalars['Int']['output']>>;
  productFailureRiskScore?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  recalls?: Maybe<Array<Scalars['String']['output']>>;
  remainingLife?: Maybe<Scalars['Float']['output']>;
  /** Query related ReportAttachments with filters. */
  reportAttachments: Array<ReportAttachmentType>;
  reportId: Scalars['ID']['output'];
  reportInformationId: Scalars['ID']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
  /** Valid values: pending_data, source7_ready, source7_retrieved, source7_verified, inspector_skipped, inspector_verified, inspectify_fixed */
  status?: Maybe<Scalars['String']['output']>;
  subProductId?: Maybe<Scalars['Int']['output']>;
  subProductName?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  warrantyCovered?: Maybe<Scalars['Boolean']['output']>;
  yearManufactured?: Maybe<Scalars['Int']['output']>;
};

/** A ReportAttachment */
export type ReportAttachmentType = Record & {
  __typename?: 'ReportAttachmentType';
  attachmentUrl?: Maybe<Scalars['String']['output']>;
  compressedAttachmentUrl?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  itemId?: Maybe<Scalars['ID']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  longLiveUrl?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JsonAsString']['output'];
  /** Query related ReportAttachments with filters. */
  reportAttachments: Array<ReportAttachmentType>;
  reportId: Scalars['ID']['output'];
  reportSystemGroupId?: Maybe<Scalars['ID']['output']>;
  resizedUrls: Array<ResizedUrlType>;
  rotatedUrls: Array<RotatedUrlType>;
  s3ObjectKey?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A ReportDeficiencyInformation */
export type ReportDeficiencyInformationType = Record & {
  __typename?: 'ReportDeficiencyInformationType';
  allowsOther: Scalars['Boolean']['output'];
  cannotAnswer?: Maybe<Scalars['Boolean']['output']>;
  catalogDeficiencyInformationId: Scalars['ID']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  dataName: Scalars['String']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  isMultiSelect: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  questionType: Scalars['String']['output'];
  /** Query related ReportAttachments with filters. */
  reportAttachments: Array<ReportAttachmentType>;
  reportDeficiencyId: Scalars['ID']['output'];
  /** Query related ReportLocations with filters. */
  reportLocations: Array<ReportLocationType>;
  requiresLocations: Scalars['Boolean']['output'];
  requiresMedias: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  units?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** A ReportDeficiency */
export type ReportDeficiencyType = Record & {
  __typename?: 'ReportDeficiencyType';
  catalogDeficiencyId?: Maybe<Scalars['ID']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Associated OriginalReportDeficiency. */
  originalReportDeficiency?: Maybe<ReportDeficiencyType>;
  originalReportDeficiencyId?: Maybe<Scalars['ID']['output']>;
  reInspectionStatus?: Maybe<Scalars['String']['output']>;
  recommendationDescription?: Maybe<Scalars['String']['output']>;
  recommendationTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Query related ReportAttachments with filters. */
  reportAttachments: Array<ReportAttachmentType>;
  /** Query related ReportDeficiencyInformationss with filters. */
  reportDeficiencyInformations: Array<ReportDeficiencyInformationType>;
  reportInformationId?: Maybe<Scalars['ID']['output']>;
  /** Query related ReportLocations with filters. */
  reportLocations: Array<ReportLocationType>;
  reportSubsystemId: Scalars['ID']['output'];
  severity: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

export enum ReportInformationCannotAnswerReason {
  NoAccess = 'no_access',
  NotPresent = 'not_present',
  Other = 'other'
}

export enum ReportInformationStatus {
  /** The inspector could not answer the question */
  CannotAnswer = 'cannot_answer',
  /** The inspector has answered this question */
  Completed = 'completed',
  /** The inspector has not answered this question */
  Incomplete = 'incomplete'
}

/** A ReportInformation */
export type ReportInformationType = Record & {
  __typename?: 'ReportInformationType';
  allowsOther: Scalars['Boolean']['output'];
  /** @deprecated Replaced by status: cannot_answer */
  cannotAnswer?: Maybe<Scalars['Boolean']['output']>;
  cannotAnswerReason?: Maybe<ReportInformationCannotAnswerReason>;
  /** Associated CatalogInformation. */
  catalogInformation?: Maybe<CatalogInformationType>;
  catalogInformationId: Scalars['ID']['output'];
  conditionalFollowupLogic?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  dataName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  displayIndex: Scalars['Int']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  inspectionScopeItemId?: Maybe<Scalars['ID']['output']>;
  isMultiSelect: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  previousInspectionReportInformation?: Maybe<ReportInformationType>;
  questionType: Scalars['String']['output'];
  /** Associated ReportApplianceInformation. */
  reportApplianceInformation?: Maybe<ReportApplianceInformationType>;
  /** Query related ReportApplianceInformationss with filters. */
  reportApplianceInformations: Array<ReportApplianceInformationType>;
  /** Query related ReportAttachments with filters. */
  reportAttachments: Array<ReportAttachmentType>;
  /** Query related ReportDeficiencies with filters. */
  reportDeficiencies: Array<ReportDeficiencyType>;
  reportLimitationId?: Maybe<Scalars['ID']['output']>;
  /** Query related ReportLimitations with filters. */
  reportLimitations: Array<ReportLimitationType>;
  /** Query related ReportLocations with filters. */
  reportLocations: Array<ReportLocationType>;
  reportSubsystemId: Scalars['ID']['output'];
  requiresDeficiencyCatalogDeficiencyId?: Maybe<Scalars['ID']['output']>;
  requiresDeficiencyCondition?: Maybe<Scalars['JsonAsString']['output']>;
  requiresLimitationCondition?: Maybe<Scalars['JsonAsString']['output']>;
  requiresLocations: Scalars['Boolean']['output'];
  /** Valid values: any_orientation, portrait, landscape */
  requiresMediaOrientation: Scalars['String']['output'];
  /** Valid values: any_media_type, video, photo, photo_sphere */
  requiresMediaType: Scalars['String']['output'];
  requiresMedias: Scalars['Int']['output'];
  status: ReportInformationStatus;
  tags?: Maybe<Scalars['JsonAsString']['output']>;
  title: Scalars['String']['output'];
  units?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** A Report */
export type ReportInput = {
  id: Scalars['ID']['input'];
  startedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  updatedAt: Scalars['UnixTimestamp']['input'];
};

/** A ReportLimitation */
export type ReportLimitationType = Record & {
  __typename?: 'ReportLimitationType';
  catalogLimitationId?: Maybe<Scalars['ID']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Query related ReportAttachments with filters. */
  reportAttachments: Array<ReportAttachmentType>;
  reportInformationId?: Maybe<Scalars['ID']['output']>;
  /** Query related ReportLocations with filters. */
  reportLocations: Array<ReportLocationType>;
  reportSubsystemId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A ReportLocation */
export type ReportLocationType = Record & {
  __typename?: 'ReportLocationType';
  catalogLocationTypeId: Scalars['ID']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  groupName: Scalars['String']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  itemId?: Maybe<Scalars['ID']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  reportId: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A ReportSubsystem */
export type ReportSubsystemType = Record & {
  __typename?: 'ReportSubsystemType';
  catalogSubsystemId: Scalars['ID']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  disableNotPresent?: Maybe<Scalars['Boolean']['output']>;
  displayIndex?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  includeOnReport: Scalars['Boolean']['output'];
  includeOnReportIfNotPresent?: Maybe<Scalars['Boolean']['output']>;
  multiUseSubsystemName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Query related ReportAttachments with filters. */
  reportAttachments: Array<ReportAttachmentType>;
  /** Query related ReportDeficiencies with filters. */
  reportDeficiencies: Array<ReportDeficiencyType>;
  /** Query related ReportInformationss with filters. */
  reportInformations: Array<ReportInformationType>;
  /** Query related ReportLimitations with filters. */
  reportLimitations: Array<ReportLimitationType>;
  reportSystemId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  templateSubsystemIds: Array<Scalars['ID']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A ReportSystemGroup */
export type ReportSystemGroupType = Record & {
  __typename?: 'ReportSystemGroupType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reportId: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A ReportSystem */
export type ReportSystemType = Record & {
  __typename?: 'ReportSystemType';
  catalogSystemId: Scalars['ID']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  displayIndex?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  includeOnReport: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Query related ReportAttachments with filters. */
  reportAttachments: Array<ReportAttachmentType>;
  reportId: Scalars['ID']['output'];
  /** Query related ReportSubsystems with filters. */
  reportSubsystems: Array<ReportSubsystemType>;
  reportSystemGroupId?: Maybe<Scalars['ID']['output']>;
  standardText?: Maybe<Scalars['String']['output']>;
  templateSystemIds: Array<Scalars['ID']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A Report */
export type ReportType = Record & {
  __typename?: 'ReportType';
  autoDeficiencyLocationRequired: Scalars['Boolean']['output'];
  complianceText?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  geotaggingRequired: Scalars['Boolean']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Will include draw disbursement fields in the inspection report */
  includeDrawDisbursementFields: Scalars['Boolean']['output'];
  /** Include Permit Data in the Inspection Report */
  includePermitData: Scalars['Boolean']['output'];
  /** Require Wide Angle Photos in the Inspection Report for deficiencies */
  includeWideAnglePhotos: Scalars['Boolean']['output'];
  /** Query related InspectionDocuments with filters. */
  inspectionDocuments: Array<InspectionDocumentType>;
  /** Query related InspectionReports with filters. */
  inspectionReports: Array<InspectionReportType>;
  noDeficienciesAllowed: Scalars['Boolean']['output'];
  noLimitationsAllowed: Scalars['Boolean']['output'];
  orderId?: Maybe<Scalars['ID']['output']>;
  /** Associated OriginalReport. */
  originalReport?: Maybe<ReportType>;
  originalReportId?: Maybe<Scalars['ID']['output']>;
  pdfDocumentUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Query related ReportApplianceInformationss with filters. */
  reportApplianceInformations: Array<ReportApplianceInformationType>;
  /** Query related ReportAttachments with filters. */
  reportAttachments: Array<ReportAttachmentType>;
  /** Query related ReportLocations with filters. */
  reportLocations: Array<ReportLocationType>;
  /** Query related ReportSystemGroups with filters. */
  reportSystemGroups: Array<ReportSystemGroupType>;
  /** Query related ReportSystems with filters. */
  reportSystems: Array<ReportSystemType>;
  startedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  templateNames: Array<Scalars['String']['output']>;
  templateReportIds: Array<Scalars['ID']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  videoCaptureEnabled: Scalars['Boolean']['output'];
};

/** The connection type for ReportType. */
export type ReportTypeConnection = {
  __typename?: 'ReportTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReportTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReportType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ReportTypeEdge = {
  __typename?: 'ReportTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ReportType>;
};

/** Autogenerated input type of ResendInvite */
export type ResendInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ResendInvite. */
export type ResendInvitePayload = {
  __typename?: 'ResendInvitePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  user?: Maybe<UserType>;
};

/** A ResizedUrlType */
export type ResizedUrlType = {
  __typename?: 'ResizedUrlType';
  url: Scalars['String']['output'];
  width: Scalars['ID']['output'];
};

/** A RotatedUrl */
export type RotatedUrlType = {
  __typename?: 'RotatedUrlType';
  degree: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of RunFixMissingS3ObjectKeysOnReportAttachments */
export type RunFixMissingS3ObjectKeysOnReportAttachmentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RunFixMissingS3ObjectKeysOnReportAttachments. */
export type RunFixMissingS3ObjectKeysOnReportAttachmentsPayload = {
  __typename?: 'RunFixMissingS3ObjectKeysOnReportAttachmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
};

/** Autogenerated input type of ScheduleInternalInspection */
export type ScheduleInternalInspectionInput = {
  address: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Contractor Id to schedule, else name/email/phone should be provided */
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  contractorName?: InputMaybe<Scalars['String']['input']>;
  contractorPhone?: InputMaybe<Scalars['String']['input']>;
  inspectionType?: InputMaybe<Scalars['String']['input']>;
  isGoAnytime?: InputMaybe<Scalars['Boolean']['input']>;
  orderStakeholders?: InputMaybe<Array<OrderStakeholderInput>>;
  scheduledTime: Scalars['UnixTimestamp']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
  teamInternalUserTypeId?: InputMaybe<Scalars['ID']['input']>;
  templateReportId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ScheduleInternalInspection. */
export type ScheduleInternalInspectionPayload = {
  __typename?: 'ScheduleInternalInspectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
};

/** Details about scheduling for a single inspection */
export type SchedulingDetail = {
  assignUserIds: Array<Scalars['ID']['input']>;
  inspectionId: Scalars['ID']['input'];
  scheduledTime?: InputMaybe<Scalars['UnixTimestamp']['input']>;
};

/** Autogenerated input type of SendTestNotification */
export type SendTestNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendTestNotification. */
export type SendTestNotificationPayload = {
  __typename?: 'SendTestNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
};

/** Autogenerated input type of SendVerificationSms */
export type SendVerificationSmsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendVerificationSms. */
export type SendVerificationSmsPayload = {
  __typename?: 'SendVerificationSmsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
};

export enum SowSummaryTableDisplay {
  /** Summary is shown */
  Display = 'display',
  /** Summary is hidden */
  Hidden = 'hidden'
}

/** Autogenerated input type of SubmitFeedback */
export type SubmitFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reviewableId?: InputMaybe<Scalars['String']['input']>;
  reviewableType?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** A ReportSubsystem */
export type SubsystemInput = {
  catalogSubsystemId: Scalars['ID']['input'];
  disableNotPresent?: InputMaybe<Scalars['Boolean']['input']>;
  displayIndex?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  includeOnReport?: InputMaybe<Scalars['Boolean']['input']>;
  multiUseSubsystemName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reportSystemId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  templateSubsystemIds: Array<Scalars['ID']['input']>;
  updatedAt: Scalars['UnixTimestamp']['input'];
};

/** Data provided by onboarding user */
export type SurveyorOnboardingFormInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractorLicenseHeld: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  hasReliableModeOfTransportation: Scalars['Boolean']['input'];
  hasReliablePhone: Scalars['Boolean']['input'];
  inspectorLicenseHeld: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  realEstateLicenseHeld: Scalars['Boolean']['input'];
  sendAutomatedSms: Scalars['Boolean']['input'];
  serviceAreaRadiusMileage: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Track the progress data of a surveyor onboarding process */
export type SurveyorOnboardingType = Record & {
  __typename?: 'SurveyorOnboardingType';
  appLoggedIn: Scalars['Boolean']['output'];
  backgroundCheckRequired: Scalars['Boolean']['output'];
  backgroundCheckSubmittedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  canSetPassword: Scalars['Boolean']['output'];
  completedStep: Scalars['String']['output'];
  /** Associated Contractor. */
  contractor?: Maybe<ContractorType>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  marketSaturatedAtOnboardingTime: Scalars['Boolean']['output'];
  misaSigned: Scalars['Boolean']['output'];
  onboardingTrackerDismissedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  paymentDetailsFilled: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  submitBackgroundCheckUrl?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for SurveyorOnboardingType. */
export type SurveyorOnboardingTypeConnection = {
  __typename?: 'SurveyorOnboardingTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SurveyorOnboardingTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SurveyorOnboardingType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SurveyorOnboardingTypeEdge = {
  __typename?: 'SurveyorOnboardingTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SurveyorOnboardingType>;
};

/** Autogenerated input type of SyncReport */
export type SyncReportInput = {
  applianceInformations?: InputMaybe<Array<ApplianceInformationInput>>;
  attachments: Array<AttachmentInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deficiencies: Array<DeficiencyInput>;
  deficiencyInformations?: InputMaybe<Array<DeficiencyInformationInput>>;
  deletions?: InputMaybe<Array<DeletionInput>>;
  informations: Array<InformationInput>;
  limitations: Array<LimitationInput>;
  locations: Array<LocationInput>;
  report: ReportInput;
  subsystems: Array<SubsystemInput>;
  systems: Array<SystemInput>;
};

/** Autogenerated return type of SyncReport. */
export type SyncReportPayload = {
  __typename?: 'SyncReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  report: ReportType;
};

/** A ReportSystem */
export type SystemInput = {
  catalogSystemId: Scalars['ID']['input'];
  displayIndex?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  includeOnReport?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  reportId: Scalars['ID']['input'];
  standardText?: InputMaybe<Scalars['String']['input']>;
  templateSystemIds: Array<Scalars['ID']['input']>;
  updatedAt: Scalars['UnixTimestamp']['input'];
};

/** A single rehab team custom system */
export type TeamCustomSystemType = Record & {
  __typename?: 'TeamCustomSystemType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subsystemNames: Array<Scalars['String']['output']>;
  teamId: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A TeamInspectionConfig */
export type TeamInspectionConfig = Record & {
  __typename?: 'TeamInspectionConfig';
  /** If this inspection type can be set for Bundling for this team */
  allowAutomatedScheduling: Scalars['Boolean']['output'];
  /** @deprecated Should not be used anymore */
  appRequirement: Scalars['String']['output'];
  /** If this inspection type should default to receiving repair estimate when displaying to user during booking */
  bookingFlowDefaultChecked: Scalars['Boolean']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** The Template Report to use for inspection of this type */
  inspectionType: Scalars['String']['output'];
  /** The id this config belongs to. */
  teamId: Scalars['ID']['output'];
  /** Associated TemplateReport. */
  templateReport?: Maybe<TemplateReportType>;
  /** The Template Report to use for inspection of this type */
  templateReportId?: Maybe<Scalars['ID']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  videoCaptureEnabled: Scalars['Boolean']['output'];
};

/** A market */
export type TeamMarketType = Record & {
  __typename?: 'TeamMarketType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  stateAbbreviation: Scalars['String']['output'];
  teamId: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A TeamOrderStakeholder */
export type TeamOrderStakeholder = Record & {
  __typename?: 'TeamOrderStakeholder';
  /** If we should be collecting the email, possible values: `collect`, `collect_required`, `no_collect`, `collect_for_team_user_only`, `collect_for_team_user_only_required`, `collect_for_team_user_only_required`, `collect_for_non_team_user_only_required` */
  collectEmail: Scalars['String']['output'];
  /** If we should be collecting the name, possible values: `collect`, `collect_required`, `no_collect`, `collect_for_team_user_only`, `collect_for_team_user_only_required`, `collect_for_team_user_only_required`, `collect_for_non_team_user_only_required` */
  collectName: Scalars['String']['output'];
  /** If we should be collecting the phone, possible values: `collect`, `collect_required`, `no_collect`, `collect_for_team_user_only`, `collect_for_team_user_only_required`, `collect_for_team_user_only_required`, `collect_for_non_team_user_only_required` */
  collectPhone: Scalars['String']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** The type of stakeholder, matches stakeholder_type in OrderStakeholder */
  stakeholderType: Scalars['String']['output'];
  /** The id this config belongs to. */
  teamId: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A Team */
export type TeamType = Record & {
  __typename?: 'TeamType';
  /** Allow Contractor who are setup as Internal Contractor to book inspection directly in the App */
  allowInAppBooking: Scalars['Boolean']['output'];
  /** Allow Contractor who are setup as Internal Contractor to publish reports before they are 100% complete. */
  allowPublishReportBeforeCompletion: Scalars['Boolean']['output'];
  /** Team can create Rehab Project on their reports */
  allowRehabToolAccess: Scalars['Boolean']['output'];
  /** Apply Pricing Sheet Names */
  applyPricingSheetNames?: Maybe<Scalars['Boolean']['output']>;
  /** Information for troubleshooting access issues */
  automatedTroubleshootingInformation?: Maybe<Scalars['String']['output']>;
  /** The unique URL to book an order on this Team. */
  bookingUrl: Scalars['String']['output'];
  /** Team can publish Rehab Projects */
  canPublishRehabProjects?: Maybe<Scalars['Boolean']['output']>;
  /** Cannot answer No Access requires media */
  cannotAnswerNoAccessRequiresMedia?: Maybe<Scalars['Boolean']['output']>;
  /** Associated Company. */
  company?: Maybe<CompanyType>;
  /** The ID of the Company this Team belongs to. */
  companyId: Scalars['ID']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  drawSummaryTableDisplay: DrawSummaryTableDisplay;
  /** Enable Rehab Cost Splitting */
  enableRehabCostSplitting?: Maybe<Scalars['Boolean']['output']>;
  hideContactInformationOnReport: Scalars['Boolean']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Will include draw disbursement fields in the inspection report */
  includeDrawDisbursementFields: Scalars['Boolean']['output'];
  /** Whether the team is an Inspectify Pro team */
  isInspectifyPro: Scalars['Boolean']['output'];
  /** The name of the Team. */
  name?: Maybe<Scalars['String']['output']>;
  /** List of Default Rehab Tool Tags for this Team */
  rehabTags: Array<Scalars['String']['output']>;
  /** Query related RehabTeamCustomSystems with filters. */
  rehabTeamCustomSystems: Array<TeamCustomSystemType>;
  /** Query related RehabTeamMarkets with filters. */
  rehabTeamMarkets: Array<TeamMarketType>;
  sowSummaryTableDisplay: SowSummaryTableDisplay;
  /** Query related TeamInspectionConfigs with filters. */
  teamInspectionConfigs: Array<TeamInspectionConfig>;
  /** Attached TeamLogo. */
  teamLogo?: Maybe<ActiveStorageBlob>;
  /** Query related TeamOrderStakeholders with filters. */
  teamOrderStakeholders: Array<TeamOrderStakeholder>;
  /** Query related TemplateWorkItems with filters. */
  templateWorkItems: Array<TemplateWorkItemType>;
  /** The unique token for this Team used for their booking url. */
  token: Scalars['String']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Report for this Team use a custom deficiency bank */
  useCustomDeficiencyBank: Scalars['Boolean']['output'];
  /** Report for this Team use a custom limitation bank */
  useCustomLimitationBank: Scalars['Boolean']['output'];
};

/** The many-to-many relationship between User and Team */
export type TeamUserType = Record & {
  __typename?: 'TeamUserType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** Associated Team. */
  team?: Maybe<TeamType>;
  teamAdmin: Scalars['Boolean']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Associated User. */
  user?: Maybe<UserType>;
};

/** A TemplateInformation */
export type TemplateInformationType = Record & {
  __typename?: 'TemplateInformationType';
  /** Associated CatalogInformation. */
  catalogInformation?: Maybe<CatalogInformationType>;
  catalogInformationId: Scalars['ID']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  displayIndex?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  templateSubsystemId: Scalars['ID']['output'];
  /** Query related TemplateSubsystems with filters. */
  templateSubsystems: Array<TemplateSubsystemType>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A TemplateReportEstimatedDuration for a group of template report IDs */
export type TemplateReportEstimatedDurationType = Record & {
  __typename?: 'TemplateReportEstimatedDurationType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  id: Scalars['ID']['output'];
  p60DurationInMinutes: Scalars['Int']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for TemplateReportEstimatedDurationType. */
export type TemplateReportEstimatedDurationTypeConnection = {
  __typename?: 'TemplateReportEstimatedDurationTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TemplateReportEstimatedDurationTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TemplateReportEstimatedDurationType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TemplateReportEstimatedDurationTypeEdge = {
  __typename?: 'TemplateReportEstimatedDurationTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TemplateReportEstimatedDurationType>;
};

/** A TemplateReport */
export type TemplateReportType = Record & {
  __typename?: 'TemplateReportType';
  autoDeficiencyLocationRequired: Scalars['Boolean']['output'];
  baseTemplateReportId?: Maybe<Scalars['ID']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  inspectionType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  noDeficienciesAllowed: Scalars['Boolean']['output'];
  noLimitationsAllowed: Scalars['Boolean']['output'];
  reInspectionTemplateReportId?: Maybe<Scalars['ID']['output']>;
  /** Associated TemplateReportEstimatedDuration. */
  templateReportEstimatedDuration?: Maybe<TemplateReportEstimatedDurationType>;
  /** Query related TemplateSystems with filters. */
  templateSystems: Array<TemplateSystemType>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for TemplateReportType. */
export type TemplateReportTypeConnection = {
  __typename?: 'TemplateReportTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TemplateReportTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TemplateReportType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TemplateReportTypeEdge = {
  __typename?: 'TemplateReportTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TemplateReportType>;
};

/** A TemplateSubsystem */
export type TemplateSubsystemType = Record & {
  __typename?: 'TemplateSubsystemType';
  /** Associated CatalogSubsystem. */
  catalogSubsystem?: Maybe<CatalogSubsystemType>;
  catalogSubsystemId: Scalars['ID']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  disableNotPresent: Scalars['Boolean']['output'];
  displayIndex?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  includeOnReportIfNotPresent: Scalars['Boolean']['output'];
  multiUseSubsystemName?: Maybe<Scalars['String']['output']>;
  /** Query related TemplateInformationss with filters. */
  templateInformations: Array<TemplateInformationType>;
  templateSystemId: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A TemplateSystem */
export type TemplateSystemType = Record & {
  __typename?: 'TemplateSystemType';
  /** Associated CatalogSystem. */
  catalogSystem?: Maybe<CatalogSystemType>;
  catalogSystemId: Scalars['ID']['output'];
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  displayIndex?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  templateReportId: Scalars['ID']['output'];
  /** Query related TemplateSubsystems with filters. */
  templateSubsystems: Array<TemplateSubsystemType>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A single rehab template work item pricing */
export type TemplateWorkItemPricingType = Record & {
  __typename?: 'TemplateWorkItemPricingType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  lumpSumPrice?: Maybe<Scalars['Float']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  pricingExternalId?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  teamMarketId?: Maybe<Scalars['ID']['output']>;
  /** Types::Records::Rehab::TemplateWorkItemType */
  templateWorkItem?: Maybe<TemplateWorkItemType>;
  templateWorkItemId: Scalars['ID']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** A single rehab template work item */
export type TemplateWorkItemType = Record & {
  __typename?: 'TemplateWorkItemType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  systemName?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['ID']['output'];
  templateWorkItemPricings?: Maybe<Array<TemplateWorkItemPricingType>>;
  title?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
};

/** The connection type for TemplateWorkItemType. */
export type TemplateWorkItemTypeConnection = {
  __typename?: 'TemplateWorkItemTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TemplateWorkItemTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TemplateWorkItemType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TemplateWorkItemTypeEdge = {
  __typename?: 'TemplateWorkItemTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TemplateWorkItemType>;
};

/** Autogenerated input type of TransformReportAttachment */
export type TransformReportAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  rotationDegree?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of TransformReportAttachment. */
export type TransformReportAttachmentPayload = {
  __typename?: 'TransformReportAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  reportAttachment?: Maybe<ReportAttachmentType>;
};

/** Autogenerated input type of UpdateContractor */
export type UpdateContractorInput = {
  ashiLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  businessContactName?: InputMaybe<Scalars['String']['input']>;
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  businessSite?: InputMaybe<Scalars['String']['input']>;
  certifications?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Possible values: call, text */
  communicationPreference?: InputMaybe<Scalars['String']['input']>;
  contractorLicenseHeld?: InputMaybe<Scalars['Boolean']['input']>;
  customInfo?: InputMaybe<Scalars['String']['input']>;
  employeeCount?: InputMaybe<Scalars['Int']['input']>;
  hasSentrilock?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupra?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  inBusinessSince?: InputMaybe<Scalars['Int']['input']>;
  inspectorLicenseHeld?: InputMaybe<Scalars['Boolean']['input']>;
  internachiLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  newContractorPricings?: InputMaybe<Array<ContractorPricingInput>>;
  otherLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  platformFeePercentage?: InputMaybe<Scalars['String']['input']>;
  /** Possible values: not_preferred, onboarding, preferred */
  preferredInspectorStatus?: InputMaybe<Scalars['String']['input']>;
  realEstateLicenseHeld?: InputMaybe<Scalars['Boolean']['input']>;
  reportWritingSoftware?: InputMaybe<Scalars['String']['input']>;
  schedulerEmail?: InputMaybe<Scalars['String']['input']>;
  schedulerName?: InputMaybe<Scalars['String']['input']>;
  schedulerPhone?: InputMaybe<Scalars['String']['input']>;
  sendAutomatedSms?: InputMaybe<Scalars['Boolean']['input']>;
  serviceAreaRadiusMileage?: InputMaybe<Scalars['Float']['input']>;
  serviceZipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateContractor. */
export type UpdateContractorPayload = {
  __typename?: 'UpdateContractorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contractor?: Maybe<ContractorType>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
};

/** Autogenerated input type of UpdateFloorPlanLevel */
export type UpdateFloorPlanLevelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  floorPlanAnchors: Array<FloorPlanAnchorInput>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFloorPlanLevel. */
export type UpdateFloorPlanLevelPayload = {
  __typename?: 'UpdateFloorPlanLevelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  floorPlanLevel: FloorPlanLevelType;
};

/** Autogenerated input type of UpdateInspectionScopeItem */
export type UpdateInspectionScopeItemInput = {
  budget?: InputMaybe<Scalars['Float']['input']>;
  clientDisbursement?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disbursement?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  previousDisbursement?: InputMaybe<Scalars['Float']['input']>;
  progress?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of UpdateInspectionScopeItem. */
export type UpdateInspectionScopeItemPayload = {
  __typename?: 'UpdateInspectionScopeItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  inspectionScopeItem?: Maybe<InspectionScopeItemType>;
};

/** Autogenerated input type of UpdateInspectorOnboarding */
export type UpdateInspectorOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completedStep?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  onboardingFormInput?: InputMaybe<InspectorOnboardingFormInput>;
  onboardingTrackerDismissedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  passwordSet?: InputMaybe<PasswordSetInput>;
};

/** Autogenerated return type of UpdateInspectorOnboarding. */
export type UpdateInspectorOnboardingPayload = {
  __typename?: 'UpdateInspectorOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  inspectorOnboarding?: Maybe<InspectorOnboardingType>;
};

/** Autogenerated input type of UpdateProject */
export type UpdateProjectInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  inspectionDocumentId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  teamMarketId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateProject. */
export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  project?: Maybe<ProjectType>;
};

/** Autogenerated input type of UpdateReportApplianceInformation */
export type UpdateReportApplianceInformationInput = {
  applianceTagS3ObjectKey?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  modelNumber?: InputMaybe<Scalars['String']['input']>;
  monthManufactured?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Possible values: pending_data, source7_ready, source7_retrieved, source7_verified, inspector_skipped, inspector_verified, inspectify_fixed */
  status?: InputMaybe<Scalars['String']['input']>;
  subProductId?: InputMaybe<Scalars['Int']['input']>;
  subProductName?: InputMaybe<Scalars['String']['input']>;
  yearManufactured?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateReportApplianceInformation. */
export type UpdateReportApplianceInformationPayload = {
  __typename?: 'UpdateReportApplianceInformationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  reportApplianceInformation?: Maybe<ReportApplianceInformationType>;
};

/** Autogenerated input type of UpdateSurveyorOnboarding */
export type UpdateSurveyorOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completedStep?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  onboardingFormInput?: InputMaybe<SurveyorOnboardingFormInput>;
  onboardingTrackerDismissedAt?: InputMaybe<Scalars['UnixTimestamp']['input']>;
  passwordSet?: InputMaybe<PasswordSetInput>;
};

/** Autogenerated return type of UpdateSurveyorOnboarding. */
export type UpdateSurveyorOnboardingPayload = {
  __typename?: 'UpdateSurveyorOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  surveyorOnboarding?: Maybe<SurveyorOnboardingType>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  grantedPermissions?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  user?: Maybe<UserType>;
};

/** Autogenerated input type of UpdateWorkItemAssociation */
export type UpdateWorkItemAssociationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JsonAsString']['input']>;
  id: Scalars['ID']['input'];
  itemId?: InputMaybe<Scalars['ID']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  workItemId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateWorkItemAssociation. */
export type UpdateWorkItemAssociationPayload = {
  __typename?: 'UpdateWorkItemAssociationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItemAssociation?: Maybe<WorkItemAssociationType>;
};

/** Autogenerated input type of UpdateWorkItemAttachment */
export type UpdateWorkItemAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  s3ObjectKey?: InputMaybe<Scalars['String']['input']>;
  workItemAssociationId?: InputMaybe<Scalars['ID']['input']>;
  workItemId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateWorkItemAttachment. */
export type UpdateWorkItemAttachmentPayload = {
  __typename?: 'UpdateWorkItemAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItemAttachment?: Maybe<WorkItemAttachmentType>;
};

/** Autogenerated input type of UpdateWorkItemContributor */
export type UpdateWorkItemContributorInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  workItemId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateWorkItemContributor. */
export type UpdateWorkItemContributorPayload = {
  __typename?: 'UpdateWorkItemContributorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItemContributor?: Maybe<WorkItemContributorType>;
};

/** Autogenerated input type of UpdateWorkItem */
export type UpdateWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  displayIndex?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
  pricingExternalId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  subsystemName?: InputMaybe<Scalars['String']['input']>;
  systemName: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateWorkItemPricingId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateWorkItem. */
export type UpdateWorkItemPayload = {
  __typename?: 'UpdateWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  workItem?: Maybe<WorkItemType>;
};

/** Instance of an alert campaign for a specific app user */
export type UserAlertType = Record & {
  __typename?: 'UserAlertType';
  /** Associated AlertCampaign. */
  alertCampaign?: Maybe<AlertCampaignType>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Associated User. */
  user?: Maybe<UserType>;
  viewed: Scalars['Boolean']['output'];
};

/** The connection type for UserAlertType. */
export type UserAlertTypeConnection = {
  __typename?: 'UserAlertTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserAlertTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserAlertType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserAlertTypeEdge = {
  __typename?: 'UserAlertTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserAlertType>;
};

/** Feedback provided from a user */
export type UserFeedback = Record & {
  __typename?: 'UserFeedback';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  initiatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  reviewableId: Scalars['String']['output'];
  reviewableType: Scalars['String']['output'];
  score?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** A single Push Token for a User */
export type UserPushTokenType = Record & {
  __typename?: 'UserPushTokenType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  expoPushToken?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  userId: Scalars['ID']['output'];
};

/** A User */
export type UserType = Record & {
  __typename?: 'UserType';
  activatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  admin: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  assignmentTags: Array<Scalars['String']['output']>;
  canManageUsers: Scalars['Boolean']['output'];
  /** Associated Contractor. */
  contractor?: Maybe<ContractorType>;
  contractorId?: Maybe<Scalars['ID']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  grantedPermissions: Array<Scalars['String']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  minimumAppVersion: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Associated Team.
   * @deprecated Replaced in favour of teamUsers.team
   */
  team?: Maybe<TeamType>;
  teamAdmin: Scalars['Boolean']['output'];
  /** @deprecated Replaced in favour of teamUsers.teamId */
  teamId?: Maybe<Scalars['ID']['output']>;
  /** Query related TeamUsers with filters. */
  teamUsers: Array<TeamUserType>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Query related UserAlerts with filters. */
  userAlerts: Array<UserAlertType>;
};

/** The connection type for UserType. */
export type UserTypeConnection = {
  __typename?: 'UserTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserTypeEdge = {
  __typename?: 'UserTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserType>;
};

/** Autogenerated input type of WarrantyClaim */
export type WarrantyClaimInput = {
  blobSignedId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfLoss: Scalars['ISO8601Date']['input'];
  inspectionWarrantyId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  productType: Scalars['String']['input'];
  repairStatus: Scalars['String']['input'];
};

/** Autogenerated return type of WarrantyClaim. */
export type WarrantyClaimPayload = {
  __typename?: 'WarrantyClaimPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  inspectionWarranty?: Maybe<InspectionWarrantyType>;
};

/** Autogenerated input type of WarrantyProveOwnership */
export type WarrantyProveOwnershipInput = {
  blobSignedId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inspectionWarrantyId: Scalars['ID']['input'];
  ownerEmail: Scalars['String']['input'];
  ownerFirstName: Scalars['String']['input'];
  ownerLastName: Scalars['String']['input'];
  ownerPhoneNumber: Scalars['String']['input'];
  purchaseDate: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of WarrantyProveOwnership. */
export type WarrantyProveOwnershipPayload = {
  __typename?: 'WarrantyProveOwnershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by standard graphql errors, do not use. */
  errors?: Maybe<Array<MutationError>>;
  inspectionWarranty?: Maybe<InspectionWarrantyType>;
};

/** A single rehab work item association */
export type WorkItemAssociationType = Record & {
  __typename?: 'WorkItemAssociationType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  data?: Maybe<Scalars['JsonAsString']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  itemId?: Maybe<Scalars['ID']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  workItemId?: Maybe<Scalars['ID']['output']>;
};

/** A single rehab work item attachment */
export type WorkItemAttachmentType = Record & {
  __typename?: 'WorkItemAttachmentType';
  attachmentUrl?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  resizedUrls: Array<ResizedUrlType>;
  rotatedUrls: Array<RotatedUrlType>;
  s3ObjectKey?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  workItemAssociationId?: Maybe<Scalars['ID']['output']>;
  workItemId: Scalars['ID']['output'];
};

/** A single rehab work item contributor */
export type WorkItemContributorType = Record & {
  __typename?: 'WorkItemContributorType';
  amount?: Maybe<Scalars['Float']['output']>;
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  workItemId?: Maybe<Scalars['ID']['output']>;
};

/** A single rehab work item */
export type WorkItemType = Record & {
  __typename?: 'WorkItemType';
  /** The date and time that the resource was created. */
  createdAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  details: Scalars['String']['output'];
  displayIndex: Scalars['Int']['output'];
  /** The unique identifier of the resource. */
  id: Scalars['ID']['output'];
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  pricingExternalId?: Maybe<Scalars['ID']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  subsystemDisplayIndex?: Maybe<Scalars['Int']['output']>;
  subsystemName?: Maybe<Scalars['String']['output']>;
  systemDisplayIndex?: Maybe<Scalars['Int']['output']>;
  systemName: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  /** Types::Records::Rehab::TemplateWorkItemPricingType */
  templateWorkItemPricing?: Maybe<TemplateWorkItemPricingType>;
  templateWorkItemPricingId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  totalPrice?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  /** The date and time that the resource was last updated. */
  updatedAt?: Maybe<Scalars['UnixTimestamp']['output']>;
  /** Query related WorkItemAssociations with filters. */
  workItemAssociations: Array<WorkItemAssociationType>;
  /** Query related WorkItemAttachments with filters. */
  workItemAttachments: Array<WorkItemAttachmentType>;
  /** Query related WorkItemContributors with filters. */
  workItemContributors: Array<WorkItemContributorType>;
};

export type BasicReportAttachmentFieldsFragment = { __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> };

export type BasicReportLimitationFieldsFragment = { __typename?: 'ReportLimitationType', id: string, note?: string | null, title: string, detail?: string | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, itemId?: string | null, itemType?: string | null, name: string, groupName: string }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> };

export type BasicReportLocationFieldsFragment = { __typename?: 'ReportLocationType', id: string, itemId?: string | null, itemType?: string | null, name: string, groupName: string };

export type ContractorLicensesFieldsFragment = { __typename?: 'ContractorType', stateLicenseNumber?: string | null, ashiLicenseNumber?: string | null, internachiLicenseNumber?: string | null, otherLicenseNumber?: string | null };

export type FloorplanLevelFieldsFragment = { __typename?: 'FloorPlanLevelType', id: string, floorName: string, floorPlanInspectionId: string, image: { __typename?: 'ActiveStorageBlob', id: string, cdnUrl: string, url: string, filename: string }, floorPlanAnchors: Array<{ __typename?: 'FloorPlanAnchorType', id: string, x: number, y: number, floorPlanLevelId: string, reportAttachmentId: string }> };

export type BundleOfferFieldsFragment = { __typename?: 'BundleOffer', id: string, totalPay: number, status: string, bundle?: { __typename?: 'BundleType', id: string, status: string, requestedAt: any, bundleInspections: Array<{ __typename?: 'BundleInspection', id: string, appointmentAvailabilities?: Array<any> | null, inspection?: { __typename?: 'InspectionType', id: string, inspectionType: string, scheduledProposalId?: string | null, templateReportId?: string | null, status?: string | null, order?: { __typename?: 'OrderType', id: string, contingencyDate?: any | null, inspectionSchedulingDeadline?: any | null, accessInformation?: string | null, property?: { __typename?: 'PropertyType', id: string, street?: string | null, address: string, city?: string | null, state?: string | null, totalSquareFeet?: number | null, zipCode?: string | null } | null } | null } | null }> } | null };

export type FullCatalogInformationFieldsFragment = { __typename?: 'CatalogInformationType', id: string, title: string, detail?: string | null, dataName: string, questionType: string, units?: string | null, allowsOther: boolean, requiresLocations: boolean, requiresMedias: number, requiresDeficiencyCondition?: any | null, isMultiSelect: boolean, options?: Array<string> | null };

export type FullCatalogSubsystemFieldsFragment = { __typename?: 'CatalogSubsystemType', id: string, name: string };

export type FullCatalogSystemFieldsFragment = { __typename?: 'CatalogSystemType', id: string, name: string, createdAt?: any | null };

export type FullContractorDetailsFragmentFragment = { __typename?: 'ContractorType', id: string, contractorType?: string | null, city?: string | null, state?: string | null, country?: string | null, businessZipCode?: string | null, preferredInspectorStatus?: string | null, businessContactName?: string | null, businessPhone?: string | null, businessEmail?: string | null, businessName?: string | null, businessSite?: string | null, businessAddress?: string | null, schedulerName?: string | null, schedulerPhone?: string | null, schedulerEmail?: string | null, serviceZipCodes?: Array<string> | null, serviceAreaRadiusMileage?: number | null, hasSupra?: boolean | null, hasSentrilock?: boolean | null, reportWritingSoftware?: string | null, msaSigned?: boolean | null, tipaltiIsPayable?: boolean | null, stateLicenseNumber?: string | null, ashiLicenseNumber?: string | null, internachiLicenseNumber?: string | null, otherLicenseNumber?: string | null, logo?: { __typename?: 'ActiveStorageBlob', url: string } | null, fileAttachments: Array<{ __typename?: 'FileAttachment', id: string, category: string, createdAt?: any | null, attachment?: { __typename?: 'ActiveStorageBlob', id: string, cdnUrl: string, url: string, filename: string } | null }>, contractorPricings: Array<{ __typename?: 'ContractorPricing', name: string, description?: string | null, active: boolean, allowCustomPricing: boolean }> };

export type InspectionFragmentFragment = { __typename?: 'InspectionType', id: string, inspectionType: string, geotaggingRequired: boolean, orderId: string, scheduledProposalId?: string | null, status?: string | null, templateReportId?: string | null, createdAt?: any | null, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, inspectionId: string, contractorId: string, scheduledAt?: any | null, totalFee?: number | null, contractorFee?: number | null, contractorPaidAt?: any | null, teamInternalUserTypeId?: string | null, isGoAnytime?: boolean | null } | null };

export type InspectionProposalFragmentFragment = { __typename?: 'InspectionProposalType', id: string, inspectionId: string, contractorId: string, scheduledAt?: any | null, totalFee?: number | null, contractorFee?: number | null, contractorPaidAt?: any | null, teamInternalUserTypeId?: string | null, isGoAnytime?: boolean | null };

export type JobFragmentFragment = { __typename?: 'JobType', id: string, scheduledTime: any, status: JobStatus, isFee: boolean, isGoAnytime: boolean, isMock: boolean, order: { __typename?: 'OrderType', id: string, accessInformation?: string | null, contingencyDate?: any | null, createdAt?: any | null, inspectionSchedulingDeadline?: any | null, readOnlyToken?: string | null, isPaywall?: boolean | null, status: string, teamExternalId?: string | null, occupancyInfo?: string | null, isMock: boolean, teamId: string, propertyId: string, property?: { __typename?: 'PropertyType', id: string, address: string, street?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, homeType?: string | null, totalSquareFeet?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, timezone?: string | null, latitude?: number | null, longitude?: number | null, photo?: { __typename?: 'ActiveStorageBlob', url: string } | null } | null, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string, status?: string | null, isPaid?: boolean | null, orderId: string, inspectionWarranty?: { __typename?: 'InspectionWarrantyType', id: string, inspectionId: string, status: string, startDate?: any | null, expirationDate?: any | null, createdAt?: any | null, updatedAt?: any | null, inspection?: { __typename?: 'InspectionType', orderId: string } | null } | null, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, report?: { __typename?: 'ReportType', id: string } | null }>, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, totalFee?: number | null, scheduledAt?: any | null, contractorId: string } | null }>, team?: { __typename?: 'TeamType', id: string, hideContactInformationOnReport: boolean, drawSummaryTableDisplay: DrawSummaryTableDisplay, includeDrawDisbursementFields: boolean, companyId: string } | null }, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string, geotaggingRequired: boolean, orderId: string, scheduledProposalId?: string | null, status?: string | null, templateReportId?: string | null, createdAt?: any | null, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, inspectionId: string, contractorId: string, scheduledAt?: any | null, totalFee?: number | null, contractorFee?: number | null, contractorPaidAt?: any | null, teamInternalUserTypeId?: string | null, isGoAnytime?: boolean | null } | null }>, reports: Array<{ __typename?: 'ReportType', id: string, templateReportIds: Array<string>, templateNames: Array<string>, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, pdfDocumentUrl?: string | null, originalReportId?: string | null, noDeficienciesAllowed: boolean, noLimitationsAllowed: boolean, geotaggingRequired: boolean, complianceText?: string | null, reportSystems: Array<{ __typename?: 'ReportSystemType', id: string }> }> };

export type OrderFragmentFragment = { __typename?: 'OrderType', id: string, accessInformation?: string | null, contingencyDate?: any | null, createdAt?: any | null, inspectionSchedulingDeadline?: any | null, readOnlyToken?: string | null, isPaywall?: boolean | null, status: string, teamExternalId?: string | null, occupancyInfo?: string | null, isMock: boolean, teamId: string, propertyId: string, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string, status?: string | null, isPaid?: boolean | null, orderId: string, inspectionWarranty?: { __typename?: 'InspectionWarrantyType', id: string, inspectionId: string, status: string, startDate?: any | null, expirationDate?: any | null, createdAt?: any | null, updatedAt?: any | null, inspection?: { __typename?: 'InspectionType', orderId: string } | null } | null, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, report?: { __typename?: 'ReportType', id: string } | null }>, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, totalFee?: number | null, scheduledAt?: any | null, contractorId: string } | null }>, team?: { __typename?: 'TeamType', id: string, hideContactInformationOnReport: boolean, drawSummaryTableDisplay: DrawSummaryTableDisplay, includeDrawDisbursementFields: boolean, companyId: string } | null };

export type OrderStakeholderFragmentFragment = { __typename?: 'OrderStakeholderType', id: string, email?: string | null, name?: string | null, phone?: string | null, stakeholderType: string, isClient?: boolean | null };

export type FullOriginalReportDeficiencyFieldsFragment = { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> };

export type PropertyFragmentFragment = { __typename?: 'PropertyType', id: string, address: string, street?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, homeType?: string | null, totalSquareFeet?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, timezone?: string | null, latitude?: number | null, longitude?: number | null, photo?: { __typename?: 'ActiveStorageBlob', url: string } | null };

export type FullReportApplianceInformationsFieldsFragment = { __typename?: 'ReportApplianceInformationType', age?: number | null, brandId?: number | null, brandName?: string | null, createdAt?: any | null, expectedLife?: number | null, id: string, modelNumber?: string | null, monthManufactured?: number | null, possibleYearsManufactured?: Array<number> | null, productFailureRiskScore?: number | null, productId?: number | null, productName?: string | null, recalls?: Array<string> | null, remainingLife?: number | null, reportId: string, reportInformationId: string, serialNumber?: string | null, status?: string | null, subProductId?: number | null, subProductName?: string | null, updatedAt?: any | null, yearManufactured?: number | null, warrantyCovered?: boolean | null, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> };

export type FullReportAttachmentFieldsFragment = { __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> };

export type FullReportDeficiencyFieldsFragment = { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null };

export type FullReportFieldsFragment = { __typename?: 'ReportType', id: string, orderId?: string | null, templateReportIds: Array<string>, templateNames: Array<string>, pdfDocumentUrl?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, noDeficienciesAllowed: boolean, noLimitationsAllowed: boolean, geotaggingRequired: boolean, originalReportId?: string | null, complianceText?: string | null, reportSystems: Array<{ __typename?: 'ReportSystemType', id: string, reportId: string, catalogSystemId: string, templateSystemIds: Array<string>, name: string, standardText?: string | null, updatedAt?: any | null, displayIndex?: number | null, includeOnReport: boolean, reportSystemGroupId?: string | null, reportSubsystems: Array<{ __typename?: 'ReportSubsystemType', id: string, reportSystemId: string, catalogSubsystemId: string, templateSubsystemIds: Array<string>, status: string, name: string, note?: string | null, updatedAt?: any | null, displayIndex?: number | null, includeOnReport: boolean, includeOnReportIfNotPresent?: boolean | null, multiUseSubsystemName?: string | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportInformations: Array<{ __typename?: 'ReportInformationType', id: string, reportSubsystemId: string, reportLimitationId?: string | null, catalogInformationId: string, note?: string | null, title: string, dataName: string, detail?: string | null, value?: string | null, questionType: string, units?: string | null, status: ReportInformationStatus, cannotAnswerReason?: ReportInformationCannotAnswerReason | null, allowsOther: boolean, requiresLocations: boolean, requiresMedias: number, requiresMediaOrientation: string, requiresMediaType: string, requiresDeficiencyCondition?: any | null, requiresDeficiencyCatalogDeficiencyId?: string | null, inspectionScopeItemId?: string | null, isMultiSelect: boolean, options?: Array<string> | null, displayIndex: number, tags?: any | null, updatedAt?: any | null, conditionalFollowupLogic?: string | null, catalogInformation?: { __typename?: 'CatalogInformationType', id: string, autoDeficiencyCondition?: any | null, autoDeficiencyMediaRequired: number } | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, reportApplianceInformation?: { __typename?: 'ReportApplianceInformationType', age?: number | null, brandId?: number | null, brandName?: string | null, createdAt?: any | null, expectedLife?: number | null, id: string, modelNumber?: string | null, monthManufactured?: number | null, possibleYearsManufactured?: Array<number> | null, productFailureRiskScore?: number | null, productId?: number | null, productName?: string | null, recalls?: Array<string> | null, remainingLife?: number | null, reportId: string, reportInformationId: string, serialNumber?: string | null, status?: string | null, subProductId?: number | null, subProductName?: string | null, updatedAt?: any | null, yearManufactured?: number | null, warrantyCovered?: boolean | null, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }> }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, inspectionReports: Array<{ __typename?: 'InspectionReportType', inspection?: { __typename?: 'InspectionType', id: string, orderId: string, inspectionType: string, order?: { __typename?: 'OrderType', teamId: string, team?: { __typename?: 'TeamType', id: string, name?: string | null } | null } | null, inspectionWarranty?: { __typename?: 'InspectionWarrantyType', id: string, status: string, inspectionId: string, expirationDate?: any | null, startDate?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, contractorId: string, scheduledAt?: any | null } | null } | null }>, reportSystemGroups: Array<{ __typename?: 'ReportSystemGroupType', id: string, name?: string | null }> };

export type FullReportInformationsFieldsFragment = { __typename?: 'ReportInformationType', id: string, reportSubsystemId: string, reportLimitationId?: string | null, catalogInformationId: string, note?: string | null, title: string, dataName: string, detail?: string | null, value?: string | null, questionType: string, units?: string | null, status: ReportInformationStatus, cannotAnswerReason?: ReportInformationCannotAnswerReason | null, allowsOther: boolean, requiresLocations: boolean, requiresMedias: number, requiresMediaOrientation: string, requiresMediaType: string, requiresDeficiencyCondition?: any | null, requiresDeficiencyCatalogDeficiencyId?: string | null, inspectionScopeItemId?: string | null, isMultiSelect: boolean, options?: Array<string> | null, displayIndex: number, tags?: any | null, updatedAt?: any | null, conditionalFollowupLogic?: string | null, catalogInformation?: { __typename?: 'CatalogInformationType', id: string, autoDeficiencyCondition?: any | null, autoDeficiencyMediaRequired: number } | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, reportApplianceInformation?: { __typename?: 'ReportApplianceInformationType', age?: number | null, brandId?: number | null, brandName?: string | null, createdAt?: any | null, expectedLife?: number | null, id: string, modelNumber?: string | null, monthManufactured?: number | null, possibleYearsManufactured?: Array<number> | null, productFailureRiskScore?: number | null, productId?: number | null, productName?: string | null, recalls?: Array<string> | null, remainingLife?: number | null, reportId: string, reportInformationId: string, serialNumber?: string | null, status?: string | null, subProductId?: number | null, subProductName?: string | null, updatedAt?: any | null, yearManufactured?: number | null, warrantyCovered?: boolean | null, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }> };

export type FullReportLimitationFieldsFragment = { __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> };

export type FullReportLocationFieldsFragment = { __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null };

export type ReportRecordFragmentFragment = { __typename?: 'ReportType', id: string, templateReportIds: Array<string>, templateNames: Array<string>, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, pdfDocumentUrl?: string | null, originalReportId?: string | null, noDeficienciesAllowed: boolean, noLimitationsAllowed: boolean, geotaggingRequired: boolean, complianceText?: string | null, reportSystems: Array<{ __typename?: 'ReportSystemType', id: string }> };

export type FullReportSubsystemFieldsFragment = { __typename?: 'ReportSubsystemType', id: string, reportSystemId: string, catalogSubsystemId: string, templateSubsystemIds: Array<string>, status: string, name: string, note?: string | null, updatedAt?: any | null, displayIndex?: number | null, includeOnReport: boolean, includeOnReportIfNotPresent?: boolean | null, multiUseSubsystemName?: string | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportInformations: Array<{ __typename?: 'ReportInformationType', id: string, reportSubsystemId: string, reportLimitationId?: string | null, catalogInformationId: string, note?: string | null, title: string, dataName: string, detail?: string | null, value?: string | null, questionType: string, units?: string | null, status: ReportInformationStatus, cannotAnswerReason?: ReportInformationCannotAnswerReason | null, allowsOther: boolean, requiresLocations: boolean, requiresMedias: number, requiresMediaOrientation: string, requiresMediaType: string, requiresDeficiencyCondition?: any | null, requiresDeficiencyCatalogDeficiencyId?: string | null, inspectionScopeItemId?: string | null, isMultiSelect: boolean, options?: Array<string> | null, displayIndex: number, tags?: any | null, updatedAt?: any | null, conditionalFollowupLogic?: string | null, catalogInformation?: { __typename?: 'CatalogInformationType', id: string, autoDeficiencyCondition?: any | null, autoDeficiencyMediaRequired: number } | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, reportApplianceInformation?: { __typename?: 'ReportApplianceInformationType', age?: number | null, brandId?: number | null, brandName?: string | null, createdAt?: any | null, expectedLife?: number | null, id: string, modelNumber?: string | null, monthManufactured?: number | null, possibleYearsManufactured?: Array<number> | null, productFailureRiskScore?: number | null, productId?: number | null, productName?: string | null, recalls?: Array<string> | null, remainingLife?: number | null, reportId: string, reportInformationId: string, serialNumber?: string | null, status?: string | null, subProductId?: number | null, subProductName?: string | null, updatedAt?: any | null, yearManufactured?: number | null, warrantyCovered?: boolean | null, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }> }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> };

export type FullReportSystemFieldsFragment = { __typename?: 'ReportSystemType', id: string, reportId: string, catalogSystemId: string, templateSystemIds: Array<string>, name: string, standardText?: string | null, updatedAt?: any | null, displayIndex?: number | null, includeOnReport: boolean, reportSystemGroupId?: string | null, reportSubsystems: Array<{ __typename?: 'ReportSubsystemType', id: string, reportSystemId: string, catalogSubsystemId: string, templateSubsystemIds: Array<string>, status: string, name: string, note?: string | null, updatedAt?: any | null, displayIndex?: number | null, includeOnReport: boolean, includeOnReportIfNotPresent?: boolean | null, multiUseSubsystemName?: string | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportInformations: Array<{ __typename?: 'ReportInformationType', id: string, reportSubsystemId: string, reportLimitationId?: string | null, catalogInformationId: string, note?: string | null, title: string, dataName: string, detail?: string | null, value?: string | null, questionType: string, units?: string | null, status: ReportInformationStatus, cannotAnswerReason?: ReportInformationCannotAnswerReason | null, allowsOther: boolean, requiresLocations: boolean, requiresMedias: number, requiresMediaOrientation: string, requiresMediaType: string, requiresDeficiencyCondition?: any | null, requiresDeficiencyCatalogDeficiencyId?: string | null, inspectionScopeItemId?: string | null, isMultiSelect: boolean, options?: Array<string> | null, displayIndex: number, tags?: any | null, updatedAt?: any | null, conditionalFollowupLogic?: string | null, catalogInformation?: { __typename?: 'CatalogInformationType', id: string, autoDeficiencyCondition?: any | null, autoDeficiencyMediaRequired: number } | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, reportApplianceInformation?: { __typename?: 'ReportApplianceInformationType', age?: number | null, brandId?: number | null, brandName?: string | null, createdAt?: any | null, expectedLife?: number | null, id: string, modelNumber?: string | null, monthManufactured?: number | null, possibleYearsManufactured?: Array<number> | null, productFailureRiskScore?: number | null, productId?: number | null, productName?: string | null, recalls?: Array<string> | null, remainingLife?: number | null, reportId: string, reportInformationId: string, serialNumber?: string | null, status?: string | null, subProductId?: number | null, subProductName?: string | null, updatedAt?: any | null, yearManufactured?: number | null, warrantyCovered?: boolean | null, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }> }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> };

export type FullTemplateReportFieldsFragment = { __typename?: 'TemplateReportType', id: string, baseTemplateReportId?: string | null, reInspectionTemplateReportId?: string | null, name: string, description?: string | null, displayName: string, inspectionType?: string | null, noDeficienciesAllowed: boolean, noLimitationsAllowed: boolean, templateSystems: Array<{ __typename?: 'TemplateSystemType', id: string, templateReportId: string, catalogSystemId: string, displayIndex?: number | null, catalogSystem?: { __typename?: 'CatalogSystemType', id: string, name: string, createdAt?: any | null } | null, templateSubsystems: Array<{ __typename?: 'TemplateSubsystemType', id: string, templateSystemId: string, catalogSubsystemId: string, displayIndex?: number | null, multiUseSubsystemName?: string | null, includeOnReportIfNotPresent: boolean, catalogSubsystem?: { __typename?: 'CatalogSubsystemType', id: string, name: string } | null, templateInformations: Array<{ __typename?: 'TemplateInformationType', id: string, templateSubsystemId: string, catalogInformationId: string, displayIndex?: number | null, catalogInformation?: { __typename?: 'CatalogInformationType', id: string, title: string, detail?: string | null, dataName: string, questionType: string, units?: string | null, allowsOther: boolean, requiresLocations: boolean, requiresMedias: number, requiresDeficiencyCondition?: any | null, isMultiSelect: boolean, options?: Array<string> | null } | null }> }> }> };

export type InspectionDocumentFragmentFragment = { __typename?: 'InspectionType', id: string, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, report?: { __typename?: 'ReportType', id: string, inspectionDocuments: Array<{ __typename?: 'InspectionDocumentType', id: string, document?: { __typename?: 'ActiveStorageBlob', id: string, byteSize: any, contentType?: string | null, cdnUrl: string } | null }> } | null }> };

export type JobListFragmentFragment = { __typename?: 'JobType', id: string, status: JobStatus, isGoAnytime: boolean, isMock: boolean, scheduledTime: any, order: { __typename?: 'OrderType', id: string, readOnlyToken?: string | null, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string }>, property?: { __typename?: 'PropertyType', id: string, address: string, street?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, homeType?: string | null, totalSquareFeet?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, timezone?: string | null, latitude?: number | null, longitude?: number | null, photo?: { __typename?: 'ActiveStorageBlob', url: string } | null } | null }, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string, status?: string | null, templateReportId?: string | null }> };

export type RehabPropertyFieldsFragment = { __typename?: 'PropertyType', id: string, address: string, street?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, homeType?: string | null, totalSquareFeet?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, timezone?: string | null, photo?: { __typename?: 'ActiveStorageBlob', cdnUrl: string } | null };

export type RehabTeamCustomSystemFieldsFragment = { __typename?: 'TeamCustomSystemType', id: string, teamId: string, name: string, subsystemNames: Array<string> };

export type RehabTeamFieldsFragment = { __typename?: 'TeamType', id: string, token: string, name?: string | null, rehabTags: Array<string>, canPublishRehabProjects?: boolean | null, allowRehabToolAccess: boolean, enableRehabCostSplitting?: boolean | null, rehabTeamMarkets: Array<{ __typename?: 'TeamMarketType', id: string, name: string, stateAbbreviation: string }>, rehabTeamCustomSystems: Array<{ __typename?: 'TeamCustomSystemType', id: string, teamId: string, name: string, subsystemNames: Array<string> }> };

export type RehabWorkItemFieldsFragment = { __typename?: 'WorkItemType', id: string, projectId?: string | null, systemName: string, subsystemName?: string | null, title: string, details: string, quantity?: number | null, unit?: string | null, pricePerUnit?: number | null, totalPrice?: number | null, tags: Array<string>, templateWorkItemPricingId?: string | null, pricingExternalId?: string | null, displayIndex: number, workItemAssociations: Array<{ __typename?: 'WorkItemAssociationType', id: string, workItemId?: string | null, itemId?: string | null, itemType?: string | null, data?: any | null }>, workItemAttachments: Array<{ __typename?: 'WorkItemAttachmentType', id: string, workItemId: string, workItemAssociationId?: string | null, s3ObjectKey?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', url: string, width: string }> }>, workItemContributors: Array<{ __typename?: 'WorkItemContributorType', amount?: number | null, createdAt?: any | null, id: string, name?: string | null, updatedAt?: any | null, workItemId?: string | null }> };

export type ReportFieldsFragment = { __typename?: 'ReportType', id: string, orderId?: string | null, templateReportIds: Array<string>, templateNames: Array<string>, pdfDocumentUrl?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, noDeficienciesAllowed: boolean, noLimitationsAllowed: boolean, geotaggingRequired: boolean, originalReportId?: string | null, complianceText?: string | null, inspectionReports: Array<{ __typename?: 'InspectionReportType', inspection?: { __typename?: 'InspectionType', id: string, orderId: string, inspectionType: string, order?: { __typename?: 'OrderType', teamId: string, team?: { __typename?: 'TeamType', id: string, name?: string | null } | null } | null, inspectionWarranty?: { __typename?: 'InspectionWarrantyType', id: string, status: string, inspectionId: string, expirationDate?: any | null, startDate?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, contractorId: string, scheduledAt?: any | null } | null } | null }>, reportSystemGroups: Array<{ __typename?: 'ReportSystemGroupType', id: string, name?: string | null }> };

export type CreateFeedbackMutationVariables = Exact<{
  input: SubmitFeedbackInput;
}>;


export type CreateFeedbackMutation = { __typename?: 'Mutation', submitFeedback?: { __typename?: 'UserFeedback', id: string, reviewableId: string, reviewableType: string, score?: string | null, note?: string | null, initiatedAt?: any | null, submittedAt?: any | null, userId?: string | null } | null };

export type MutateAttachmentMutationVariables = Exact<{
  input: TransformReportAttachmentInput;
}>;


export type MutateAttachmentMutation = { __typename?: 'Mutation', transformReportAttachment?: { __typename?: 'TransformReportAttachmentPayload', reportAttachment?: { __typename?: 'ReportAttachmentType', id: string } | null } | null };

export type CreateItemAccessLogMutationVariables = Exact<{
  input: CreateItemAccessLogInput;
}>;


export type CreateItemAccessLogMutation = { __typename?: 'Mutation', createItemAccessLog?: { __typename?: 'CreateItemAccessLogPayload', errors?: Array<{ __typename?: 'MutationError', code: string, message: string }> | null } | null };

export type CreateReportMutationVariables = Exact<{
  inspectionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport?: { __typename?: 'CreateReportPayload', report: { __typename?: 'ReportType', id: string, orderId?: string | null, templateReportIds: Array<string>, templateNames: Array<string>, pdfDocumentUrl?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, noDeficienciesAllowed: boolean, noLimitationsAllowed: boolean, geotaggingRequired: boolean, originalReportId?: string | null, complianceText?: string | null, reportSystems: Array<{ __typename?: 'ReportSystemType', id: string, reportId: string, catalogSystemId: string, templateSystemIds: Array<string>, name: string, standardText?: string | null, updatedAt?: any | null, displayIndex?: number | null, includeOnReport: boolean, reportSystemGroupId?: string | null, reportSubsystems: Array<{ __typename?: 'ReportSubsystemType', id: string, reportSystemId: string, catalogSubsystemId: string, templateSubsystemIds: Array<string>, status: string, name: string, note?: string | null, updatedAt?: any | null, displayIndex?: number | null, includeOnReport: boolean, includeOnReportIfNotPresent?: boolean | null, multiUseSubsystemName?: string | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportInformations: Array<{ __typename?: 'ReportInformationType', id: string, reportSubsystemId: string, reportLimitationId?: string | null, catalogInformationId: string, note?: string | null, title: string, dataName: string, detail?: string | null, value?: string | null, questionType: string, units?: string | null, status: ReportInformationStatus, cannotAnswerReason?: ReportInformationCannotAnswerReason | null, allowsOther: boolean, requiresLocations: boolean, requiresMedias: number, requiresMediaOrientation: string, requiresMediaType: string, requiresDeficiencyCondition?: any | null, requiresDeficiencyCatalogDeficiencyId?: string | null, inspectionScopeItemId?: string | null, isMultiSelect: boolean, options?: Array<string> | null, displayIndex: number, tags?: any | null, updatedAt?: any | null, conditionalFollowupLogic?: string | null, catalogInformation?: { __typename?: 'CatalogInformationType', id: string, autoDeficiencyCondition?: any | null, autoDeficiencyMediaRequired: number } | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, reportApplianceInformation?: { __typename?: 'ReportApplianceInformationType', age?: number | null, brandId?: number | null, brandName?: string | null, createdAt?: any | null, expectedLife?: number | null, id: string, modelNumber?: string | null, monthManufactured?: number | null, possibleYearsManufactured?: Array<number> | null, productFailureRiskScore?: number | null, productId?: number | null, productName?: string | null, recalls?: Array<string> | null, remainingLife?: number | null, reportId: string, reportInformationId: string, serialNumber?: string | null, status?: string | null, subProductId?: number | null, subProductName?: string | null, updatedAt?: any | null, yearManufactured?: number | null, warrantyCovered?: boolean | null, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }> }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, inspectionReports: Array<{ __typename?: 'InspectionReportType', inspection?: { __typename?: 'InspectionType', id: string, orderId: string, inspectionType: string, order?: { __typename?: 'OrderType', teamId: string, team?: { __typename?: 'TeamType', id: string, name?: string | null } | null } | null, inspectionWarranty?: { __typename?: 'InspectionWarrantyType', id: string, status: string, inspectionId: string, expirationDate?: any | null, startDate?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, contractorId: string, scheduledAt?: any | null } | null } | null }>, reportSystemGroups: Array<{ __typename?: 'ReportSystemGroupType', id: string, name?: string | null }> } } | null };

export type MutateCreateReportAttachmentMutationVariables = Exact<{
  input: CreateReportAttachmentInput;
}>;


export type MutateCreateReportAttachmentMutation = { __typename?: 'Mutation', createReportAttachment?: { __typename?: 'CreateReportAttachmentPayload', reportAttachment?: { __typename?: 'ReportAttachmentType', attachmentUrl?: string | null, longLiveUrl?: string | null, createdAt?: any | null, fileName?: string | null, id: string, itemId?: string | null, itemType?: string | null, mediaType?: string | null, metadata: any, reportId: string, reportSystemGroupId?: string | null, s3ObjectKey?: string | null, thumbnailUrl?: string | null, updatedAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', url: string, width: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', url: string, degree: string }> } | null } | null };

export type MutateDeleteAttachmentMutationVariables = Exact<{
  input: DeleteReportAttachmentInput;
}>;


export type MutateDeleteAttachmentMutation = { __typename?: 'Mutation', deleteReportAttachment?: { __typename?: 'DeleteReportAttachmentPayload', reportAttachment?: { __typename?: 'ReportAttachmentType', id: string } | null } | null };

export type DirectUploadMutationVariables = Exact<{
  input: DirectUploadInput;
}>;


export type DirectUploadMutation = { __typename?: 'Mutation', directUpload?: { __typename?: 'DirectUploadPayload', blobSignedId: string, contentMd5: string, contentType: string, url: string } | null };

export type MutateFixMissingS3ObjectKeysMutationVariables = Exact<{
  input: RunFixMissingS3ObjectKeysOnReportAttachmentsInput;
}>;


export type MutateFixMissingS3ObjectKeysMutation = { __typename?: 'Mutation', runFixMissingS3ObjectKeysOnReportAttachment?: { __typename?: 'RunFixMissingS3ObjectKeysOnReportAttachmentsPayload', clientMutationId?: string | null } | null };

export type MutateFloorplanAnchorsMutationVariables = Exact<{
  input: UpdateFloorPlanLevelInput;
}>;


export type MutateFloorplanAnchorsMutation = { __typename?: 'Mutation', updateFloorPlanLevel?: { __typename?: 'UpdateFloorPlanLevelPayload', floorPlanLevel: { __typename?: 'FloorPlanLevelType', id: string, floorName: string, floorPlanInspectionId: string, image: { __typename?: 'ActiveStorageBlob', id: string, cdnUrl: string, url: string, filename: string }, floorPlanAnchors: Array<{ __typename?: 'FloorPlanAnchorType', id: string, x: number, y: number, floorPlanLevelId: string, reportAttachmentId: string }> } } | null };

export type GeneratePhotoSphereImagesZipMutationVariables = Exact<{
  input: GeneratePhotoSphereImagesZipInput;
}>;


export type GeneratePhotoSphereImagesZipMutation = { __typename?: 'Mutation', generatePhotoSphereImagesZip?: { __typename?: 'GeneratePhotoSphereImagesZipPayload', photoSphereImagesZipActiveStorageBlob: { __typename?: 'ActiveStorageBlob', filename: string, cdnUrl: string } } | null };

export type MutateInspectionScopeItemMutationVariables = Exact<{
  input: UpdateInspectionScopeItemInput;
}>;


export type MutateInspectionScopeItemMutation = { __typename?: 'Mutation', updateInspectionScopeItem?: { __typename?: 'UpdateInspectionScopeItemPayload', inspectionScopeItem?: { __typename?: 'InspectionScopeItemType', id: string, name?: string | null, description?: string | null, orderUnitId?: string | null, budget?: number | null, progress?: number | null, disbursement?: number | null, clientDisbursement?: number | null, previousDisbursement?: number | null, orderUnit?: { __typename?: 'OrderUnitType', id: string, name?: string | null } | null, previousInspectionScopeItem?: { __typename?: 'InspectionScopeItemType', id: string, name?: string | null, description?: string | null, orderUnitId?: string | null, budget?: number | null, progress?: number | null, disbursement?: number | null, clientDisbursement?: number | null, previousDisbursement?: number | null, orderUnit?: { __typename?: 'OrderUnitType', id: string, name?: string | null } | null } | null } | null } | null };

export type MutatePermitsPdfMutationVariables = Exact<{
  input: GeneratePropertyPermitPdfReportInput;
}>;


export type MutatePermitsPdfMutation = { __typename?: 'Mutation', generatePropertyPermitPdfReport?: { __typename?: 'GeneratePropertyPermitPdfReportPayload', permitPdfReportActiveStorageBlob: { __typename?: 'ActiveStorageBlob', id: string, filename: string, byteSize: any, contentType?: string | null, cdnUrl: string, url: string, createdAt?: any | null } } | null };

export type MutatePropertyGeneratePermitPdfMutationVariables = Exact<{
  input: GeneratePropertyPermitPdfReportInput;
}>;


export type MutatePropertyGeneratePermitPdfMutation = { __typename?: 'Mutation', generatePropertyPermitPdfReport?: { __typename?: 'GeneratePropertyPermitPdfReportPayload', permitPdfReportActiveStorageBlob: { __typename?: 'ActiveStorageBlob', id: string, contentType?: string | null, filename: string, url: string, byteSize: any, createdAt?: any | null } } | null };

export type PublishReportMutationVariables = Exact<{
  input: PublishReportInput;
}>;


export type PublishReportMutation = { __typename?: 'Mutation', publishReport?: { __typename?: 'PublishReportPayload', report: { __typename?: 'ReportType', id: string, publishedAt?: any | null } } | null };

export type MutateReportFixMissingS3ObjectMutationVariables = Exact<{
  input: RunFixMissingS3ObjectKeysOnReportAttachmentsInput;
}>;


export type MutateReportFixMissingS3ObjectMutation = { __typename?: 'Mutation', runFixMissingS3ObjectKeysOnReportAttachment?: { __typename?: 'RunFixMissingS3ObjectKeysOnReportAttachmentsPayload', clientMutationId?: string | null } | null };

export type MutateReportPdfMutationVariables = Exact<{
  input: GeneratePdfReportInput;
}>;


export type MutateReportPdfMutation = { __typename?: 'Mutation', generatePdfReport?: { __typename?: 'GeneratePdfReportPayload', pdfReportActiveStorageBlob: { __typename?: 'ActiveStorageBlob', id: string, filename: string, byteSize: any, contentType?: string | null, cdnUrl: string, url: string, createdAt?: any | null } } | null };

export type MutateTipaltiUrlMutationVariables = Exact<{
  input: GenerateTipaltiIframeUrlInput;
}>;


export type MutateTipaltiUrlMutation = { __typename?: 'Mutation', generateTipaltiIframeUrl?: { __typename?: 'GenerateTipaltiIframeUrlPayload', iframeUrl: string } | null };

export type MutateWarrantyClaimMutationVariables = Exact<{
  input: WarrantyClaimInput;
}>;


export type MutateWarrantyClaimMutation = { __typename?: 'Mutation', warrantyClaim?: { __typename?: 'WarrantyClaimPayload', inspectionWarranty?: { __typename?: 'InspectionWarrantyType', createdAt?: any | null, expirationDate?: any | null, id: string, inspectionId: string, startDate?: any | null, status: string } | null } | null };

export type MutateWarrantyOwnershipMutationVariables = Exact<{
  input: WarrantyProveOwnershipInput;
}>;


export type MutateWarrantyOwnershipMutation = { __typename?: 'Mutation', warrantyProveOwnership?: { __typename?: 'WarrantyProveOwnershipPayload', inspectionWarranty?: { __typename?: 'InspectionWarrantyType', createdAt?: any | null, expirationDate?: any | null, id: string, inspectionId: string, startDate?: any | null, status: string } | null } | null };

export type CreateInspectorOnboardingMutationVariables = Exact<{
  input: CreateInspectorOnboardingInput;
}>;


export type CreateInspectorOnboardingMutation = { __typename?: 'Mutation', createInspectorOnboarding?: { __typename?: 'CreateInspectorOnboardingPayload', inspectorOnboarding?: { __typename?: 'InspectorOnboardingType', id: string, completedStep: string } | null } | null };

export type CreateSurveyorOnboardingMutationVariables = Exact<{
  input: CreateSurveyorOnboardingInput;
}>;


export type CreateSurveyorOnboardingMutation = { __typename?: 'Mutation', createSurveyorOnboarding?: { __typename?: 'CreateSurveyorOnboardingPayload', surveyorOnboarding?: { __typename?: 'SurveyorOnboardingType', id: string, completedStep: string } | null } | null };

export type MutateInspectorOnboardingMutationVariables = Exact<{
  input: UpdateInspectorOnboardingInput;
}>;


export type MutateInspectorOnboardingMutation = { __typename?: 'Mutation', updateInspectorOnboarding?: { __typename?: 'UpdateInspectorOnboardingPayload', inspectorOnboarding?: { __typename?: 'InspectorOnboardingType', id: string, appLoggedIn: boolean, canSetPassword: boolean, completedStep: string, createdAt?: any | null, misaSigned: boolean, onboardingTrackerDismissedAt?: any | null, paymentDetailsFilled: boolean, status: string, updatedAt?: any | null, usersAdded: boolean, contractor?: { __typename?: 'ContractorType', id: string, contractorType?: string | null, city?: string | null, state?: string | null, country?: string | null, businessZipCode?: string | null, preferredInspectorStatus?: string | null, businessContactName?: string | null, businessPhone?: string | null, businessEmail?: string | null, businessName?: string | null, businessSite?: string | null, businessAddress?: string | null, schedulerName?: string | null, schedulerPhone?: string | null, schedulerEmail?: string | null, serviceZipCodes?: Array<string> | null, serviceAreaRadiusMileage?: number | null, hasSupra?: boolean | null, hasSentrilock?: boolean | null, reportWritingSoftware?: string | null, msaSigned?: boolean | null, tipaltiIsPayable?: boolean | null, stateLicenseNumber?: string | null, ashiLicenseNumber?: string | null, internachiLicenseNumber?: string | null, otherLicenseNumber?: string | null, logo?: { __typename?: 'ActiveStorageBlob', url: string } | null, fileAttachments: Array<{ __typename?: 'FileAttachment', id: string, category: string, createdAt?: any | null, attachment?: { __typename?: 'ActiveStorageBlob', id: string, cdnUrl: string, url: string, filename: string } | null }>, contractorPricings: Array<{ __typename?: 'ContractorPricing', name: string, description?: string | null, active: boolean, allowCustomPricing: boolean }> } | null } | null } | null };

export type MutateSurveyorOnboardingMutationVariables = Exact<{
  input: UpdateSurveyorOnboardingInput;
}>;


export type MutateSurveyorOnboardingMutation = { __typename?: 'Mutation', updateSurveyorOnboarding?: { __typename?: 'UpdateSurveyorOnboardingPayload', surveyorOnboarding?: { __typename?: 'SurveyorOnboardingType', id: string, appLoggedIn: boolean, backgroundCheckRequired: boolean, backgroundCheckSubmittedAt?: any | null, canSetPassword: boolean, completedStep: string, createdAt?: any | null, misaSigned: boolean, onboardingTrackerDismissedAt?: any | null, paymentDetailsFilled: boolean, status: string, submitBackgroundCheckUrl?: string | null, updatedAt?: any | null, contractor?: { __typename?: 'ContractorType', id: string, contractorType?: string | null, city?: string | null, state?: string | null, country?: string | null, businessZipCode?: string | null, preferredInspectorStatus?: string | null, businessContactName?: string | null, businessPhone?: string | null, businessEmail?: string | null, businessName?: string | null, businessSite?: string | null, businessAddress?: string | null, schedulerName?: string | null, schedulerPhone?: string | null, schedulerEmail?: string | null, serviceZipCodes?: Array<string> | null, serviceAreaRadiusMileage?: number | null, hasSupra?: boolean | null, hasSentrilock?: boolean | null, reportWritingSoftware?: string | null, msaSigned?: boolean | null, tipaltiIsPayable?: boolean | null, stateLicenseNumber?: string | null, ashiLicenseNumber?: string | null, internachiLicenseNumber?: string | null, otherLicenseNumber?: string | null, logo?: { __typename?: 'ActiveStorageBlob', url: string } | null, fileAttachments: Array<{ __typename?: 'FileAttachment', id: string, category: string, createdAt?: any | null, attachment?: { __typename?: 'ActiveStorageBlob', id: string, cdnUrl: string, url: string, filename: string } | null }>, contractorPricings: Array<{ __typename?: 'ContractorPricing', name: string, description?: string | null, active: boolean, allowCustomPricing: boolean }> } | null } | null } | null };

export type CreateRehabProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateRehabProjectMutation = { __typename?: 'Mutation', createRehabProject?: { __typename?: 'CreateProjectPayload', project?: { __typename?: 'ProjectType', id: string } | null } | null };

export type CreateRehabWorkItemMutationVariables = Exact<{
  input: CreateWorkItemInput;
}>;


export type CreateRehabWorkItemMutation = { __typename?: 'Mutation', createRehabWorkItem?: { __typename?: 'CreateWorkItemPayload', workItem?: { __typename?: 'WorkItemType', id: string, systemName: string, subsystemName?: string | null, title: string, details: string, unit?: string | null, quantity?: number | null, pricePerUnit?: number | null, totalPrice?: number | null, projectId?: string | null, pricingExternalId?: string | null, tags: Array<string>, displayIndex: number, workItemAssociations: Array<{ __typename?: 'WorkItemAssociationType', id: string, workItemId?: string | null, itemId?: string | null, itemType?: string | null, data?: any | null }>, workItemAttachments: Array<{ __typename?: 'WorkItemAttachmentType', id: string, workItemId: string, workItemAssociationId?: string | null, s3ObjectKey?: string | null, attachmentUrl?: string | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', url: string, width: string }> }>, templateWorkItemPricing?: { __typename?: 'TemplateWorkItemPricingType', id: string, pricingExternalId?: string | null, details?: string | null, unit?: string | null, pricePerUnit?: number | null, lumpSumPrice?: number | null, teamMarketId?: string | null, templateWorkItem?: { __typename?: 'TemplateWorkItemType', id: string, teamId: string, systemName?: string | null, title?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null } | null };

export type CreateRehabWorkItemAssociationMutationVariables = Exact<{
  input: CreateWorkItemAssociationInput;
}>;


export type CreateRehabWorkItemAssociationMutation = { __typename?: 'Mutation', createRehabWorkItemAssociation?: { __typename?: 'CreateWorkItemAssociationPayload', workItemAssociation?: { __typename?: 'WorkItemAssociationType', id: string, workItemId?: string | null, itemId?: string | null, itemType?: string | null, data?: any | null } | null } | null };

export type CreateRehabWorkItemAttachmentMutationVariables = Exact<{
  input: CreateWorkItemAttachmentInput;
}>;


export type CreateRehabWorkItemAttachmentMutation = { __typename?: 'Mutation', createRehabWorkItemAttachment?: { __typename?: 'CreateWorkItemAttachmentPayload', workItemAttachment?: { __typename?: 'WorkItemAttachmentType', id: string, workItemId: string, workItemAssociationId?: string | null, s3ObjectKey?: string | null, attachmentUrl?: string | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', url: string, width: string }> } | null } | null };

export type CreateRehabWorkItemContributorMutationVariables = Exact<{
  input: CreateWorkItemContributorInput;
}>;


export type CreateRehabWorkItemContributorMutation = { __typename?: 'Mutation', createRehabWorkItemContributor?: { __typename?: 'CreateWorkItemContributorPayload', clientMutationId?: string | null, workItemContributor?: { __typename?: 'WorkItemContributorType', id: string, workItemId?: string | null, name?: string | null, amount?: number | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type DeleteRehabWorkItemMutationVariables = Exact<{
  input: DeleteWorkItemInput;
}>;


export type DeleteRehabWorkItemMutation = { __typename?: 'Mutation', deleteRehabWorkItem?: { __typename?: 'DeleteWorkItemPayload', workItem?: { __typename?: 'WorkItemType', id: string } | null } | null };

export type DeleteRehabWorkItemAssociationMutationVariables = Exact<{
  input: DeleteWorkItemAssociationInput;
}>;


export type DeleteRehabWorkItemAssociationMutation = { __typename?: 'Mutation', deleteRehabWorkItemAssociation?: { __typename?: 'DeleteWorkItemAssociationPayload', workItemAssociation?: { __typename?: 'WorkItemAssociationType', id: string } | null } | null };

export type DeleteRehabWorkItemAttachmentMutationVariables = Exact<{
  input: DeleteWorkItemAttachmentInput;
}>;


export type DeleteRehabWorkItemAttachmentMutation = { __typename?: 'Mutation', deleteRehabWorkItemAttachment?: { __typename?: 'DeleteWorkItemAttachmentPayload', workItemAttachment?: { __typename?: 'WorkItemAttachmentType', id: string } | null } | null };

export type DeleteRehabWorkItemContributorMutationVariables = Exact<{
  input: DeleteWorkItemContributorInput;
}>;


export type DeleteRehabWorkItemContributorMutation = { __typename?: 'Mutation', deleteRehabWorkItemContributor?: { __typename?: 'DeleteWorkItemContributorPayload', clientMutationId?: string | null, workItemContributor?: { __typename?: 'WorkItemContributorType', id: string, workItemId?: string | null, name?: string | null, amount?: number | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type DeleteTeamCustomSystemMutationVariables = Exact<{
  input: DeleteTeamCustomSystemInput;
}>;


export type DeleteTeamCustomSystemMutation = { __typename?: 'Mutation', deleteTeamCustomSystem?: { __typename?: 'DeleteTeamCustomSystemPayload', teamCustomSystem?: { __typename?: 'TeamCustomSystemType', id: string } | null } | null };

export type MutateRehabProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type MutateRehabProjectMutation = { __typename?: 'Mutation', updateRehabProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'ProjectType', id: string, name: string, propertyId?: string | null, teamId?: string | null, reportId?: string | null, publishedAt?: any | null, teamMarketId?: string | null } | null } | null };

export type MutateRehabProjectGenerateCsvMutationVariables = Exact<{
  input: GenerateProjectCsvInput;
}>;


export type MutateRehabProjectGenerateCsvMutation = { __typename?: 'Mutation', generateRehabProjectCsv?: { __typename?: 'GenerateProjectCsvPayload', rehabProjectCsvActiveStorageBlob: { __typename?: 'ActiveStorageBlob', id: string, contentType?: string | null, filename: string, url: string, byteSize: any, createdAt?: any | null } } | null };

export type MutateRehabProjectGeneratePdfMutationVariables = Exact<{
  input: GenerateProjectPdfInput;
}>;


export type MutateRehabProjectGeneratePdfMutation = { __typename?: 'Mutation', generateRehabProjectPdf?: { __typename?: 'GenerateProjectPdfPayload', rehabProjectPdfActiveStorageBlob: { __typename?: 'ActiveStorageBlob', id: string, contentType?: string | null, filename: string, url: string, byteSize: any, createdAt?: any | null } } | null };

export type PopulateTeamCustomSystemMutationVariables = Exact<{
  input: PopulateTeamCustomSystemInput;
}>;


export type PopulateTeamCustomSystemMutation = { __typename?: 'Mutation', populateTeamCustomSystem?: { __typename?: 'PopulateTeamCustomSystemPayload', populateTeamCustomSystem?: { __typename?: 'TeamCustomSystemType', id: string, teamId: string, name: string, subsystemNames: Array<string> } | null } | null };

export type PublishRehabProjectMutationVariables = Exact<{
  input: PublishProjectInput;
}>;


export type PublishRehabProjectMutation = { __typename?: 'Mutation', publishRehabProject?: { __typename?: 'PublishProjectPayload', project?: { __typename?: 'ProjectType', id: string, publishedAt?: any | null } | null } | null };

export type UpdateRehabWorkItemMutationVariables = Exact<{
  input: UpdateWorkItemInput;
}>;


export type UpdateRehabWorkItemMutation = { __typename?: 'Mutation', updateRehabWorkItem?: { __typename?: 'UpdateWorkItemPayload', workItem?: { __typename?: 'WorkItemType', id: string, projectId?: string | null, systemName: string, subsystemName?: string | null, title: string, details: string, quantity?: number | null, unit?: string | null, pricePerUnit?: number | null, totalPrice?: number | null, tags: Array<string>, templateWorkItemPricingId?: string | null, pricingExternalId?: string | null, displayIndex: number, workItemAssociations: Array<{ __typename?: 'WorkItemAssociationType', id: string, workItemId?: string | null, itemId?: string | null, itemType?: string | null, data?: any | null }>, workItemAttachments: Array<{ __typename?: 'WorkItemAttachmentType', id: string, workItemId: string, workItemAssociationId?: string | null, s3ObjectKey?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', url: string, width: string }> }>, workItemContributors: Array<{ __typename?: 'WorkItemContributorType', amount?: number | null, createdAt?: any | null, id: string, name?: string | null, updatedAt?: any | null, workItemId?: string | null }> } | null } | null };

export type UpdateWorkItemContributorMutationVariables = Exact<{
  input: UpdateWorkItemContributorInput;
}>;


export type UpdateWorkItemContributorMutation = { __typename?: 'Mutation', updateRehabWorkItemContributor?: { __typename?: 'UpdateWorkItemContributorPayload', clientMutationId?: string | null, workItemContributor?: { __typename?: 'WorkItemContributorType', id: string, workItemId?: string | null, name?: string | null, amount?: number | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'CreateUserPayload', user?: { __typename?: 'UserType', id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, grantedPermissions: Array<string>, archivedAt?: any | null, activatedAt?: any | null } | null } | null };

export type CreateUserContractorMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserContractorMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'CreateUserPayload', user?: { __typename?: 'UserType', contractorId?: string | null } | null } | null };

export type MutateCheckVerificationSmsMutationVariables = Exact<{
  input: CheckVerificationSmsInput;
}>;


export type MutateCheckVerificationSmsMutation = { __typename?: 'Mutation', checkVerificationSms?: { __typename?: 'CheckVerificationSmsPayload', token?: string | null } | null };

export type MutateContractorDetailsMutationVariables = Exact<{
  input: UpdateContractorInput;
}>;


export type MutateContractorDetailsMutation = { __typename?: 'Mutation', updateContractor?: { __typename?: 'UpdateContractorPayload', contractor?: { __typename?: 'ContractorType', id: string, contractorType?: string | null, businessName?: string | null, businessSite?: string | null, latitude?: number | null, longitude?: number | null, certifications?: string | null, ashiLicenseNumber?: string | null, internachiLicenseNumber?: string | null, otherLicenseNumber?: string | null, stateLicenseNumber?: string | null, inBusinessSince?: number | null, state?: string | null, country?: string | null, preferredInspectorStatus?: string | null, instantBookingEnabled?: boolean | null, businessContactName?: string | null, businessPhone?: string | null, businessEmail?: string | null, businessAddress?: string | null, schedulerName?: string | null, schedulerPhone?: string | null, schedulerEmail?: string | null, sendAutomatedSms?: boolean | null, serviceZipCodes?: Array<string> | null, serviceAreaRadiusMileage?: number | null, hasSupra?: boolean | null, reportWritingSoftware?: string | null, msaSigned?: boolean | null, token?: string | null, tipaltiIsPayable?: boolean | null, logo?: { __typename?: 'ActiveStorageBlob', url: string } | null } | null } | null };

export type MutateInviteResendMutationVariables = Exact<{
  input: ResendInviteInput;
}>;


export type MutateInviteResendMutation = { __typename?: 'Mutation', resendInvite?: { __typename?: 'ResendInvitePayload', user?: { __typename?: 'UserType', id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, grantedPermissions: Array<string>, archivedAt?: any | null, activatedAt?: any | null } | null } | null };

export type MutateSendVerificationSmsMutationVariables = Exact<{
  input: SendVerificationSmsInput;
}>;


export type MutateSendVerificationSmsMutation = { __typename?: 'Mutation', sendVerificationSms?: { __typename?: 'SendVerificationSmsPayload', clientMutationId?: string | null } | null };

export type MutateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type MutateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'UserType', id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, grantedPermissions: Array<string>, archivedAt?: any | null, activatedAt?: any | null } | null } | null };

export type MutateUserInvitationMutationVariables = Exact<{
  input: ResendInviteInput;
}>;


export type MutateUserInvitationMutation = { __typename?: 'Mutation', resendInvite?: { __typename?: 'ResendInvitePayload', user?: { __typename?: 'UserType', id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, grantedPermissions: Array<string>, archivedAt?: any | null, activatedAt?: any | null } | null } | null };

export type GetJobQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobQuery = { __typename?: 'Query', jobs?: { __typename?: 'JobTypeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'JobType', id: string, scheduledTime: any, status: JobStatus, isFee: boolean, isGoAnytime: boolean, isMock: boolean, reports: Array<{ __typename?: 'ReportType', id: string, templateReportIds: Array<string>, templateNames: Array<string>, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, pdfDocumentUrl?: string | null, originalReportId?: string | null, noDeficienciesAllowed: boolean, noLimitationsAllowed: boolean, geotaggingRequired: boolean, complianceText?: string | null, inspectionDocuments: Array<{ __typename?: 'InspectionDocumentType', id: string, documentType: string, externalDocumentUrl: string, document?: { __typename?: 'ActiveStorageBlob', filename: string } | null }>, reportSystems: Array<{ __typename?: 'ReportSystemType', id: string }> }>, order: { __typename?: 'OrderType', id: string, accessInformation?: string | null, contingencyDate?: any | null, createdAt?: any | null, inspectionSchedulingDeadline?: any | null, readOnlyToken?: string | null, isPaywall?: boolean | null, status: string, teamExternalId?: string | null, occupancyInfo?: string | null, isMock: boolean, teamId: string, propertyId: string, property?: { __typename?: 'PropertyType', id: string, address: string, street?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, homeType?: string | null, totalSquareFeet?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, timezone?: string | null, latitude?: number | null, longitude?: number | null, photo?: { __typename?: 'ActiveStorageBlob', url: string } | null } | null, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string, status?: string | null, isPaid?: boolean | null, orderId: string, inspectionWarranty?: { __typename?: 'InspectionWarrantyType', id: string, inspectionId: string, status: string, startDate?: any | null, expirationDate?: any | null, createdAt?: any | null, updatedAt?: any | null, inspection?: { __typename?: 'InspectionType', orderId: string } | null } | null, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, report?: { __typename?: 'ReportType', id: string } | null }>, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, totalFee?: number | null, scheduledAt?: any | null, contractorId: string } | null }>, team?: { __typename?: 'TeamType', id: string, hideContactInformationOnReport: boolean, drawSummaryTableDisplay: DrawSummaryTableDisplay, includeDrawDisbursementFields: boolean, companyId: string } | null }, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string, geotaggingRequired: boolean, orderId: string, scheduledProposalId?: string | null, status?: string | null, templateReportId?: string | null, createdAt?: any | null, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, inspectionId: string, contractorId: string, scheduledAt?: any | null, totalFee?: number | null, contractorFee?: number | null, contractorPaidAt?: any | null, teamInternalUserTypeId?: string | null, isGoAnytime?: boolean | null } | null }> } | null> | null } | null };

export type GetJobDetailsQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetJobDetailsQuery = { __typename?: 'Query', orderByToken?: { __typename?: 'OrderType', id: string, accessInformation?: string | null, contingencyDate?: any | null, createdAt?: any | null, inspectionSchedulingDeadline?: any | null, readOnlyToken?: string | null, isPaywall?: boolean | null, status: string, teamExternalId?: string | null, occupancyInfo?: string | null, isMock: boolean, teamId: string, propertyId: string, orderStakeholders: Array<{ __typename?: 'OrderStakeholderType', id: string, email?: string | null, name?: string | null, phone?: string | null, stakeholderType: string, isClient?: boolean | null }>, property?: { __typename?: 'PropertyType', id: string, address: string, street?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, homeType?: string | null, totalSquareFeet?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, timezone?: string | null, latitude?: number | null, longitude?: number | null, photo?: { __typename?: 'ActiveStorageBlob', url: string } | null } | null, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string, status?: string | null, isPaid?: boolean | null, orderId: string, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, scheduledAt?: any | null, isGoAnytime?: boolean | null, contractorPaidAt?: any | null, contractorFee?: number | null, totalFee?: number | null, contractorPaymentPlatform: ContractorPaymentPlatform, contractorId: string } | null, templateReport?: { __typename?: 'TemplateReportType', id: string, name: string } | null, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, report?: { __typename?: 'ReportType', id: string, pdfDocumentUrl?: string | null, updatedAt?: any | null, publishedAt?: any | null, inspectionDocuments: Array<{ __typename?: 'InspectionDocumentType', id: string, updatedAt?: any | null, document?: { __typename?: 'ActiveStorageBlob', id: string, filename: string, url: string, cdnUrl: string } | null }> } | null }>, inspectionWarranty?: { __typename?: 'InspectionWarrantyType', id: string, inspectionId: string, status: string, startDate?: any | null, expirationDate?: any | null, createdAt?: any | null, updatedAt?: any | null, inspection?: { __typename?: 'InspectionType', orderId: string } | null } | null }>, team?: { __typename?: 'TeamType', id: string, hideContactInformationOnReport: boolean, drawSummaryTableDisplay: DrawSummaryTableDisplay, includeDrawDisbursementFields: boolean, companyId: string } | null } | null };

export type GetJobsQueryVariables = Exact<{
  status?: InputMaybe<JobStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scheduledOnGte?: InputMaybe<Scalars['ISO8601Date']['input']>;
  scheduledOnLte?: InputMaybe<Scalars['ISO8601Date']['input']>;
  includeAllGoAnytime?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetJobsQuery = { __typename?: 'Query', jobs?: { __typename?: 'JobTypeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'JobType', id: string, status: JobStatus, isGoAnytime: boolean, isMock: boolean, scheduledTime: any, order: { __typename?: 'OrderType', id: string, readOnlyToken?: string | null, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string }>, property?: { __typename?: 'PropertyType', id: string, address: string, street?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, homeType?: string | null, totalSquareFeet?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, timezone?: string | null, latitude?: number | null, longitude?: number | null, photo?: { __typename?: 'ActiveStorageBlob', url: string } | null } | null }, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string, status?: string | null, templateReportId?: string | null }> } | null> | null } | null };

export type GetInspectorOnboardingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInspectorOnboardingQuery = { __typename?: 'Query', inspectorOnboarding?: { __typename?: 'InspectorOnboardingType', id: string, appLoggedIn: boolean, canSetPassword: boolean, completedStep: string, createdAt?: any | null, isMultiInspectorFirm: boolean, misaSigned: boolean, onboardingTrackerDismissedAt?: any | null, paymentDetailsFilled: boolean, status: string, updatedAt?: any | null, usersAdded: boolean, contractor?: { __typename?: 'ContractorType', id: string, contractorType?: string | null, city?: string | null, state?: string | null, country?: string | null, businessZipCode?: string | null, preferredInspectorStatus?: string | null, businessContactName?: string | null, businessPhone?: string | null, businessEmail?: string | null, businessName?: string | null, businessSite?: string | null, businessAddress?: string | null, schedulerName?: string | null, schedulerPhone?: string | null, schedulerEmail?: string | null, serviceZipCodes?: Array<string> | null, serviceAreaRadiusMileage?: number | null, hasSupra?: boolean | null, hasSentrilock?: boolean | null, reportWritingSoftware?: string | null, msaSigned?: boolean | null, tipaltiIsPayable?: boolean | null, stateLicenseNumber?: string | null, ashiLicenseNumber?: string | null, internachiLicenseNumber?: string | null, otherLicenseNumber?: string | null, logo?: { __typename?: 'ActiveStorageBlob', url: string } | null, fileAttachments: Array<{ __typename?: 'FileAttachment', id: string, category: string, createdAt?: any | null, attachment?: { __typename?: 'ActiveStorageBlob', id: string, cdnUrl: string, url: string, filename: string } | null }>, contractorPricings: Array<{ __typename?: 'ContractorPricing', name: string, description?: string | null, active: boolean, allowCustomPricing: boolean }> } | null } | null };

export type GetSurveyorOnboardingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSurveyorOnboardingQuery = { __typename?: 'Query', surveyorOnboarding?: { __typename?: 'SurveyorOnboardingType', id: string, appLoggedIn: boolean, backgroundCheckRequired: boolean, backgroundCheckSubmittedAt?: any | null, canSetPassword: boolean, completedStep: string, createdAt?: any | null, marketSaturatedAtOnboardingTime: boolean, misaSigned: boolean, onboardingTrackerDismissedAt?: any | null, paymentDetailsFilled: boolean, status: string, submitBackgroundCheckUrl?: string | null, updatedAt?: any | null, contractor?: { __typename?: 'ContractorType', id: string, contractorType?: string | null, city?: string | null, state?: string | null, country?: string | null, businessZipCode?: string | null, preferredInspectorStatus?: string | null, businessContactName?: string | null, businessPhone?: string | null, businessEmail?: string | null, businessName?: string | null, businessSite?: string | null, businessAddress?: string | null, schedulerName?: string | null, schedulerPhone?: string | null, schedulerEmail?: string | null, serviceZipCodes?: Array<string> | null, serviceAreaRadiusMileage?: number | null, hasSupra?: boolean | null, hasSentrilock?: boolean | null, reportWritingSoftware?: string | null, msaSigned?: boolean | null, tipaltiIsPayable?: boolean | null, stateLicenseNumber?: string | null, ashiLicenseNumber?: string | null, internachiLicenseNumber?: string | null, otherLicenseNumber?: string | null, logo?: { __typename?: 'ActiveStorageBlob', url: string } | null, fileAttachments: Array<{ __typename?: 'FileAttachment', id: string, category: string, createdAt?: any | null, attachment?: { __typename?: 'ActiveStorageBlob', id: string, cdnUrl: string, url: string, filename: string } | null }>, contractorPricings: Array<{ __typename?: 'ContractorPricing', name: string, description?: string | null, active: boolean, allowCustomPricing: boolean }> } | null } | null };

export type GetAllDownloadLinksForOrderQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetAllDownloadLinksForOrderQuery = { __typename?: 'Query', orderByToken?: { __typename?: 'OrderType', id: string, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, report?: { __typename?: 'ReportType', inspectionDocuments: Array<{ __typename?: 'InspectionDocumentType', id: string, externalDocumentUrl: string, document?: { __typename?: 'ActiveStorageBlob', id: string, url: string, cdnUrl: string, contentType?: string | null, filename: string } | null }> } | null }> }> } | null };

export type GetOrderByTokenQueryVariables = Exact<{
  orderToken: Scalars['String']['input'];
}>;


export type GetOrderByTokenQuery = { __typename?: 'Query', orderByToken?: { __typename?: 'OrderType', id: string, accessInformation?: string | null, contingencyDate?: any | null, createdAt?: any | null, inspectionSchedulingDeadline?: any | null, readOnlyToken?: string | null, isPaywall?: boolean | null, status: string, teamExternalId?: string | null, occupancyInfo?: string | null, isMock: boolean, teamId: string, propertyId: string, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionType: string, status?: string | null, isPaid?: boolean | null, orderId: string, inspectionWarranty?: { __typename?: 'InspectionWarrantyType', id: string, inspectionId: string, status: string, startDate?: any | null, expirationDate?: any | null, createdAt?: any | null, updatedAt?: any | null, inspection?: { __typename?: 'InspectionType', orderId: string } | null } | null, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, report?: { __typename?: 'ReportType', id: string } | null }>, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, totalFee?: number | null, scheduledAt?: any | null, contractorId: string } | null }>, team?: { __typename?: 'TeamType', id: string, hideContactInformationOnReport: boolean, drawSummaryTableDisplay: DrawSummaryTableDisplay, includeDrawDisbursementFields: boolean, companyId: string } | null } | null };

export type GetOrderPropertyPhotoQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetOrderPropertyPhotoQuery = { __typename?: 'Query', orderByToken?: { __typename?: 'OrderType', id: string, property?: { __typename?: 'PropertyType', id: string, address: string, city?: string | null, zipCode?: string | null, state?: string | null, street?: string | null, street2?: string | null, timezone?: string | null, latitude?: number | null, longitude?: number | null, photo?: { __typename?: 'ActiveStorageBlob', id: string, cdnUrl: string, url: string } | null } | null } | null };

export type GetOrderStakeholderInformationQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetOrderStakeholderInformationQuery = { __typename?: 'Query', orderByToken?: { __typename?: 'OrderType', id: string, teamExternalId?: string | null, communityName?: string | null, floorPlanName?: string | null, orderStakeholders: Array<{ __typename?: 'OrderStakeholderType', id: string, name?: string | null, email?: string | null, phone?: string | null, stakeholderType: string, isClient?: boolean | null }> } | null };

export type GetPermitReportQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetPermitReportQuery = { __typename?: 'Query', order?: { __typename?: 'OrderType', accessInformation?: string | null, id: string, propertyId: string, updatedAt?: any | null, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, report?: { __typename?: 'ReportType', id: string, pdfDocumentUrl?: string | null, inspectionDocuments: Array<{ __typename?: 'InspectionDocumentType', id: string, updatedAt?: any | null, document?: { __typename?: 'ActiveStorageBlob', id: string, filename: string, url: string, cdnUrl: string, createdAt?: any | null } | null }> } | null }> }>, property?: { __typename?: 'PropertyType', id: string, country?: string | null, state?: string | null, city?: string | null, zipCode?: string | null, street?: string | null, street2?: string | null, address: string, photo?: { __typename?: 'ActiveStorageBlob', cdnUrl: string } | null, permits: Array<{ __typename?: 'PermitType', id: string, description?: string | null, fees?: string | null, fileDate?: string | null, finalDate?: string | null, issueDate?: string | null, jurisdiction?: string | null, number?: string | null, status?: string | null, jobValue?: string | null, permitSubtype?: string | null, permitType?: string | null, source?: string | null, shovelsContractorId?: string | null, shovelsPermitId?: string | null, createdAt?: any | null, updatedAt?: any | null, permitContractorId?: string | null, permitContractor?: { __typename?: 'PermitContractorType', id: string, businessName?: string | null, city?: string | null, email?: string | null, license?: string | null, name?: string | null, phone?: string | null, state?: string | null, street?: string | null, streetNo?: string | null, zipcode?: string | null, shovelsContractorId?: string | null, createdAt?: any | null, updatedAt?: any | null } | null }> } | null } | null };

export type GetPermitsSummaryQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetPermitsSummaryQuery = { __typename?: 'Query', order?: { __typename?: 'OrderType', updatedAt?: any | null, property?: { __typename?: 'PropertyType', id: string, permits: Array<{ __typename?: 'PermitType', id: string, fileDate?: string | null, finalDate?: string | null, issueDate?: string | null, createdAt?: any | null, updatedAt?: any | null }> } | null } | null };

export type GetProjectHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProjectHistoryQuery = { __typename?: 'Query', projectHistory: { __typename?: 'ProjectHistoryTypeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'ProjectHistoryTypeEdge', cursor: string, node?: { __typename?: 'ProjectHistoryType', id: string, itemType?: string | null, itemId?: string | null, event?: string | null, createdAt?: any | null, objectChanges?: Array<{ __typename?: 'ObjectChangeType', fieldName?: string | null, oldValue?: string | null, newValue?: string | null }> | null, user?: { __typename?: 'UserType', id: string, name?: string | null, email?: string | null } | null } | null } | null> | null } };

export type GetRehabProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  resizedAttachmentWidths?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  rotatedAttachmentDegrees?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetRehabProjectQuery = { __typename?: 'Query', rehabProject?: { __typename?: 'ProjectType', id: string, name: string, propertyId?: string | null, teamId?: string | null, reportId?: string | null, publishedAt?: any | null, teamMarketId?: string | null, property?: { __typename?: 'PropertyType', id: string, address: string, street?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, homeType?: string | null, totalSquareFeet?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, timezone?: string | null, photo?: { __typename?: 'ActiveStorageBlob', cdnUrl: string } | null } | null, report?: { __typename?: 'ReportType', id: string, orderId?: string | null, templateReportIds: Array<string>, templateNames: Array<string>, pdfDocumentUrl?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, noDeficienciesAllowed: boolean, noLimitationsAllowed: boolean, geotaggingRequired: boolean, originalReportId?: string | null, complianceText?: string | null, reportSystems: Array<{ __typename?: 'ReportSystemType', id: string, reportId: string, catalogSystemId: string, templateSystemIds: Array<string>, name: string, standardText?: string | null, updatedAt?: any | null, displayIndex?: number | null, includeOnReport: boolean, reportSystemGroupId?: string | null, reportSubsystems: Array<{ __typename?: 'ReportSubsystemType', id: string, reportSystemId: string, catalogSubsystemId: string, templateSubsystemIds: Array<string>, status: string, name: string, note?: string | null, updatedAt?: any | null, displayIndex?: number | null, includeOnReport: boolean, includeOnReportIfNotPresent?: boolean | null, multiUseSubsystemName?: string | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportInformations: Array<{ __typename?: 'ReportInformationType', id: string, reportSubsystemId: string, reportLimitationId?: string | null, catalogInformationId: string, note?: string | null, title: string, dataName: string, detail?: string | null, value?: string | null, questionType: string, units?: string | null, status: ReportInformationStatus, cannotAnswerReason?: ReportInformationCannotAnswerReason | null, allowsOther: boolean, requiresLocations: boolean, requiresMedias: number, requiresMediaOrientation: string, requiresMediaType: string, requiresDeficiencyCondition?: any | null, requiresDeficiencyCatalogDeficiencyId?: string | null, inspectionScopeItemId?: string | null, isMultiSelect: boolean, options?: Array<string> | null, displayIndex: number, tags?: any | null, updatedAt?: any | null, conditionalFollowupLogic?: string | null, catalogInformation?: { __typename?: 'CatalogInformationType', id: string, autoDeficiencyCondition?: any | null, autoDeficiencyMediaRequired: number } | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, reportApplianceInformation?: { __typename?: 'ReportApplianceInformationType', age?: number | null, brandId?: number | null, brandName?: string | null, createdAt?: any | null, expectedLife?: number | null, id: string, modelNumber?: string | null, monthManufactured?: number | null, possibleYearsManufactured?: Array<number> | null, productFailureRiskScore?: number | null, productId?: number | null, productName?: string | null, recalls?: Array<string> | null, remainingLife?: number | null, reportId: string, reportInformationId: string, serialNumber?: string | null, status?: string | null, subProductId?: number | null, subProductName?: string | null, updatedAt?: any | null, yearManufactured?: number | null, warrantyCovered?: boolean | null, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }> }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, inspectionReports: Array<{ __typename?: 'InspectionReportType', inspection?: { __typename?: 'InspectionType', id: string, orderId: string, inspectionType: string, order?: { __typename?: 'OrderType', teamId: string, team?: { __typename?: 'TeamType', id: string, name?: string | null } | null } | null, inspectionWarranty?: { __typename?: 'InspectionWarrantyType', id: string, status: string, inspectionId: string, expirationDate?: any | null, startDate?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, contractorId: string, scheduledAt?: any | null } | null } | null }>, reportSystemGroups: Array<{ __typename?: 'ReportSystemGroupType', id: string, name?: string | null }> } | null, workItems: Array<{ __typename?: 'WorkItemType', id: string, projectId?: string | null, systemName: string, subsystemName?: string | null, title: string, details: string, quantity?: number | null, unit?: string | null, pricePerUnit?: number | null, totalPrice?: number | null, tags: Array<string>, templateWorkItemPricingId?: string | null, pricingExternalId?: string | null, displayIndex: number, workItemAssociations: Array<{ __typename?: 'WorkItemAssociationType', id: string, workItemId?: string | null, itemId?: string | null, itemType?: string | null, data?: any | null }>, workItemAttachments: Array<{ __typename?: 'WorkItemAttachmentType', id: string, workItemId: string, workItemAssociationId?: string | null, s3ObjectKey?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', url: string, width: string }> }>, workItemContributors: Array<{ __typename?: 'WorkItemContributorType', amount?: number | null, createdAt?: any | null, id: string, name?: string | null, updatedAt?: any | null, workItemId?: string | null }> }>, team?: { __typename?: 'TeamType', id: string, token: string, name?: string | null, rehabTags: Array<string>, canPublishRehabProjects?: boolean | null, allowRehabToolAccess: boolean, enableRehabCostSplitting?: boolean | null, rehabTeamMarkets: Array<{ __typename?: 'TeamMarketType', id: string, name: string, stateAbbreviation: string }>, rehabTeamCustomSystems: Array<{ __typename?: 'TeamCustomSystemType', id: string, teamId: string, name: string, subsystemNames: Array<string> }> } | null } | null };

export type GetRehabProjectReadOnlyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  resizedAttachmentWidths?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetRehabProjectReadOnlyQuery = { __typename?: 'Query', rehabProject?: { __typename?: 'ProjectType', id: string, name: string, propertyId?: string | null, teamId?: string | null, reportId?: string | null, publishedAt?: any | null, teamMarketId?: string | null, property?: { __typename?: 'PropertyType', id: string, address: string, street?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, homeType?: string | null, totalSquareFeet?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, timezone?: string | null, photo?: { __typename?: 'ActiveStorageBlob', cdnUrl: string } | null } | null, workItems: Array<{ __typename?: 'WorkItemType', id: string, projectId?: string | null, systemName: string, subsystemName?: string | null, title: string, details: string, quantity?: number | null, unit?: string | null, pricePerUnit?: number | null, totalPrice?: number | null, tags: Array<string>, templateWorkItemPricingId?: string | null, pricingExternalId?: string | null, displayIndex: number, workItemAssociations: Array<{ __typename?: 'WorkItemAssociationType', id: string, workItemId?: string | null, itemId?: string | null, itemType?: string | null, data?: any | null }>, workItemAttachments: Array<{ __typename?: 'WorkItemAttachmentType', id: string, workItemId: string, workItemAssociationId?: string | null, s3ObjectKey?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', url: string, width: string }> }>, workItemContributors: Array<{ __typename?: 'WorkItemContributorType', amount?: number | null, createdAt?: any | null, id: string, name?: string | null, updatedAt?: any | null, workItemId?: string | null }> }>, team?: { __typename?: 'TeamType', id: string, token: string, name?: string | null, rehabTags: Array<string>, canPublishRehabProjects?: boolean | null, allowRehabToolAccess: boolean, enableRehabCostSplitting?: boolean | null, rehabTeamMarkets: Array<{ __typename?: 'TeamMarketType', id: string, name: string, stateAbbreviation: string }>, rehabTeamCustomSystems: Array<{ __typename?: 'TeamCustomSystemType', id: string, teamId: string, name: string, subsystemNames: Array<string> }> } | null } | null };

export type GetRehabProjectsQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type GetRehabProjectsQuery = { __typename?: 'Query', report?: { __typename?: 'ReportType', id: string, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, inspection?: { __typename?: 'InspectionType', id: string, orderId: string, order?: { __typename?: 'OrderType', teamId: string } | null } | null }> } | null, rehabProjects: { __typename?: 'ProjectTypeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'ProjectTypeEdge', cursor: string, node?: { __typename?: 'ProjectType', id: string, reportId?: string | null, propertyId?: string | null, teamId?: string | null } | null } | null> | null } };

export type GetTemplateWorkItemsQueryVariables = Exact<{
  marketId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTemplateWorkItemsQuery = { __typename?: 'Query', templateWorkItems: { __typename?: 'TemplateWorkItemTypeConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes?: Array<{ __typename?: 'TemplateWorkItemType', id: string, systemName?: string | null, teamId: string, title?: string | null, templateWorkItemPricings?: Array<{ __typename?: 'TemplateWorkItemPricingType', id: string, pricingExternalId?: string | null, details?: string | null, teamMarketId?: string | null, lumpSumPrice?: number | null, pricePerUnit?: number | null, templateWorkItemId: string, unit?: string | null, tags: Array<string> }> | null } | null> | null } };

export type GetInspectionFloorplansQueryVariables = Exact<{
  orderToken: Scalars['String']['input'];
}>;


export type GetInspectionFloorplansQuery = { __typename?: 'Query', orderByToken?: { __typename?: 'OrderType', id: string, inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, report?: { __typename?: 'ReportType', id: string } | null }>, floorPlanInspections: Array<{ __typename?: 'FloorPlanInspectionType', id: string, status: string, createdAt?: any | null, floorPlanLevels: Array<{ __typename?: 'FloorPlanLevelType', id: string, floorName: string, floorPlanInspectionId: string, image: { __typename?: 'ActiveStorageBlob', id: string, cdnUrl: string, url: string, filename: string }, floorPlanAnchors: Array<{ __typename?: 'FloorPlanAnchorType', id: string, x: number, y: number, floorPlanLevelId: string, reportAttachmentId: string }> }> }> }> } | null };

export type GetInspectionScopeItemsQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type GetInspectionScopeItemsQuery = { __typename?: 'Query', report?: { __typename?: 'ReportType', id: string, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, inspection?: { __typename?: 'InspectionType', id: string, inspectionScopeItems: Array<{ __typename?: 'InspectionScopeItemType', id: string, name?: string | null, budget?: number | null, clientDisbursement?: number | null, createdAt?: any | null, description?: string | null, displayIndex: number, disbursement?: number | null, previousDisbursement?: number | null, updatedAt?: any | null, orderUnit?: { __typename?: 'OrderUnitType', id: string, name?: string | null } | null, previousInspectionScopeItem?: { __typename?: 'InspectionScopeItemType', id: string, name?: string | null, budget?: number | null } | null }> } | null }>, reportSystems: Array<{ __typename?: 'ReportSystemType', id: string, reportSubsystems: Array<{ __typename?: 'ReportSubsystemType', id: string, reportInformations: Array<{ __typename?: 'ReportInformationType', id: string, inspectionScopeItemId?: string | null, reportSubsystemId: string, value?: string | null }> }> }> } | null };

export type GetPhotoSphereAttachmentsQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type GetPhotoSphereAttachmentsQuery = { __typename?: 'Query', report?: { __typename?: 'ReportType', id: string, reportSystems: Array<{ __typename?: 'ReportSystemType', id: string, name: string, displayIndex?: number | null, includeOnReport: boolean, reportSystemGroupId?: string | null, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, reportSubsystems: Array<{ __typename?: 'ReportSubsystemType', id: string, name: string, displayIndex?: number | null, includeOnReport: boolean, includeOnReportIfNotPresent?: boolean | null, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, reportInformations: Array<{ __typename?: 'ReportInformationType', id: string, title: string, displayIndex: number, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }> }> }> } | null };

export type GetReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  imageWidths?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  rotatedAttachmentDegrees?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetReportQuery = { __typename?: 'Query', report?: { __typename?: 'ReportType', id: string, orderId?: string | null, templateReportIds: Array<string>, templateNames: Array<string>, pdfDocumentUrl?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, noDeficienciesAllowed: boolean, noLimitationsAllowed: boolean, geotaggingRequired: boolean, originalReportId?: string | null, complianceText?: string | null, reportSystems: Array<{ __typename?: 'ReportSystemType', id: string, reportId: string, catalogSystemId: string, templateSystemIds: Array<string>, name: string, standardText?: string | null, updatedAt?: any | null, displayIndex?: number | null, includeOnReport: boolean, reportSystemGroupId?: string | null, reportSubsystems: Array<{ __typename?: 'ReportSubsystemType', id: string, reportSystemId: string, catalogSubsystemId: string, templateSubsystemIds: Array<string>, status: string, name: string, note?: string | null, updatedAt?: any | null, displayIndex?: number | null, includeOnReport: boolean, includeOnReportIfNotPresent?: boolean | null, multiUseSubsystemName?: string | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportInformations: Array<{ __typename?: 'ReportInformationType', id: string, reportSubsystemId: string, reportLimitationId?: string | null, catalogInformationId: string, note?: string | null, title: string, dataName: string, detail?: string | null, value?: string | null, questionType: string, units?: string | null, status: ReportInformationStatus, cannotAnswerReason?: ReportInformationCannotAnswerReason | null, allowsOther: boolean, requiresLocations: boolean, requiresMedias: number, requiresMediaOrientation: string, requiresMediaType: string, requiresDeficiencyCondition?: any | null, requiresDeficiencyCatalogDeficiencyId?: string | null, inspectionScopeItemId?: string | null, isMultiSelect: boolean, options?: Array<string> | null, displayIndex: number, tags?: any | null, updatedAt?: any | null, conditionalFollowupLogic?: string | null, catalogInformation?: { __typename?: 'CatalogInformationType', id: string, autoDeficiencyCondition?: any | null, autoDeficiencyMediaRequired: number } | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, reportApplianceInformation?: { __typename?: 'ReportApplianceInformationType', age?: number | null, brandId?: number | null, brandName?: string | null, createdAt?: any | null, expectedLife?: number | null, id: string, modelNumber?: string | null, monthManufactured?: number | null, possibleYearsManufactured?: Array<number> | null, productFailureRiskScore?: number | null, productId?: number | null, productName?: string | null, recalls?: Array<string> | null, remainingLife?: number | null, reportId: string, reportInformationId: string, serialNumber?: string | null, status?: string | null, subProductId?: number | null, subProductName?: string | null, updatedAt?: any | null, yearManufactured?: number | null, warrantyCovered?: boolean | null, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, reportInformationId?: string | null, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, reportSubsystemId: string, catalogDeficiencyId?: string | null, note?: string | null, title: string, detail?: string | null, severity: string, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }> }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, reportSubsystemId: string, catalogLimitationId?: string | null, note?: string | null, title: string, detail?: string | null, updatedAt?: any | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, reportId: string, catalogLocationTypeId: string, itemType?: string | null, itemId?: string | null, name: string, groupName: string, updatedAt?: any | null }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, reportId: string, itemType?: string | null, mediaType?: string | null, itemId?: string | null, s3ObjectKey?: string | null, updatedAt?: any | null, fileName?: string | null, attachmentUrl?: string | null, thumbnailUrl?: string | null, metadata: any, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, inspectionReports: Array<{ __typename?: 'InspectionReportType', inspection?: { __typename?: 'InspectionType', id: string, orderId: string, inspectionType: string, order?: { __typename?: 'OrderType', teamId: string, team?: { __typename?: 'TeamType', id: string, name?: string | null } | null } | null, inspectionWarranty?: { __typename?: 'InspectionWarrantyType', id: string, status: string, inspectionId: string, expirationDate?: any | null, startDate?: any | null, createdAt?: any | null, updatedAt?: any | null } | null, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, contractorId: string, scheduledAt?: any | null } | null } | null }>, reportSystemGroups: Array<{ __typename?: 'ReportSystemGroupType', id: string, name?: string | null }> } | null };

export type GetReportLeanQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  imageWidths?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  rotatedAttachmentDegrees?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetReportLeanQuery = { __typename?: 'Query', report?: { __typename?: 'ReportType', id: string, orderId?: string | null, templateNames: Array<string>, pdfDocumentUrl?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, originalReportId?: string | null, complianceText?: string | null, geotaggingRequired: boolean, reportSystemGroups: Array<{ __typename?: 'ReportSystemGroupType', id: string, name?: string | null }>, reportSystems: Array<{ __typename?: 'ReportSystemType', id: string, name: string, standardText?: string | null, displayIndex?: number | null, includeOnReport: boolean, reportSystemGroupId?: string | null, reportSubsystems: Array<{ __typename?: 'ReportSubsystemType', id: string, status: string, name: string, note?: string | null, displayIndex?: number | null, includeOnReport: boolean, includeOnReportIfNotPresent?: boolean | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, note?: string | null, title: string, detail?: string | null, severity: string, recommendationTypes?: Array<string> | null, recommendationDescription?: string | null, reInspectionStatus?: string | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, itemId?: string | null, itemType?: string | null, name: string, groupName: string }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, note?: string | null, title: string, detail?: string | null, severity: string, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, itemId?: string | null, itemType?: string | null, name: string, groupName: string }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportInformations: Array<{ __typename?: 'ReportInformationType', id: string, note?: string | null, title: string, dataName: string, value?: string | null, questionType: string, units?: string | null, detail?: string | null, status: ReportInformationStatus, cannotAnswer?: boolean | null, cannotAnswerReason?: ReportInformationCannotAnswerReason | null, inspectionScopeItemId?: string | null, displayIndex: number, conditionalFollowupLogic?: string | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, itemId?: string | null, itemType?: string | null, name: string, groupName: string }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, reportApplianceInformation?: { __typename?: 'ReportApplianceInformationType', id: string, age?: number | null, brandName?: string | null, expectedLife?: number | null, modelNumber?: string | null, monthManufactured?: number | null, productName?: string | null, recalls?: Array<string> | null, remainingLife?: number | null, reportInformationId: string, serialNumber?: string | null, status?: string | null, yearManufactured?: number | null, warrantyCovered?: boolean | null, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null, reportDeficiencies: Array<{ __typename?: 'ReportDeficiencyType', id: string, note?: string | null, title: string, detail?: string | null, severity: string, reInspectionStatus?: string | null, recommendationDescription?: string | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, itemId?: string | null, itemType?: string | null, name: string, groupName: string }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }>, originalReportDeficiency?: { __typename?: 'ReportDeficiencyType', id: string, note?: string | null, title: string, detail?: string | null, severity: string, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, itemId?: string | null, itemType?: string | null, name: string, groupName: string }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> } | null }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, note?: string | null, title: string, detail?: string | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, itemId?: string | null, itemType?: string | null, name: string, groupName: string }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }> }>, reportLimitations: Array<{ __typename?: 'ReportLimitationType', id: string, note?: string | null, title: string, detail?: string | null, reportLocations: Array<{ __typename?: 'ReportLocationType', id: string, itemId?: string | null, itemType?: string | null, name: string, groupName: string }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }>, reportAttachments: Array<{ __typename?: 'ReportAttachmentType', id: string, itemType?: string | null, itemId?: string | null, fileName?: string | null, mediaType?: string | null, metadata: any, attachmentUrl?: string | null, thumbnailUrl?: string | null, s3ObjectKey?: string | null, createdAt?: any | null, resizedUrls: Array<{ __typename?: 'ResizedUrlType', width: string, url: string }>, rotatedUrls: Array<{ __typename?: 'RotatedUrlType', degree: string, url: string }> }> }> } | null };

export type GetReportPrintHeaderInfoQueryVariables = Exact<{
  orderToken: Scalars['String']['input'];
  reportId: Scalars['ID']['input'];
  contractorId: Scalars['ID']['input'];
}>;


export type GetReportPrintHeaderInfoQuery = { __typename?: 'Query', contractor?: { __typename?: 'ContractorType', id: string, businessName?: string | null, stateLicenseNumber?: string | null, ashiLicenseNumber?: string | null, internachiLicenseNumber?: string | null, otherLicenseNumber?: string | null } | null, report?: { __typename?: 'ReportType', id: string, publishedAt?: any | null, templateNames: Array<string>, orderId?: string | null } | null, orderByToken?: { __typename?: 'OrderType', id: string, floorPlanName?: string | null, communityName?: string | null, teamExternalId?: string | null, orderStakeholders: Array<{ __typename?: 'OrderStakeholderType', id: string, name?: string | null, isClient?: boolean | null }>, property?: { __typename?: 'PropertyType', id: string, address: string, street?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, homeType?: string | null, totalSquareFeet?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, timezone?: string | null, latitude?: number | null, longitude?: number | null, photo?: { __typename?: 'ActiveStorageBlob', url: string } | null } | null, inspections: Array<{ __typename?: 'InspectionType', id: string, orderId: string, inspectionScopeNumber?: number | null, inspectionType: string, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, report?: { __typename?: 'ReportType', id: string } | null }>, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, scheduledAt?: any | null } | null }> } | null };

export type GetReportsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetReportsQuery = { __typename?: 'Query', reports: { __typename?: 'ReportTypeConnection', edges?: Array<{ __typename?: 'ReportTypeEdge', cursor: string, node?: { __typename?: 'ReportType', id: string, publishedAt?: any | null, orderId?: string | null, templateNames: Array<string>, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, inspection?: { __typename?: 'InspectionType', order?: { __typename?: 'OrderType', id: string, readOnlyToken?: string | null, status: string } | null, scheduledProposal?: { __typename?: 'InspectionProposalType', id: string, isGoAnytime?: boolean | null, contractorId: string } | null } | null }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetAllowsInitialUserCreationQueryVariables = Exact<{
  contractorToken: Scalars['String']['input'];
}>;


export type GetAllowsInitialUserCreationQuery = { __typename?: 'Query', contractorAllowInitialUserCreation: { __typename?: 'IsAllowedType', isAllowed: boolean } };

export type GetAvailableOrderReportsQueryVariables = Exact<{
  orderToken: Scalars['String']['input'];
}>;


export type GetAvailableOrderReportsQuery = { __typename?: 'Query', orderByToken?: { __typename?: 'OrderType', inspections: Array<{ __typename?: 'InspectionType', id: string, inspectionScopeNumber?: number | null, inspectionType: string, inspectionReports: Array<{ __typename?: 'InspectionReportType', id: string, report?: { __typename?: 'ReportType', id: string, publishedAt?: any | null, updatedAt?: any | null } | null }> }> } | null };

export type GetContractorDetailsQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
}>;


export type GetContractorDetailsQuery = { __typename?: 'Query', contractor?: { __typename?: 'ContractorType', id: string, contractorType?: string | null, businessName?: string | null, businessSite?: string | null, ashiLicenseNumber?: string | null, internachiLicenseNumber?: string | null, otherLicenseNumber?: string | null, stateLicenseNumber?: string | null, state?: string | null, country?: string | null, logo?: { __typename?: 'ActiveStorageBlob', url: string } | null } | null };

export type GetContractorScoreCardQueryVariables = Exact<{
  startDate: Scalars['UnixTimestamp']['input'];
  endDate: Scalars['UnixTimestamp']['input'];
}>;


export type GetContractorScoreCardQuery = { __typename?: 'Query', contractorScorecard: { __typename?: 'ContractorScorecardType', hasEnoughData: boolean, inspectorScorecardDashboardUrl?: string | null, inspectorScorecardReliabilityScoreUrl?: string | null } };

export type GetCurrentUserContractorDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserContractorDetailsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserType', id: string, contractorId?: string | null, grantedPermissions: Array<string>, name?: string | null, team?: { __typename?: 'TeamType', id: string, name?: string | null } | null, contractor?: { __typename?: 'ContractorType', id: string, businessName?: string | null, contractorType?: string | null, logo?: { __typename?: 'ActiveStorageBlob', id: string, cdnUrl: string, url: string } | null } | null } | null };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserType', id: string, email?: string | null, phoneNumber?: string | null, name?: string | null, createdAt?: any | null, admin: boolean, teamAdmin: boolean, canManageUsers: boolean, contractorId?: string | null, grantedPermissions: Array<string>, contractor?: { __typename?: 'ContractorType', id: string, businessName?: string | null, businessAddress?: string | null, city?: string | null, state?: string | null, contractorType?: string | null, ashiLicenseNumber?: string | null, logo?: { __typename?: 'ActiveStorageBlob', url: string } | null, internalTeams: Array<{ __typename?: 'TeamType', id: string, allowInAppBooking: boolean, bookingUrl: string, name?: string | null }> } | null, teamUsers: Array<{ __typename?: 'TeamUserType', id: string, team?: { __typename?: 'TeamType', id: string, token: string, name?: string | null, allowRehabToolAccess: boolean, enableRehabCostSplitting?: boolean | null, rehabTags: Array<string>, drawSummaryTableDisplay: DrawSummaryTableDisplay, sowSummaryTableDisplay: SowSummaryTableDisplay, teamLogo?: { __typename?: 'ActiveStorageBlob', url: string } | null, company?: { __typename?: 'CompanyType', id: string, name?: string | null } | null } | null }> } | null, availableUsers: Array<{ __typename?: 'UserType', id: string, email?: string | null, name?: string | null, createdAt?: any | null, admin: boolean, teamAdmin: boolean, canManageUsers: boolean, contractorId?: string | null, grantedPermissions: Array<string>, contractor?: { __typename?: 'ContractorType', id: string, businessAddress?: string | null, businessName?: string | null, city?: string | null, state?: string | null, logo?: { __typename?: 'ActiveStorageBlob', url: string } | null } | null, teamUsers: Array<{ __typename?: 'TeamUserType', id: string, team?: { __typename?: 'TeamType', id: string, token: string, name?: string | null, allowRehabToolAccess: boolean, enableRehabCostSplitting?: boolean | null, rehabTags: Array<string>, drawSummaryTableDisplay: DrawSummaryTableDisplay, sowSummaryTableDisplay: SowSummaryTableDisplay, teamLogo?: { __typename?: 'ActiveStorageBlob', url: string } | null, company?: { __typename?: 'CompanyType', id: string, name?: string | null } | null } | null }> }> };

export type GetCurrentUserContractorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserContractorQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserType', id: string, contractorId?: string | null, grantedPermissions: Array<string>, contractor?: { __typename?: 'ContractorType', id: string, businessEmail?: string | null, businessAddress?: string | null, businessName?: string | null, contractorType?: string | null, latitude?: number | null, longitude?: number | null, automatedSchedulingEnabled?: boolean | null, androidBlurryFreqThreshold?: number | null, iosBlurryFreqThreshold?: number | null, internalTeams: Array<{ __typename?: 'TeamType', id: string, allowInAppBooking: boolean, bookingUrl: string, name?: string | null, teamInspectionConfigs: Array<{ __typename?: 'TeamInspectionConfig', inspectionType: string, templateReport?: { __typename?: 'TemplateReportType', id: string, displayName: string } | null }>, teamOrderStakeholders: Array<{ __typename?: 'TeamOrderStakeholder', id: string, stakeholderType: string, collectEmail: string, collectName: string, collectPhone: string }> }> } | null } | null };

export type GetFullContractorDetailsQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
}>;


export type GetFullContractorDetailsQuery = { __typename?: 'Query', contractor?: { __typename?: 'ContractorType', id: string, contractorType?: string | null, city?: string | null, state?: string | null, country?: string | null, businessZipCode?: string | null, preferredInspectorStatus?: string | null, businessContactName?: string | null, businessPhone?: string | null, businessEmail?: string | null, businessName?: string | null, businessSite?: string | null, businessAddress?: string | null, schedulerName?: string | null, schedulerPhone?: string | null, schedulerEmail?: string | null, serviceZipCodes?: Array<string> | null, serviceAreaRadiusMileage?: number | null, hasSupra?: boolean | null, hasSentrilock?: boolean | null, reportWritingSoftware?: string | null, msaSigned?: boolean | null, tipaltiIsPayable?: boolean | null, stateLicenseNumber?: string | null, ashiLicenseNumber?: string | null, internachiLicenseNumber?: string | null, otherLicenseNumber?: string | null, logo?: { __typename?: 'ActiveStorageBlob', url: string } | null, fileAttachments: Array<{ __typename?: 'FileAttachment', id: string, category: string, createdAt?: any | null, attachment?: { __typename?: 'ActiveStorageBlob', id: string, cdnUrl: string, url: string, filename: string } | null }>, contractorPricings: Array<{ __typename?: 'ContractorPricing', name: string, description?: string | null, active: boolean, allowCustomPricing: boolean }> } | null };

export type GetManageableUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['UnixTimestamp']['input']>;
}>;


export type GetManageableUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserTypeConnection', edges?: Array<{ __typename?: 'UserTypeEdge', node?: { __typename?: 'UserType', id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, grantedPermissions: Array<string>, archivedAt?: any | null, activatedAt?: any | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetManagedUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetManagedUserQuery = { __typename?: 'Query', user?: { __typename?: 'UserType', id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, grantedPermissions: Array<string>, archivedAt?: any | null, activatedAt?: any | null } | null };

export const BasicReportLocationFieldsFragmentDoc = `
    fragment BasicReportLocationFields on ReportLocationType {
  id
  itemId
  itemType
  name
  groupName
}
    `;
export const BasicReportAttachmentFieldsFragmentDoc = `
    fragment BasicReportAttachmentFields on ReportAttachmentType {
  id
  itemType
  itemId
  fileName
  mediaType
  metadata
  attachmentUrl
  thumbnailUrl
  resizedUrls {
    width
    url
  }
  rotatedUrls {
    degree
    url
  }
  s3ObjectKey
  createdAt
}
    `;
export const BasicReportLimitationFieldsFragmentDoc = `
    fragment BasicReportLimitationFields on ReportLimitationType {
  id
  note
  title
  detail
  reportLocations {
    ...BasicReportLocationFields
  }
  reportAttachments {
    ...BasicReportAttachmentFields
  }
}
    `;
export const FloorplanLevelFieldsFragmentDoc = `
    fragment FloorplanLevelFields on FloorPlanLevelType {
  id
  floorName
  floorPlanInspectionId
  image {
    id
    cdnUrl
    url
    filename
  }
  floorPlanAnchors {
    id
    x
    y
    floorPlanLevelId
    reportAttachmentId
  }
}
    `;
export const BundleOfferFieldsFragmentDoc = `
    fragment BundleOfferFields on BundleOffer {
  id
  totalPay
  status
  bundle {
    id
    status
    requestedAt
    bundleInspections {
      id
      appointmentAvailabilities
      inspection {
        id
        inspectionType
        scheduledProposalId
        templateReportId
        status
        order {
          id
          contingencyDate
          inspectionSchedulingDeadline
          accessInformation
          property {
            id
            street
            address
            city
            state
            totalSquareFeet
            zipCode
          }
        }
      }
    }
  }
}
    `;
export const ContractorLicensesFieldsFragmentDoc = `
    fragment ContractorLicensesFields on ContractorType {
  stateLicenseNumber
  ashiLicenseNumber
  internachiLicenseNumber
  otherLicenseNumber
}
    `;
export const FullContractorDetailsFragmentFragmentDoc = `
    fragment FullContractorDetailsFragment on ContractorType {
  id
  contractorType
  ...ContractorLicensesFields
  city
  state
  country
  businessZipCode
  logo {
    url
  }
  preferredInspectorStatus
  businessContactName
  businessPhone
  businessEmail
  businessName
  businessSite
  businessAddress
  schedulerName
  schedulerPhone
  schedulerEmail
  serviceZipCodes
  serviceAreaRadiusMileage
  hasSupra
  hasSentrilock
  reportWritingSoftware
  msaSigned
  tipaltiIsPayable
  fileAttachments {
    id
    category
    attachment {
      id
      cdnUrl
      url
      filename
    }
    createdAt
  }
  contractorPricings {
    name
    description
    active
    allowCustomPricing
  }
}
    `;
export const OrderFragmentFragmentDoc = `
    fragment OrderFragment on OrderType {
  id
  accessInformation
  contingencyDate
  createdAt
  inspectionSchedulingDeadline
  readOnlyToken
  isPaywall
  status
  teamExternalId
  occupancyInfo
  isMock
  inspections {
    id
    inspectionType
    inspectionWarranty {
      id
      inspectionId
      status
      inspection {
        orderId
      }
      startDate
      expirationDate
      expirationDate
      createdAt
      updatedAt
    }
    status
    isPaid
    orderId
    inspectionReports {
      id
      report {
        id
      }
    }
    scheduledProposal {
      id
      totalFee
      scheduledAt
      contractorId
    }
  }
  teamId
  team {
    id
    hideContactInformationOnReport
    drawSummaryTableDisplay
    includeDrawDisbursementFields
    companyId
  }
  propertyId
}
    `;
export const PropertyFragmentFragmentDoc = `
    fragment PropertyFragment on PropertyType {
  id
  address
  street
  street2
  city
  state
  zipCode
  country
  homeType
  totalSquareFeet
  bedrooms
  bathrooms
  yearBuilt
  photo {
    url
  }
  timezone
  latitude
  longitude
}
    `;
export const InspectionProposalFragmentFragmentDoc = `
    fragment InspectionProposalFragment on InspectionProposalType {
  id
  inspectionId
  contractorId
  scheduledAt
  totalFee
  contractorFee
  contractorPaidAt
  teamInternalUserTypeId
  isGoAnytime
}
    `;
export const InspectionFragmentFragmentDoc = `
    fragment InspectionFragment on InspectionType {
  id
  inspectionType
  geotaggingRequired
  orderId
  scheduledProposalId
  scheduledProposal {
    ...InspectionProposalFragment
  }
  status
  templateReportId
  createdAt
}
    `;
export const ReportRecordFragmentFragmentDoc = `
    fragment ReportRecordFragment on ReportType {
  id
  templateReportIds
  templateNames
  createdAt
  updatedAt
  publishedAt
  pdfDocumentUrl
  originalReportId
  noDeficienciesAllowed
  noLimitationsAllowed
  geotaggingRequired
  complianceText
  reportSystems {
    id
  }
}
    `;
export const JobFragmentFragmentDoc = `
    fragment JobFragment on JobType {
  id
  scheduledTime
  status
  isFee
  isGoAnytime
  isMock
  order {
    ...OrderFragment
    property {
      ...PropertyFragment
    }
  }
  inspections {
    ...InspectionFragment
  }
  reports {
    ...ReportRecordFragment
  }
}
    `;
export const OrderStakeholderFragmentFragmentDoc = `
    fragment OrderStakeholderFragment on OrderStakeholderType {
  id
  email
  name
  phone
  stakeholderType
  isClient
}
    `;
export const ReportFieldsFragmentDoc = `
    fragment ReportFields on ReportType {
  id
  orderId
  templateReportIds
  templateNames
  inspectionReports {
    inspection {
      id
      orderId
      inspectionType
      order {
        teamId
        team {
          id
          name
        }
      }
      inspectionWarranty {
        id
        status
        inspectionId
        expirationDate
        startDate
        createdAt
        updatedAt
      }
      scheduledProposal {
        id
        contractorId
        scheduledAt
      }
    }
  }
  reportSystemGroups {
    id
    name
  }
  pdfDocumentUrl
  createdAt
  updatedAt
  publishedAt
  noDeficienciesAllowed
  noLimitationsAllowed
  geotaggingRequired
  originalReportId
  complianceText
}
    `;
export const FullReportLocationFieldsFragmentDoc = `
    fragment FullReportLocationFields on ReportLocationType {
  id
  reportId
  catalogLocationTypeId
  itemType
  itemId
  name
  groupName
  updatedAt
}
    `;
export const FullReportAttachmentFieldsFragmentDoc = `
    fragment FullReportAttachmentFields on ReportAttachmentType {
  id
  reportId
  itemType
  mediaType
  itemId
  s3ObjectKey
  updatedAt
  fileName
  mediaType
  attachmentUrl
  thumbnailUrl
  metadata
  resizedUrls {
    width
    url
  }
  rotatedUrls {
    degree
    url
  }
}
    `;
export const FullOriginalReportDeficiencyFieldsFragmentDoc = `
    fragment FullOriginalReportDeficiencyFields on ReportDeficiencyType {
  id
  reportSubsystemId
  catalogDeficiencyId
  note
  title
  detail
  severity
  updatedAt
  reportLocations {
    ...FullReportLocationFields
  }
  reportAttachments {
    ...FullReportAttachmentFields
  }
}
    `;
export const FullReportDeficiencyFieldsFragmentDoc = `
    fragment FullReportDeficiencyFields on ReportDeficiencyType {
  id
  reportSubsystemId
  reportInformationId
  catalogDeficiencyId
  note
  title
  detail
  severity
  reInspectionStatus
  recommendationTypes
  recommendationDescription
  updatedAt
  reportLocations {
    ...FullReportLocationFields
  }
  reportAttachments {
    ...FullReportAttachmentFields
  }
  originalReportDeficiency {
    ...FullOriginalReportDeficiencyFields
  }
}
    `;
export const FullReportApplianceInformationsFieldsFragmentDoc = `
    fragment FullReportApplianceInformationsFields on ReportApplianceInformationType {
  age
  brandId
  brandName
  createdAt
  expectedLife
  id
  modelNumber
  monthManufactured
  possibleYearsManufactured
  productFailureRiskScore
  productId
  productName
  recalls
  remainingLife
  reportId
  reportInformationId
  serialNumber
  status
  subProductId
  subProductName
  updatedAt
  yearManufactured
  warrantyCovered
  reportAttachments {
    ...FullReportAttachmentFields
  }
}
    `;
export const FullReportLimitationFieldsFragmentDoc = `
    fragment FullReportLimitationFields on ReportLimitationType {
  id
  reportSubsystemId
  catalogLimitationId
  note
  title
  detail
  updatedAt
  reportLocations {
    ...FullReportLocationFields
  }
  reportAttachments {
    ...FullReportAttachmentFields
  }
}
    `;
export const FullReportInformationsFieldsFragmentDoc = `
    fragment FullReportInformationsFields on ReportInformationType {
  id
  reportSubsystemId
  reportLimitationId
  catalogInformationId
  note
  title
  dataName
  detail
  value
  questionType
  units
  status
  cannotAnswerReason
  allowsOther
  requiresLocations
  requiresMedias
  requiresMediaOrientation
  requiresMediaType
  requiresDeficiencyCondition
  requiresDeficiencyCatalogDeficiencyId
  inspectionScopeItemId
  isMultiSelect
  options
  displayIndex
  tags
  updatedAt
  conditionalFollowupLogic
  catalogInformation {
    id
    autoDeficiencyCondition
    autoDeficiencyMediaRequired
  }
  reportLocations {
    ...FullReportLocationFields
  }
  reportAttachments {
    ...FullReportAttachmentFields
  }
  reportApplianceInformation {
    ...FullReportApplianceInformationsFields
  }
  reportDeficiencies {
    ...FullReportDeficiencyFields
  }
  reportLimitations {
    ...FullReportLimitationFields
  }
}
    `;
export const FullReportSubsystemFieldsFragmentDoc = `
    fragment FullReportSubsystemFields on ReportSubsystemType {
  id
  reportSystemId
  catalogSubsystemId
  templateSubsystemIds
  status
  name
  note
  updatedAt
  displayIndex
  includeOnReport
  includeOnReportIfNotPresent
  multiUseSubsystemName
  reportDeficiencies {
    ...FullReportDeficiencyFields
  }
  reportInformations {
    ...FullReportInformationsFields
  }
  reportLimitations {
    ...FullReportLimitationFields
  }
  reportAttachments {
    ...FullReportAttachmentFields
  }
}
    `;
export const FullReportSystemFieldsFragmentDoc = `
    fragment FullReportSystemFields on ReportSystemType {
  id
  reportId
  catalogSystemId
  templateSystemIds
  name
  standardText
  updatedAt
  displayIndex
  includeOnReport
  reportSystemGroupId
  reportSubsystems {
    ...FullReportSubsystemFields
  }
  reportAttachments {
    ...FullReportAttachmentFields
  }
}
    `;
export const FullReportFieldsFragmentDoc = `
    fragment FullReportFields on ReportType {
  ...ReportFields
  reportSystems {
    ...FullReportSystemFields
  }
}
    `;
export const FullCatalogSystemFieldsFragmentDoc = `
    fragment FullCatalogSystemFields on CatalogSystemType {
  id
  name
  createdAt
}
    `;
export const FullCatalogSubsystemFieldsFragmentDoc = `
    fragment FullCatalogSubsystemFields on CatalogSubsystemType {
  id
  name
}
    `;
export const FullCatalogInformationFieldsFragmentDoc = `
    fragment FullCatalogInformationFields on CatalogInformationType {
  id
  title
  detail
  dataName
  questionType
  units
  allowsOther
  requiresLocations
  requiresMedias
  requiresDeficiencyCondition
  isMultiSelect
  options
}
    `;
export const FullTemplateReportFieldsFragmentDoc = `
    fragment FullTemplateReportFields on TemplateReportType {
  id
  baseTemplateReportId
  reInspectionTemplateReportId
  name
  description
  displayName
  inspectionType
  noDeficienciesAllowed
  noLimitationsAllowed
  templateSystems {
    id
    templateReportId
    catalogSystemId
    catalogSystem {
      ...FullCatalogSystemFields
    }
    displayIndex
    templateSubsystems {
      id
      templateSystemId
      catalogSubsystemId
      catalogSubsystem {
        ...FullCatalogSubsystemFields
      }
      displayIndex
      multiUseSubsystemName
      includeOnReportIfNotPresent
      templateInformations {
        id
        templateSubsystemId
        catalogInformationId
        catalogInformation {
          ...FullCatalogInformationFields
        }
        displayIndex
      }
    }
  }
}
    `;
export const InspectionDocumentFragmentFragmentDoc = `
    fragment InspectionDocumentFragment on InspectionType {
  id
  inspectionReports {
    id
    report {
      id
      inspectionDocuments {
        id
        document {
          id
          byteSize
          contentType
          cdnUrl
        }
      }
    }
  }
}
    `;
export const JobListFragmentFragmentDoc = `
    fragment JobListFragment on JobType {
  id
  status
  isGoAnytime
  isMock
  scheduledTime
  order {
    id
    readOnlyToken
    inspections {
      id
      inspectionType
    }
    property {
      ...PropertyFragment
    }
  }
  inspections {
    id
    inspectionType
    status
    templateReportId
  }
}
    `;
export const RehabPropertyFieldsFragmentDoc = `
    fragment RehabPropertyFields on PropertyType {
  id
  address
  street
  street2
  city
  state
  zipCode
  country
  homeType
  totalSquareFeet
  bedrooms
  bathrooms
  yearBuilt
  photo {
    cdnUrl
  }
  timezone
}
    `;
export const RehabTeamCustomSystemFieldsFragmentDoc = `
    fragment RehabTeamCustomSystemFields on TeamCustomSystemType {
  id
  teamId
  name
  subsystemNames
}
    `;
export const RehabTeamFieldsFragmentDoc = `
    fragment RehabTeamFields on TeamType {
  id
  token
  name
  rehabTags
  canPublishRehabProjects
  allowRehabToolAccess
  enableRehabCostSplitting
  rehabTeamMarkets {
    id
    name
    stateAbbreviation
  }
  rehabTeamCustomSystems {
    ...RehabTeamCustomSystemFields
  }
}
    `;
export const RehabWorkItemFieldsFragmentDoc = `
    fragment RehabWorkItemFields on WorkItemType {
  id
  projectId
  systemName
  subsystemName
  title
  details
  quantity
  unit
  pricePerUnit
  totalPrice
  tags
  templateWorkItemPricingId
  pricingExternalId
  displayIndex
  workItemAssociations {
    id
    workItemId
    itemId
    itemType
    data
  }
  workItemAttachments {
    id
    workItemId
    workItemAssociationId
    s3ObjectKey
    attachmentUrl
    thumbnailUrl
    resizedUrls {
      url
      width
    }
  }
  workItemContributors {
    amount
    createdAt
    id
    name
    updatedAt
    workItemId
  }
}
    `;
export const CreateFeedbackDocument = `
    mutation CreateFeedback($input: SubmitFeedbackInput!) {
  submitFeedback(input: $input) {
    id
    reviewableId
    reviewableType
    score
    note
    initiatedAt
    submittedAt
    userId
  }
}
    `;
export const MutateAttachmentDocument = `
    mutation MutateAttachment($input: TransformReportAttachmentInput!) {
  transformReportAttachment(input: $input) {
    reportAttachment {
      id
    }
  }
}
    `;
export const CreateItemAccessLogDocument = `
    mutation CreateItemAccessLog($input: CreateItemAccessLogInput!) {
  createItemAccessLog(input: $input) {
    errors {
      code
      message
    }
  }
}
    `;
export const CreateReportDocument = `
    mutation CreateReport($inspectionIds: [ID!]!) {
  createReport(input: {inspectionIds: $inspectionIds}) {
    report {
      ...FullReportFields
    }
  }
}
    ${FullReportFieldsFragmentDoc}
${ReportFieldsFragmentDoc}
${FullReportSystemFieldsFragmentDoc}
${FullReportSubsystemFieldsFragmentDoc}
${FullReportDeficiencyFieldsFragmentDoc}
${FullReportLocationFieldsFragmentDoc}
${FullReportAttachmentFieldsFragmentDoc}
${FullOriginalReportDeficiencyFieldsFragmentDoc}
${FullReportInformationsFieldsFragmentDoc}
${FullReportApplianceInformationsFieldsFragmentDoc}
${FullReportLimitationFieldsFragmentDoc}`;
export const MutateCreateReportAttachmentDocument = `
    mutation MutateCreateReportAttachment($input: CreateReportAttachmentInput!) {
  createReportAttachment(input: $input) {
    reportAttachment {
      attachmentUrl
      longLiveUrl
      createdAt
      fileName
      id
      itemId
      itemType
      mediaType
      metadata
      reportId
      reportSystemGroupId
      resizedUrls {
        url
        width
      }
      rotatedUrls {
        url
        degree
      }
      s3ObjectKey
      thumbnailUrl
      updatedAt
    }
  }
}
    `;
export const MutateDeleteAttachmentDocument = `
    mutation MutateDeleteAttachment($input: DeleteReportAttachmentInput!) {
  deleteReportAttachment(input: $input) {
    reportAttachment {
      id
    }
  }
}
    `;
export const DirectUploadDocument = `
    mutation DirectUpload($input: DirectUploadInput!) {
  directUpload(input: $input) {
    blobSignedId
    contentMd5
    contentType
    url
  }
}
    `;
export const MutateFixMissingS3ObjectKeysDocument = `
    mutation MutateFixMissingS3ObjectKeys($input: RunFixMissingS3ObjectKeysOnReportAttachmentsInput!) {
  runFixMissingS3ObjectKeysOnReportAttachment(input: $input) {
    clientMutationId
  }
}
    `;
export const MutateFloorplanAnchorsDocument = `
    mutation MutateFloorplanAnchors($input: UpdateFloorPlanLevelInput!) {
  updateFloorPlanLevel(input: $input) {
    floorPlanLevel {
      ...FloorplanLevelFields
    }
  }
}
    ${FloorplanLevelFieldsFragmentDoc}`;
export const GeneratePhotoSphereImagesZipDocument = `
    mutation GeneratePhotoSphereImagesZip($input: GeneratePhotoSphereImagesZipInput!) {
  generatePhotoSphereImagesZip(input: $input) {
    photoSphereImagesZipActiveStorageBlob {
      filename
      cdnUrl
    }
  }
}
    `;
export const MutateInspectionScopeItemDocument = `
    mutation MutateInspectionScopeItem($input: UpdateInspectionScopeItemInput!) {
  updateInspectionScopeItem(input: $input) {
    inspectionScopeItem {
      id
      name
      description
      orderUnitId
      orderUnit {
        id
        name
      }
      budget
      progress
      disbursement
      clientDisbursement
      previousDisbursement
      previousInspectionScopeItem {
        id
        name
        description
        orderUnitId
        orderUnit {
          id
          name
        }
        budget
        progress
        disbursement
        clientDisbursement
        previousDisbursement
      }
    }
  }
}
    `;
export const MutatePermitsPdfDocument = `
    mutation MutatePermitsPdf($input: GeneratePropertyPermitPdfReportInput!) {
  generatePropertyPermitPdfReport(input: $input) {
    permitPdfReportActiveStorageBlob {
      id
      filename
      byteSize
      contentType
      cdnUrl
      url
      createdAt
    }
  }
}
    `;
export const MutatePropertyGeneratePermitPdfDocument = `
    mutation MutatePropertyGeneratePermitPdf($input: GeneratePropertyPermitPdfReportInput!) {
  generatePropertyPermitPdfReport(input: $input) {
    permitPdfReportActiveStorageBlob {
      id
      contentType
      filename
      url
      byteSize
      createdAt
    }
  }
}
    `;
export const PublishReportDocument = `
    mutation PublishReport($input: PublishReportInput!) {
  publishReport(input: $input) {
    report {
      id
      publishedAt
    }
  }
}
    `;
export const MutateReportFixMissingS3ObjectDocument = `
    mutation MutateReportFixMissingS3Object($input: RunFixMissingS3ObjectKeysOnReportAttachmentsInput!) {
  runFixMissingS3ObjectKeysOnReportAttachment(input: $input) {
    clientMutationId
  }
}
    `;
export const MutateReportPdfDocument = `
    mutation MutateReportPdf($input: GeneratePdfReportInput!) {
  generatePdfReport(input: $input) {
    pdfReportActiveStorageBlob {
      id
      filename
      byteSize
      contentType
      cdnUrl
      url
      createdAt
    }
  }
}
    `;
export const MutateTipaltiUrlDocument = `
    mutation MutateTipaltiUrl($input: GenerateTipaltiIframeUrlInput!) {
  generateTipaltiIframeUrl(input: $input) {
    iframeUrl
  }
}
    `;
export const MutateWarrantyClaimDocument = `
    mutation MutateWarrantyClaim($input: WarrantyClaimInput!) {
  warrantyClaim(input: $input) {
    inspectionWarranty {
      createdAt
      expirationDate
      id
      inspectionId
      startDate
      status
    }
  }
}
    `;
export const MutateWarrantyOwnershipDocument = `
    mutation MutateWarrantyOwnership($input: WarrantyProveOwnershipInput!) {
  warrantyProveOwnership(input: $input) {
    inspectionWarranty {
      createdAt
      expirationDate
      id
      inspectionId
      startDate
      status
    }
  }
}
    `;
export const CreateInspectorOnboardingDocument = `
    mutation CreateInspectorOnboarding($input: CreateInspectorOnboardingInput!) {
  createInspectorOnboarding(input: $input) {
    inspectorOnboarding {
      id
      completedStep
    }
  }
}
    `;
export const CreateSurveyorOnboardingDocument = `
    mutation CreateSurveyorOnboarding($input: CreateSurveyorOnboardingInput!) {
  createSurveyorOnboarding(input: $input) {
    surveyorOnboarding {
      id
      completedStep
    }
  }
}
    `;
export const MutateInspectorOnboardingDocument = `
    mutation MutateInspectorOnboarding($input: UpdateInspectorOnboardingInput!) {
  updateInspectorOnboarding(input: $input) {
    inspectorOnboarding {
      id
      appLoggedIn
      canSetPassword
      completedStep
      contractor {
        ...FullContractorDetailsFragment
      }
      createdAt
      misaSigned
      onboardingTrackerDismissedAt
      paymentDetailsFilled
      status
      updatedAt
      usersAdded
    }
  }
}
    ${FullContractorDetailsFragmentFragmentDoc}
${ContractorLicensesFieldsFragmentDoc}`;
export const MutateSurveyorOnboardingDocument = `
    mutation MutateSurveyorOnboarding($input: UpdateSurveyorOnboardingInput!) {
  updateSurveyorOnboarding(input: $input) {
    surveyorOnboarding {
      id
      appLoggedIn
      backgroundCheckRequired
      backgroundCheckSubmittedAt
      canSetPassword
      completedStep
      contractor {
        ...FullContractorDetailsFragment
      }
      createdAt
      misaSigned
      onboardingTrackerDismissedAt
      paymentDetailsFilled
      status
      submitBackgroundCheckUrl
      updatedAt
    }
  }
}
    ${FullContractorDetailsFragmentFragmentDoc}
${ContractorLicensesFieldsFragmentDoc}`;
export const CreateRehabProjectDocument = `
    mutation CreateRehabProject($input: CreateProjectInput!) {
  createRehabProject(input: $input) {
    project {
      id
    }
  }
}
    `;
export const CreateRehabWorkItemDocument = `
    mutation CreateRehabWorkItem($input: CreateWorkItemInput!) {
  createRehabWorkItem(input: $input) {
    workItem {
      id
      systemName
      subsystemName
      title
      details
      unit
      quantity
      pricePerUnit
      totalPrice
      projectId
      pricingExternalId
      tags
      displayIndex
      workItemAssociations {
        id
        workItemId
        itemId
        itemType
        data
      }
      workItemAttachments {
        id
        workItemId
        workItemAssociationId
        s3ObjectKey
        attachmentUrl
        resizedUrls {
          url
          width
        }
      }
      templateWorkItemPricing {
        id
        pricingExternalId
        details
        unit
        pricePerUnit
        lumpSumPrice
        teamMarketId
        templateWorkItem {
          id
          teamId
          systemName
          title
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;
export const CreateRehabWorkItemAssociationDocument = `
    mutation CreateRehabWorkItemAssociation($input: CreateWorkItemAssociationInput!) {
  createRehabWorkItemAssociation(input: $input) {
    workItemAssociation {
      id
      workItemId
      itemId
      itemType
      data
    }
  }
}
    `;
export const CreateRehabWorkItemAttachmentDocument = `
    mutation CreateRehabWorkItemAttachment($input: CreateWorkItemAttachmentInput!) {
  createRehabWorkItemAttachment(input: $input) {
    workItemAttachment {
      id
      workItemId
      workItemAssociationId
      s3ObjectKey
      attachmentUrl
      resizedUrls {
        url
        width
      }
    }
  }
}
    `;
export const CreateRehabWorkItemContributorDocument = `
    mutation createRehabWorkItemContributor($input: CreateWorkItemContributorInput!) {
  createRehabWorkItemContributor(input: $input) {
    clientMutationId
    workItemContributor {
      id
      workItemId
      name
      amount
      createdAt
      updatedAt
    }
  }
}
    `;
export const DeleteRehabWorkItemDocument = `
    mutation DeleteRehabWorkItem($input: DeleteWorkItemInput!) {
  deleteRehabWorkItem(input: $input) {
    workItem {
      id
    }
  }
}
    `;
export const DeleteRehabWorkItemAssociationDocument = `
    mutation DeleteRehabWorkItemAssociation($input: DeleteWorkItemAssociationInput!) {
  deleteRehabWorkItemAssociation(input: $input) {
    workItemAssociation {
      id
    }
  }
}
    `;
export const DeleteRehabWorkItemAttachmentDocument = `
    mutation DeleteRehabWorkItemAttachment($input: DeleteWorkItemAttachmentInput!) {
  deleteRehabWorkItemAttachment(input: $input) {
    workItemAttachment {
      id
    }
  }
}
    `;
export const DeleteRehabWorkItemContributorDocument = `
    mutation DeleteRehabWorkItemContributor($input: DeleteWorkItemContributorInput!) {
  deleteRehabWorkItemContributor(input: $input) {
    clientMutationId
    workItemContributor {
      id
      workItemId
      name
      amount
      createdAt
      updatedAt
    }
  }
}
    `;
export const DeleteTeamCustomSystemDocument = `
    mutation DeleteTeamCustomSystem($input: DeleteTeamCustomSystemInput!) {
  deleteTeamCustomSystem(input: $input) {
    teamCustomSystem {
      id
    }
  }
}
    `;
export const MutateRehabProjectDocument = `
    mutation MutateRehabProject($input: UpdateProjectInput!) {
  updateRehabProject(input: $input) {
    project {
      id
      name
      propertyId
      teamId
      reportId
      publishedAt
      teamMarketId
    }
  }
}
    `;
export const MutateRehabProjectGenerateCsvDocument = `
    mutation MutateRehabProjectGenerateCsv($input: GenerateProjectCsvInput!) {
  generateRehabProjectCsv(input: $input) {
    rehabProjectCsvActiveStorageBlob {
      id
      contentType
      filename
      url
      byteSize
      createdAt
    }
  }
}
    `;
export const MutateRehabProjectGeneratePdfDocument = `
    mutation MutateRehabProjectGeneratePdf($input: GenerateProjectPdfInput!) {
  generateRehabProjectPdf(input: $input) {
    rehabProjectPdfActiveStorageBlob {
      id
      contentType
      filename
      url
      byteSize
      createdAt
    }
  }
}
    `;
export const PopulateTeamCustomSystemDocument = `
    mutation PopulateTeamCustomSystem($input: PopulateTeamCustomSystemInput!) {
  populateTeamCustomSystem(input: $input) {
    populateTeamCustomSystem {
      ...RehabTeamCustomSystemFields
    }
  }
}
    ${RehabTeamCustomSystemFieldsFragmentDoc}`;
export const PublishRehabProjectDocument = `
    mutation PublishRehabProject($input: PublishProjectInput!) {
  publishRehabProject(input: $input) {
    project {
      id
      publishedAt
    }
  }
}
    `;
export const UpdateRehabWorkItemDocument = `
    mutation UpdateRehabWorkItem($input: UpdateWorkItemInput!) {
  updateRehabWorkItem(input: $input) {
    workItem {
      ...RehabWorkItemFields
    }
  }
}
    ${RehabWorkItemFieldsFragmentDoc}`;
export const UpdateWorkItemContributorDocument = `
    mutation updateWorkItemContributor($input: UpdateWorkItemContributorInput!) {
  updateRehabWorkItemContributor(input: $input) {
    clientMutationId
    workItemContributor {
      id
      workItemId
      name
      amount
      createdAt
      updatedAt
    }
  }
}
    `;
export const CreateUserDocument = `
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    user {
      id
      name
      email
      phoneNumber
      grantedPermissions
      archivedAt
      activatedAt
    }
  }
}
    `;
export const CreateUserContractorDocument = `
    mutation CreateUserContractor($input: CreateUserInput!) {
  createUser(input: $input) {
    user {
      contractorId
    }
  }
}
    `;
export const MutateCheckVerificationSmsDocument = `
    mutation MutateCheckVerificationSms($input: CheckVerificationSmsInput!) {
  checkVerificationSms(input: $input) {
    token
  }
}
    `;
export const MutateContractorDetailsDocument = `
    mutation MutateContractorDetails($input: UpdateContractorInput!) {
  updateContractor(input: $input) {
    contractor {
      id
      contractorType
      businessName
      businessSite
      latitude
      longitude
      certifications
      ashiLicenseNumber
      internachiLicenseNumber
      otherLicenseNumber
      stateLicenseNumber
      inBusinessSince
      state
      country
      logo {
        url
      }
      preferredInspectorStatus
      instantBookingEnabled
      businessContactName
      businessPhone
      businessEmail
      businessAddress
      schedulerName
      schedulerPhone
      schedulerEmail
      sendAutomatedSms
      serviceZipCodes
      serviceAreaRadiusMileage
      hasSupra
      reportWritingSoftware
      msaSigned
      token
      tipaltiIsPayable
    }
  }
}
    `;
export const MutateInviteResendDocument = `
    mutation MutateInviteResend($input: ResendInviteInput!) {
  resendInvite(input: $input) {
    user {
      id
      name
      email
      phoneNumber
      grantedPermissions
      archivedAt
      activatedAt
    }
  }
}
    `;
export const MutateSendVerificationSmsDocument = `
    mutation MutateSendVerificationSms($input: SendVerificationSmsInput!) {
  sendVerificationSms(input: $input) {
    clientMutationId
  }
}
    `;
export const MutateUserDocument = `
    mutation MutateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    user {
      id
      name
      email
      phoneNumber
      grantedPermissions
      archivedAt
      activatedAt
    }
  }
}
    `;
export const MutateUserInvitationDocument = `
    mutation MutateUserInvitation($input: ResendInviteInput!) {
  resendInvite(input: $input) {
    user {
      id
      name
      email
      phoneNumber
      grantedPermissions
      archivedAt
      activatedAt
    }
  }
}
    `;
export const GetJobDocument = `
    query GetJob {
  jobs(status: scheduled) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    nodes {
      ...JobFragment
      reports {
        inspectionDocuments {
          id
          documentType
          document {
            filename
          }
          externalDocumentUrl
        }
      }
    }
  }
}
    ${JobFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${PropertyFragmentFragmentDoc}
${InspectionFragmentFragmentDoc}
${InspectionProposalFragmentFragmentDoc}
${ReportRecordFragmentFragmentDoc}`;
export const GetJobDetailsDocument = `
    query GetJobDetails($token: String!) {
  orderByToken(token: $token) {
    ...OrderFragment
    orderStakeholders {
      ...OrderStakeholderFragment
    }
    property {
      ...PropertyFragment
    }
    inspections {
      id
      inspectionType
      scheduledProposal {
        id
        scheduledAt
        isGoAnytime
        contractorPaidAt
        contractorFee
        totalFee
        contractorPaymentPlatform
      }
      templateReport {
        id
        name
      }
      inspectionReports {
        id
        report {
          id
          pdfDocumentUrl
          updatedAt
          publishedAt
          inspectionDocuments {
            id
            updatedAt
            document {
              id
              filename
              url
              cdnUrl
            }
          }
          inspectionDocuments {
            id
            updatedAt
            document {
              id
              filename
              url
              cdnUrl
            }
          }
        }
      }
    }
  }
}
    ${OrderFragmentFragmentDoc}
${OrderStakeholderFragmentFragmentDoc}
${PropertyFragmentFragmentDoc}`;
export const GetJobsDocument = `
    query GetJobs($status: JobStatus, $searchText: String, $after: String, $before: String, $first: Int, $last: Int, $scheduledOnGte: ISO8601Date, $scheduledOnLte: ISO8601Date, $includeAllGoAnytime: Boolean) {
  jobs(
    status: $status
    searchText: $searchText
    after: $after
    before: $before
    first: $first
    last: $last
    scheduledOnGte: $scheduledOnGte
    scheduledOnLte: $scheduledOnLte
    includeAllGoAnytime: $includeAllGoAnytime
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    nodes {
      ...JobListFragment
    }
  }
}
    ${JobListFragmentFragmentDoc}
${PropertyFragmentFragmentDoc}`;
export const GetInspectorOnboardingDocument = `
    query GetInspectorOnboarding($id: ID!) {
  inspectorOnboarding(id: $id) {
    id
    appLoggedIn
    canSetPassword
    completedStep
    contractor {
      ...FullContractorDetailsFragment
    }
    createdAt
    isMultiInspectorFirm
    misaSigned
    onboardingTrackerDismissedAt
    paymentDetailsFilled
    status
    updatedAt
    usersAdded
  }
}
    ${FullContractorDetailsFragmentFragmentDoc}
${ContractorLicensesFieldsFragmentDoc}`;
export const GetSurveyorOnboardingDocument = `
    query GetSurveyorOnboarding($id: ID!) {
  surveyorOnboarding(id: $id) {
    id
    appLoggedIn
    backgroundCheckRequired
    backgroundCheckSubmittedAt
    canSetPassword
    completedStep
    contractor {
      ...FullContractorDetailsFragment
    }
    createdAt
    marketSaturatedAtOnboardingTime
    misaSigned
    onboardingTrackerDismissedAt
    paymentDetailsFilled
    status
    submitBackgroundCheckUrl
    updatedAt
  }
}
    ${FullContractorDetailsFragmentFragmentDoc}
${ContractorLicensesFieldsFragmentDoc}`;
export const GetAllDownloadLinksForOrderDocument = `
    query GetAllDownloadLinksForOrder($token: String!) {
  orderByToken(token: $token) {
    id
    inspections {
      id
      inspectionType
      inspectionReports {
        id
        report {
          inspectionDocuments {
            id
            externalDocumentUrl
            document {
              id
              url
              cdnUrl
              contentType
              filename
            }
          }
        }
      }
    }
  }
}
    `;
export const GetOrderByTokenDocument = `
    query GetOrderByToken($orderToken: String!) {
  orderByToken(token: $orderToken) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export const GetOrderPropertyPhotoDocument = `
    query GetOrderPropertyPhoto($token: String!) {
  orderByToken(token: $token) {
    id
    property {
      id
      address
      city
      zipCode
      state
      street
      street2
      timezone
      latitude
      longitude
      photo {
        id
        cdnUrl
        url
      }
    }
  }
}
    `;
export const GetOrderStakeholderInformationDocument = `
    query GetOrderStakeholderInformation($token: String!) {
  orderByToken(token: $token) {
    id
    teamExternalId
    communityName
    floorPlanName
    orderStakeholders {
      id
      name
      email
      phone
      stakeholderType
      isClient
    }
  }
}
    `;
export const GetPermitReportDocument = `
    query GetPermitReport($token: String!) {
  order: orderByToken(token: $token) {
    accessInformation
    id
    propertyId
    inspections {
      id
      inspectionReports {
        id
        report {
          id
          pdfDocumentUrl
          inspectionDocuments {
            id
            updatedAt
            document {
              id
              filename
              url
              cdnUrl
              createdAt
            }
          }
        }
      }
    }
    property {
      id
      photo {
        cdnUrl
      }
      country
      state
      city
      zipCode
      street
      street2
      address
      permits {
        id
        description
        fees
        fileDate
        finalDate
        issueDate
        jurisdiction
        number
        status
        jobValue
        permitSubtype
        permitType
        source
        status
        shovelsContractorId
        shovelsPermitId
        createdAt
        updatedAt
        permitContractorId
        permitContractor {
          id
          businessName
          city
          email
          license
          name
          phone
          state
          street
          streetNo
          zipcode
          shovelsContractorId
          createdAt
          updatedAt
        }
      }
    }
    updatedAt
  }
}
    `;
export const GetPermitsSummaryDocument = `
    query GetPermitsSummary($token: String!) {
  order: orderByToken(token: $token) {
    property {
      id
      permits {
        id
        fileDate
        finalDate
        issueDate
        createdAt
        updatedAt
      }
    }
    updatedAt
  }
}
    `;
export const GetProjectHistoryDocument = `
    query GetProjectHistory($first: Int, $projectId: ID!, $after: String) {
  projectHistory(first: $first, projectId: $projectId, after: $after) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        itemType
        itemId
        event
        createdAt
        objectChanges {
          fieldName
          oldValue
          newValue
        }
        user {
          id
          name
          email
        }
      }
    }
  }
}
    `;
export const GetRehabProjectDocument = `
    query getRehabProject($id: ID!, $resizedAttachmentWidths: [Int!], $rotatedAttachmentDegrees: [Int!]) {
  rehabProject(
    id: $id
    resizedAttachmentWidths: $resizedAttachmentWidths
    rotatedAttachmentDegrees: $rotatedAttachmentDegrees
  ) {
    id
    name
    propertyId
    teamId
    reportId
    publishedAt
    teamMarketId
    property {
      ...RehabPropertyFields
    }
    report {
      ...FullReportFields
    }
    workItems {
      ...RehabWorkItemFields
    }
    team {
      ...RehabTeamFields
    }
  }
}
    ${RehabPropertyFieldsFragmentDoc}
${FullReportFieldsFragmentDoc}
${ReportFieldsFragmentDoc}
${FullReportSystemFieldsFragmentDoc}
${FullReportSubsystemFieldsFragmentDoc}
${FullReportDeficiencyFieldsFragmentDoc}
${FullReportLocationFieldsFragmentDoc}
${FullReportAttachmentFieldsFragmentDoc}
${FullOriginalReportDeficiencyFieldsFragmentDoc}
${FullReportInformationsFieldsFragmentDoc}
${FullReportApplianceInformationsFieldsFragmentDoc}
${FullReportLimitationFieldsFragmentDoc}
${RehabWorkItemFieldsFragmentDoc}
${RehabTeamFieldsFragmentDoc}
${RehabTeamCustomSystemFieldsFragmentDoc}`;
export const GetRehabProjectReadOnlyDocument = `
    query GetRehabProjectReadOnly($id: ID!, $resizedAttachmentWidths: [Int!]) {
  rehabProject(id: $id, resizedAttachmentWidths: $resizedAttachmentWidths) {
    id
    name
    propertyId
    teamId
    reportId
    publishedAt
    teamMarketId
    property {
      ...RehabPropertyFields
    }
    workItems {
      ...RehabWorkItemFields
    }
    team {
      ...RehabTeamFields
    }
  }
}
    ${RehabPropertyFieldsFragmentDoc}
${RehabWorkItemFieldsFragmentDoc}
${RehabTeamFieldsFragmentDoc}
${RehabTeamCustomSystemFieldsFragmentDoc}`;
export const GetRehabProjectsDocument = `
    query GetRehabProjects($reportId: ID!) {
  report(id: $reportId) {
    id
    inspectionReports {
      id
      inspection {
        id
        orderId
        order {
          teamId
        }
      }
    }
  }
  rehabProjects(reportId: $reportId) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        reportId
        propertyId
        teamId
      }
    }
  }
}
    `;
export const GetTemplateWorkItemsDocument = `
    query GetTemplateWorkItems($marketId: ID, $after: String, $first: Int) {
  templateWorkItems(marketId: $marketId, after: $after, first: $first) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
    }
    nodes {
      id
      systemName
      teamId
      title
      templateWorkItemPricings {
        id
        pricingExternalId
        details
        teamMarketId
        lumpSumPrice
        pricePerUnit
        templateWorkItemId
        unit
        tags
      }
    }
  }
}
    `;
export const GetInspectionFloorplansDocument = `
    query GetInspectionFloorplans($orderToken: String!) {
  orderByToken(token: $orderToken) {
    id
    inspections {
      id
      inspectionReports {
        id
        report {
          id
        }
      }
      floorPlanInspections {
        id
        status
        createdAt
        floorPlanLevels {
          ...FloorplanLevelFields
        }
      }
    }
  }
}
    ${FloorplanLevelFieldsFragmentDoc}`;
export const GetInspectionScopeItemsDocument = `
    query GetInspectionScopeItems($reportId: ID!) {
  report(id: $reportId) {
    id
    inspectionReports {
      id
      inspection {
        id
        inspectionScopeItems {
          id
          name
          budget
          clientDisbursement
          createdAt
          description
          displayIndex
          disbursement
          orderUnit {
            id
            name
          }
          previousDisbursement
          previousInspectionScopeItem {
            id
            name
            budget
          }
          updatedAt
        }
      }
    }
    reportSystems {
      id
      reportSubsystems {
        id
        reportInformations {
          id
          inspectionScopeItemId
          reportSubsystemId
          value
        }
      }
    }
  }
}
    `;
export const GetPhotoSphereAttachmentsDocument = `
    query GetPhotoSphereAttachments($reportId: ID!) {
  report(id: $reportId) {
    id
    reportSystems {
      id
      name
      displayIndex
      includeOnReport
      reportSystemGroupId
      reportAttachments {
        ...FullReportAttachmentFields
      }
      reportSubsystems {
        id
        name
        displayIndex
        includeOnReport
        includeOnReportIfNotPresent
        reportAttachments {
          ...FullReportAttachmentFields
        }
        reportInformations {
          id
          title
          displayIndex
          reportAttachments {
            ...FullReportAttachmentFields
          }
        }
      }
    }
  }
}
    ${FullReportAttachmentFieldsFragmentDoc}`;
export const GetReportDocument = `
    query GetReport($id: ID!, $imageWidths: [Int!], $rotatedAttachmentDegrees: [Int!]) {
  report(
    id: $id
    resizedAttachmentWidths: $imageWidths
    rotatedAttachmentDegrees: $rotatedAttachmentDegrees
  ) {
    ...FullReportFields
  }
}
    ${FullReportFieldsFragmentDoc}
${ReportFieldsFragmentDoc}
${FullReportSystemFieldsFragmentDoc}
${FullReportSubsystemFieldsFragmentDoc}
${FullReportDeficiencyFieldsFragmentDoc}
${FullReportLocationFieldsFragmentDoc}
${FullReportAttachmentFieldsFragmentDoc}
${FullOriginalReportDeficiencyFieldsFragmentDoc}
${FullReportInformationsFieldsFragmentDoc}
${FullReportApplianceInformationsFieldsFragmentDoc}
${FullReportLimitationFieldsFragmentDoc}`;
export const GetReportLeanDocument = `
    query GetReportLean($id: ID!, $imageWidths: [Int!], $rotatedAttachmentDegrees: [Int!]) {
  report(
    id: $id
    resizedAttachmentWidths: $imageWidths
    rotatedAttachmentDegrees: $rotatedAttachmentDegrees
  ) {
    id
    orderId
    templateNames
    reportSystemGroups {
      id
      name
    }
    pdfDocumentUrl
    createdAt
    updatedAt
    publishedAt
    originalReportId
    complianceText
    geotaggingRequired
    reportSystems {
      id
      name
      standardText
      displayIndex
      includeOnReport
      reportSystemGroupId
      reportSubsystems {
        id
        status
        name
        note
        displayIndex
        includeOnReport
        includeOnReportIfNotPresent
        reportDeficiencies {
          id
          note
          title
          detail
          severity
          recommendationTypes
          recommendationDescription
          reInspectionStatus
          reportLocations {
            ...BasicReportLocationFields
          }
          reportAttachments {
            ...BasicReportAttachmentFields
          }
          originalReportDeficiency {
            id
            note
            title
            detail
            severity
            reportLocations {
              ...BasicReportLocationFields
            }
            reportAttachments {
              ...BasicReportAttachmentFields
            }
          }
        }
        reportInformations {
          id
          note
          title
          dataName
          value
          questionType
          units
          detail
          status
          cannotAnswer
          cannotAnswerReason
          inspectionScopeItemId
          displayIndex
          conditionalFollowupLogic
          reportLocations {
            ...BasicReportLocationFields
          }
          reportAttachments {
            ...BasicReportAttachmentFields
          }
          reportApplianceInformation {
            id
            age
            brandName
            expectedLife
            modelNumber
            monthManufactured
            productName
            recalls
            remainingLife
            reportInformationId
            serialNumber
            status
            yearManufactured
            warrantyCovered
            reportAttachments {
              ...BasicReportAttachmentFields
            }
          }
          reportDeficiencies {
            id
            note
            title
            detail
            severity
            reInspectionStatus
            recommendationDescription
            reportLocations {
              ...BasicReportLocationFields
            }
            reportAttachments {
              ...BasicReportAttachmentFields
            }
            originalReportDeficiency {
              id
              note
              title
              detail
              severity
              reportLocations {
                ...BasicReportLocationFields
              }
              reportAttachments {
                ...BasicReportAttachmentFields
              }
            }
          }
          reportLimitations {
            ...BasicReportLimitationFields
          }
        }
        reportLimitations {
          ...BasicReportLimitationFields
        }
        reportAttachments {
          ...BasicReportAttachmentFields
        }
      }
      reportAttachments {
        ...BasicReportAttachmentFields
      }
    }
  }
}
    ${BasicReportLocationFieldsFragmentDoc}
${BasicReportAttachmentFieldsFragmentDoc}
${BasicReportLimitationFieldsFragmentDoc}`;
export const GetReportPrintHeaderInfoDocument = `
    query GetReportPrintHeaderInfo($orderToken: String!, $reportId: ID!, $contractorId: ID!) {
  contractor(id: $contractorId) {
    id
    businessName
    ...ContractorLicensesFields
  }
  report(id: $reportId) {
    id
    publishedAt
    templateNames
    orderId
  }
  orderByToken(token: $orderToken) {
    id
    floorPlanName
    communityName
    teamExternalId
    orderStakeholders {
      id
      name
      isClient
    }
    property {
      ...PropertyFragment
    }
    inspections {
      id
      orderId
      inspectionReports {
        id
        report {
          id
        }
      }
      inspectionScopeNumber
      inspectionType
      scheduledProposal {
        id
        scheduledAt
      }
    }
  }
}
    ${ContractorLicensesFieldsFragmentDoc}
${PropertyFragmentFragmentDoc}`;
export const GetReportsDocument = `
    query GetReports($first: Int, $after: String, $last: Int, $before: String) {
  reports(first: $first, after: $after, last: $last, before: $before) {
    edges {
      cursor
      node {
        id
        publishedAt
        orderId
        templateNames
        inspectionReports {
          id
          inspection {
            order {
              id
              readOnlyToken
              status
            }
            scheduledProposal {
              id
              isGoAnytime
              contractorId
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;
export const GetAllowsInitialUserCreationDocument = `
    query GetAllowsInitialUserCreation($contractorToken: String!) {
  contractorAllowInitialUserCreation(contractorToken: $contractorToken) {
    isAllowed
  }
}
    `;
export const GetAvailableOrderReportsDocument = `
    query GetAvailableOrderReports($orderToken: String!) {
  orderByToken(token: $orderToken) {
    inspections {
      id
      inspectionScopeNumber
      inspectionType
      inspectionReports {
        id
        report {
          id
          publishedAt
          updatedAt
        }
      }
    }
  }
}
    `;
export const GetContractorDetailsDocument = `
    query GetContractorDetails($contractorId: ID!) {
  contractor(id: $contractorId) {
    id
    contractorType
    businessName
    businessSite
    ashiLicenseNumber
    internachiLicenseNumber
    otherLicenseNumber
    stateLicenseNumber
    state
    country
    logo {
      url
    }
  }
}
    `;
export const GetContractorScoreCardDocument = `
    query GetContractorScoreCard($startDate: UnixTimestamp!, $endDate: UnixTimestamp!) {
  contractorScorecard(startDate: $startDate, endDate: $endDate) {
    hasEnoughData
    inspectorScorecardDashboardUrl
    inspectorScorecardReliabilityScoreUrl
  }
}
    `;
export const GetCurrentUserContractorDetailsDocument = `
    query GetCurrentUserContractorDetails {
  currentUser {
    id
    contractorId
    grantedPermissions
    name
    team {
      id
      name
    }
    contractor {
      id
      businessName
      contractorType
      logo {
        id
        cdnUrl
        url
      }
    }
  }
}
    `;
export const GetCurrentUserDocument = `
    query GetCurrentUser {
  currentUser {
    id
    email
    phoneNumber
    name
    createdAt
    admin
    teamAdmin
    canManageUsers
    contractorId
    grantedPermissions
    contractor {
      id
      businessName
      businessAddress
      businessName
      logo {
        url
      }
      city
      state
      contractorType
      ashiLicenseNumber
      internalTeams {
        id
        allowInAppBooking
        bookingUrl
        name
      }
    }
    teamUsers {
      id
      team {
        id
        token
        name
        teamLogo {
          url
        }
        company {
          id
          name
        }
        allowRehabToolAccess
        enableRehabCostSplitting
        rehabTags
        drawSummaryTableDisplay
        sowSummaryTableDisplay
      }
    }
  }
  availableUsers(onlyContractors: false) {
    id
    email
    name
    createdAt
    admin
    teamAdmin
    canManageUsers
    contractorId
    grantedPermissions
    contractor {
      id
      businessAddress
      businessName
      city
      state
      logo {
        url
      }
    }
    teamUsers {
      id
      team {
        id
        token
        name
        teamLogo {
          url
        }
        company {
          id
          name
        }
        allowRehabToolAccess
        enableRehabCostSplitting
        rehabTags
        drawSummaryTableDisplay
        sowSummaryTableDisplay
      }
    }
  }
}
    `;
export const GetCurrentUserContractorDocument = `
    query GetCurrentUserContractor {
  currentUser {
    id
    contractorId
    grantedPermissions
    contractor {
      id
      businessEmail
      businessAddress
      businessName
      contractorType
      latitude
      longitude
      automatedSchedulingEnabled
      androidBlurryFreqThreshold
      iosBlurryFreqThreshold
      internalTeams {
        id
        allowInAppBooking
        bookingUrl
        name
        teamInspectionConfigs {
          inspectionType
          templateReport {
            id
            displayName
          }
        }
        teamOrderStakeholders {
          id
          stakeholderType
          collectEmail
          collectName
          collectPhone
        }
      }
    }
  }
}
    `;
export const GetFullContractorDetailsDocument = `
    query GetFullContractorDetails($contractorId: ID!) {
  contractor(id: $contractorId) {
    ...FullContractorDetailsFragment
  }
}
    ${FullContractorDetailsFragmentFragmentDoc}
${ContractorLicensesFieldsFragmentDoc}`;
export const GetManageableUsersDocument = `
    query GetManageableUsers($first: Int, $after: String, $last: Int, $before: String, $archived: UnixTimestamp) {
  users(
    first: $first
    after: $after
    last: $last
    before: $before
    archivedAtGt: $archived
  ) {
    edges {
      node {
        id
        name
        email
        phoneNumber
        grantedPermissions
        archivedAt
        activatedAt
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;
export const GetManagedUserDocument = `
    query GetManagedUser($userId: ID!) {
  user(id: $userId) {
    id
    name
    email
    phoneNumber
    grantedPermissions
    archivedAt
    activatedAt
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    CreateFeedback: build.mutation<CreateFeedbackMutation, CreateFeedbackMutationVariables>({
      query: (variables) => ({ document: CreateFeedbackDocument, variables })
    }),
    MutateAttachment: build.mutation<MutateAttachmentMutation, MutateAttachmentMutationVariables>({
      query: (variables) => ({ document: MutateAttachmentDocument, variables })
    }),
    CreateItemAccessLog: build.mutation<CreateItemAccessLogMutation, CreateItemAccessLogMutationVariables>({
      query: (variables) => ({ document: CreateItemAccessLogDocument, variables })
    }),
    CreateReport: build.mutation<CreateReportMutation, CreateReportMutationVariables>({
      query: (variables) => ({ document: CreateReportDocument, variables })
    }),
    MutateCreateReportAttachment: build.mutation<MutateCreateReportAttachmentMutation, MutateCreateReportAttachmentMutationVariables>({
      query: (variables) => ({ document: MutateCreateReportAttachmentDocument, variables })
    }),
    MutateDeleteAttachment: build.mutation<MutateDeleteAttachmentMutation, MutateDeleteAttachmentMutationVariables>({
      query: (variables) => ({ document: MutateDeleteAttachmentDocument, variables })
    }),
    DirectUpload: build.mutation<DirectUploadMutation, DirectUploadMutationVariables>({
      query: (variables) => ({ document: DirectUploadDocument, variables })
    }),
    MutateFixMissingS3ObjectKeys: build.mutation<MutateFixMissingS3ObjectKeysMutation, MutateFixMissingS3ObjectKeysMutationVariables>({
      query: (variables) => ({ document: MutateFixMissingS3ObjectKeysDocument, variables })
    }),
    MutateFloorplanAnchors: build.mutation<MutateFloorplanAnchorsMutation, MutateFloorplanAnchorsMutationVariables>({
      query: (variables) => ({ document: MutateFloorplanAnchorsDocument, variables })
    }),
    GeneratePhotoSphereImagesZip: build.mutation<GeneratePhotoSphereImagesZipMutation, GeneratePhotoSphereImagesZipMutationVariables>({
      query: (variables) => ({ document: GeneratePhotoSphereImagesZipDocument, variables })
    }),
    MutateInspectionScopeItem: build.mutation<MutateInspectionScopeItemMutation, MutateInspectionScopeItemMutationVariables>({
      query: (variables) => ({ document: MutateInspectionScopeItemDocument, variables })
    }),
    MutatePermitsPdf: build.mutation<MutatePermitsPdfMutation, MutatePermitsPdfMutationVariables>({
      query: (variables) => ({ document: MutatePermitsPdfDocument, variables })
    }),
    MutatePropertyGeneratePermitPdf: build.mutation<MutatePropertyGeneratePermitPdfMutation, MutatePropertyGeneratePermitPdfMutationVariables>({
      query: (variables) => ({ document: MutatePropertyGeneratePermitPdfDocument, variables })
    }),
    PublishReport: build.mutation<PublishReportMutation, PublishReportMutationVariables>({
      query: (variables) => ({ document: PublishReportDocument, variables })
    }),
    MutateReportFixMissingS3Object: build.mutation<MutateReportFixMissingS3ObjectMutation, MutateReportFixMissingS3ObjectMutationVariables>({
      query: (variables) => ({ document: MutateReportFixMissingS3ObjectDocument, variables })
    }),
    MutateReportPdf: build.mutation<MutateReportPdfMutation, MutateReportPdfMutationVariables>({
      query: (variables) => ({ document: MutateReportPdfDocument, variables })
    }),
    MutateTipaltiUrl: build.mutation<MutateTipaltiUrlMutation, MutateTipaltiUrlMutationVariables>({
      query: (variables) => ({ document: MutateTipaltiUrlDocument, variables })
    }),
    MutateWarrantyClaim: build.mutation<MutateWarrantyClaimMutation, MutateWarrantyClaimMutationVariables>({
      query: (variables) => ({ document: MutateWarrantyClaimDocument, variables })
    }),
    MutateWarrantyOwnership: build.mutation<MutateWarrantyOwnershipMutation, MutateWarrantyOwnershipMutationVariables>({
      query: (variables) => ({ document: MutateWarrantyOwnershipDocument, variables })
    }),
    CreateInspectorOnboarding: build.mutation<CreateInspectorOnboardingMutation, CreateInspectorOnboardingMutationVariables>({
      query: (variables) => ({ document: CreateInspectorOnboardingDocument, variables })
    }),
    CreateSurveyorOnboarding: build.mutation<CreateSurveyorOnboardingMutation, CreateSurveyorOnboardingMutationVariables>({
      query: (variables) => ({ document: CreateSurveyorOnboardingDocument, variables })
    }),
    MutateInspectorOnboarding: build.mutation<MutateInspectorOnboardingMutation, MutateInspectorOnboardingMutationVariables>({
      query: (variables) => ({ document: MutateInspectorOnboardingDocument, variables })
    }),
    MutateSurveyorOnboarding: build.mutation<MutateSurveyorOnboardingMutation, MutateSurveyorOnboardingMutationVariables>({
      query: (variables) => ({ document: MutateSurveyorOnboardingDocument, variables })
    }),
    CreateRehabProject: build.mutation<CreateRehabProjectMutation, CreateRehabProjectMutationVariables>({
      query: (variables) => ({ document: CreateRehabProjectDocument, variables })
    }),
    CreateRehabWorkItem: build.mutation<CreateRehabWorkItemMutation, CreateRehabWorkItemMutationVariables>({
      query: (variables) => ({ document: CreateRehabWorkItemDocument, variables })
    }),
    CreateRehabWorkItemAssociation: build.mutation<CreateRehabWorkItemAssociationMutation, CreateRehabWorkItemAssociationMutationVariables>({
      query: (variables) => ({ document: CreateRehabWorkItemAssociationDocument, variables })
    }),
    CreateRehabWorkItemAttachment: build.mutation<CreateRehabWorkItemAttachmentMutation, CreateRehabWorkItemAttachmentMutationVariables>({
      query: (variables) => ({ document: CreateRehabWorkItemAttachmentDocument, variables })
    }),
    createRehabWorkItemContributor: build.mutation<CreateRehabWorkItemContributorMutation, CreateRehabWorkItemContributorMutationVariables>({
      query: (variables) => ({ document: CreateRehabWorkItemContributorDocument, variables })
    }),
    DeleteRehabWorkItem: build.mutation<DeleteRehabWorkItemMutation, DeleteRehabWorkItemMutationVariables>({
      query: (variables) => ({ document: DeleteRehabWorkItemDocument, variables })
    }),
    DeleteRehabWorkItemAssociation: build.mutation<DeleteRehabWorkItemAssociationMutation, DeleteRehabWorkItemAssociationMutationVariables>({
      query: (variables) => ({ document: DeleteRehabWorkItemAssociationDocument, variables })
    }),
    DeleteRehabWorkItemAttachment: build.mutation<DeleteRehabWorkItemAttachmentMutation, DeleteRehabWorkItemAttachmentMutationVariables>({
      query: (variables) => ({ document: DeleteRehabWorkItemAttachmentDocument, variables })
    }),
    DeleteRehabWorkItemContributor: build.mutation<DeleteRehabWorkItemContributorMutation, DeleteRehabWorkItemContributorMutationVariables>({
      query: (variables) => ({ document: DeleteRehabWorkItemContributorDocument, variables })
    }),
    DeleteTeamCustomSystem: build.mutation<DeleteTeamCustomSystemMutation, DeleteTeamCustomSystemMutationVariables>({
      query: (variables) => ({ document: DeleteTeamCustomSystemDocument, variables })
    }),
    MutateRehabProject: build.mutation<MutateRehabProjectMutation, MutateRehabProjectMutationVariables>({
      query: (variables) => ({ document: MutateRehabProjectDocument, variables })
    }),
    MutateRehabProjectGenerateCsv: build.mutation<MutateRehabProjectGenerateCsvMutation, MutateRehabProjectGenerateCsvMutationVariables>({
      query: (variables) => ({ document: MutateRehabProjectGenerateCsvDocument, variables })
    }),
    MutateRehabProjectGeneratePdf: build.mutation<MutateRehabProjectGeneratePdfMutation, MutateRehabProjectGeneratePdfMutationVariables>({
      query: (variables) => ({ document: MutateRehabProjectGeneratePdfDocument, variables })
    }),
    PopulateTeamCustomSystem: build.mutation<PopulateTeamCustomSystemMutation, PopulateTeamCustomSystemMutationVariables>({
      query: (variables) => ({ document: PopulateTeamCustomSystemDocument, variables })
    }),
    PublishRehabProject: build.mutation<PublishRehabProjectMutation, PublishRehabProjectMutationVariables>({
      query: (variables) => ({ document: PublishRehabProjectDocument, variables })
    }),
    UpdateRehabWorkItem: build.mutation<UpdateRehabWorkItemMutation, UpdateRehabWorkItemMutationVariables>({
      query: (variables) => ({ document: UpdateRehabWorkItemDocument, variables })
    }),
    updateWorkItemContributor: build.mutation<UpdateWorkItemContributorMutation, UpdateWorkItemContributorMutationVariables>({
      query: (variables) => ({ document: UpdateWorkItemContributorDocument, variables })
    }),
    CreateUser: build.mutation<CreateUserMutation, CreateUserMutationVariables>({
      query: (variables) => ({ document: CreateUserDocument, variables })
    }),
    CreateUserContractor: build.mutation<CreateUserContractorMutation, CreateUserContractorMutationVariables>({
      query: (variables) => ({ document: CreateUserContractorDocument, variables })
    }),
    MutateCheckVerificationSms: build.mutation<MutateCheckVerificationSmsMutation, MutateCheckVerificationSmsMutationVariables>({
      query: (variables) => ({ document: MutateCheckVerificationSmsDocument, variables })
    }),
    MutateContractorDetails: build.mutation<MutateContractorDetailsMutation, MutateContractorDetailsMutationVariables>({
      query: (variables) => ({ document: MutateContractorDetailsDocument, variables })
    }),
    MutateInviteResend: build.mutation<MutateInviteResendMutation, MutateInviteResendMutationVariables>({
      query: (variables) => ({ document: MutateInviteResendDocument, variables })
    }),
    MutateSendVerificationSms: build.mutation<MutateSendVerificationSmsMutation, MutateSendVerificationSmsMutationVariables>({
      query: (variables) => ({ document: MutateSendVerificationSmsDocument, variables })
    }),
    MutateUser: build.mutation<MutateUserMutation, MutateUserMutationVariables>({
      query: (variables) => ({ document: MutateUserDocument, variables })
    }),
    MutateUserInvitation: build.mutation<MutateUserInvitationMutation, MutateUserInvitationMutationVariables>({
      query: (variables) => ({ document: MutateUserInvitationDocument, variables })
    }),
    GetJob: build.query<GetJobQuery, GetJobQueryVariables | void>({
      query: (variables) => ({ document: GetJobDocument, variables })
    }),
    GetJobDetails: build.query<GetJobDetailsQuery, GetJobDetailsQueryVariables>({
      query: (variables) => ({ document: GetJobDetailsDocument, variables })
    }),
    GetJobs: build.query<GetJobsQuery, GetJobsQueryVariables | void>({
      query: (variables) => ({ document: GetJobsDocument, variables })
    }),
    GetInspectorOnboarding: build.query<GetInspectorOnboardingQuery, GetInspectorOnboardingQueryVariables>({
      query: (variables) => ({ document: GetInspectorOnboardingDocument, variables })
    }),
    GetSurveyorOnboarding: build.query<GetSurveyorOnboardingQuery, GetSurveyorOnboardingQueryVariables>({
      query: (variables) => ({ document: GetSurveyorOnboardingDocument, variables })
    }),
    GetAllDownloadLinksForOrder: build.query<GetAllDownloadLinksForOrderQuery, GetAllDownloadLinksForOrderQueryVariables>({
      query: (variables) => ({ document: GetAllDownloadLinksForOrderDocument, variables })
    }),
    GetOrderByToken: build.query<GetOrderByTokenQuery, GetOrderByTokenQueryVariables>({
      query: (variables) => ({ document: GetOrderByTokenDocument, variables })
    }),
    GetOrderPropertyPhoto: build.query<GetOrderPropertyPhotoQuery, GetOrderPropertyPhotoQueryVariables>({
      query: (variables) => ({ document: GetOrderPropertyPhotoDocument, variables })
    }),
    GetOrderStakeholderInformation: build.query<GetOrderStakeholderInformationQuery, GetOrderStakeholderInformationQueryVariables>({
      query: (variables) => ({ document: GetOrderStakeholderInformationDocument, variables })
    }),
    GetPermitReport: build.query<GetPermitReportQuery, GetPermitReportQueryVariables>({
      query: (variables) => ({ document: GetPermitReportDocument, variables })
    }),
    GetPermitsSummary: build.query<GetPermitsSummaryQuery, GetPermitsSummaryQueryVariables>({
      query: (variables) => ({ document: GetPermitsSummaryDocument, variables })
    }),
    GetProjectHistory: build.query<GetProjectHistoryQuery, GetProjectHistoryQueryVariables>({
      query: (variables) => ({ document: GetProjectHistoryDocument, variables })
    }),
    getRehabProject: build.query<GetRehabProjectQuery, GetRehabProjectQueryVariables>({
      query: (variables) => ({ document: GetRehabProjectDocument, variables })
    }),
    GetRehabProjectReadOnly: build.query<GetRehabProjectReadOnlyQuery, GetRehabProjectReadOnlyQueryVariables>({
      query: (variables) => ({ document: GetRehabProjectReadOnlyDocument, variables })
    }),
    GetRehabProjects: build.query<GetRehabProjectsQuery, GetRehabProjectsQueryVariables>({
      query: (variables) => ({ document: GetRehabProjectsDocument, variables })
    }),
    GetTemplateWorkItems: build.query<GetTemplateWorkItemsQuery, GetTemplateWorkItemsQueryVariables | void>({
      query: (variables) => ({ document: GetTemplateWorkItemsDocument, variables })
    }),
    GetInspectionFloorplans: build.query<GetInspectionFloorplansQuery, GetInspectionFloorplansQueryVariables>({
      query: (variables) => ({ document: GetInspectionFloorplansDocument, variables })
    }),
    GetInspectionScopeItems: build.query<GetInspectionScopeItemsQuery, GetInspectionScopeItemsQueryVariables>({
      query: (variables) => ({ document: GetInspectionScopeItemsDocument, variables })
    }),
    GetPhotoSphereAttachments: build.query<GetPhotoSphereAttachmentsQuery, GetPhotoSphereAttachmentsQueryVariables>({
      query: (variables) => ({ document: GetPhotoSphereAttachmentsDocument, variables })
    }),
    GetReport: build.query<GetReportQuery, GetReportQueryVariables>({
      query: (variables) => ({ document: GetReportDocument, variables })
    }),
    GetReportLean: build.query<GetReportLeanQuery, GetReportLeanQueryVariables>({
      query: (variables) => ({ document: GetReportLeanDocument, variables })
    }),
    GetReportPrintHeaderInfo: build.query<GetReportPrintHeaderInfoQuery, GetReportPrintHeaderInfoQueryVariables>({
      query: (variables) => ({ document: GetReportPrintHeaderInfoDocument, variables })
    }),
    GetReports: build.query<GetReportsQuery, GetReportsQueryVariables | void>({
      query: (variables) => ({ document: GetReportsDocument, variables })
    }),
    GetAllowsInitialUserCreation: build.query<GetAllowsInitialUserCreationQuery, GetAllowsInitialUserCreationQueryVariables>({
      query: (variables) => ({ document: GetAllowsInitialUserCreationDocument, variables })
    }),
    GetAvailableOrderReports: build.query<GetAvailableOrderReportsQuery, GetAvailableOrderReportsQueryVariables>({
      query: (variables) => ({ document: GetAvailableOrderReportsDocument, variables })
    }),
    GetContractorDetails: build.query<GetContractorDetailsQuery, GetContractorDetailsQueryVariables>({
      query: (variables) => ({ document: GetContractorDetailsDocument, variables })
    }),
    GetContractorScoreCard: build.query<GetContractorScoreCardQuery, GetContractorScoreCardQueryVariables>({
      query: (variables) => ({ document: GetContractorScoreCardDocument, variables })
    }),
    GetCurrentUserContractorDetails: build.query<GetCurrentUserContractorDetailsQuery, GetCurrentUserContractorDetailsQueryVariables | void>({
      query: (variables) => ({ document: GetCurrentUserContractorDetailsDocument, variables })
    }),
    GetCurrentUser: build.query<GetCurrentUserQuery, GetCurrentUserQueryVariables | void>({
      query: (variables) => ({ document: GetCurrentUserDocument, variables })
    }),
    GetCurrentUserContractor: build.query<GetCurrentUserContractorQuery, GetCurrentUserContractorQueryVariables | void>({
      query: (variables) => ({ document: GetCurrentUserContractorDocument, variables })
    }),
    GetFullContractorDetails: build.query<GetFullContractorDetailsQuery, GetFullContractorDetailsQueryVariables>({
      query: (variables) => ({ document: GetFullContractorDetailsDocument, variables })
    }),
    GetManageableUsers: build.query<GetManageableUsersQuery, GetManageableUsersQueryVariables | void>({
      query: (variables) => ({ document: GetManageableUsersDocument, variables })
    }),
    GetManagedUser: build.query<GetManagedUserQuery, GetManagedUserQueryVariables>({
      query: (variables) => ({ document: GetManagedUserDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateFeedbackMutation, useMutateAttachmentMutation, useCreateItemAccessLogMutation, useCreateReportMutation, useMutateCreateReportAttachmentMutation, useMutateDeleteAttachmentMutation, useDirectUploadMutation, useMutateFixMissingS3ObjectKeysMutation, useMutateFloorplanAnchorsMutation, useGeneratePhotoSphereImagesZipMutation, useMutateInspectionScopeItemMutation, useMutatePermitsPdfMutation, useMutatePropertyGeneratePermitPdfMutation, usePublishReportMutation, useMutateReportFixMissingS3ObjectMutation, useMutateReportPdfMutation, useMutateTipaltiUrlMutation, useMutateWarrantyClaimMutation, useMutateWarrantyOwnershipMutation, useCreateInspectorOnboardingMutation, useCreateSurveyorOnboardingMutation, useMutateInspectorOnboardingMutation, useMutateSurveyorOnboardingMutation, useCreateRehabProjectMutation, useCreateRehabWorkItemMutation, useCreateRehabWorkItemAssociationMutation, useCreateRehabWorkItemAttachmentMutation, useCreateRehabWorkItemContributorMutation, useDeleteRehabWorkItemMutation, useDeleteRehabWorkItemAssociationMutation, useDeleteRehabWorkItemAttachmentMutation, useDeleteRehabWorkItemContributorMutation, useDeleteTeamCustomSystemMutation, useMutateRehabProjectMutation, useMutateRehabProjectGenerateCsvMutation, useMutateRehabProjectGeneratePdfMutation, usePopulateTeamCustomSystemMutation, usePublishRehabProjectMutation, useUpdateRehabWorkItemMutation, useUpdateWorkItemContributorMutation, useCreateUserMutation, useCreateUserContractorMutation, useMutateCheckVerificationSmsMutation, useMutateContractorDetailsMutation, useMutateInviteResendMutation, useMutateSendVerificationSmsMutation, useMutateUserMutation, useMutateUserInvitationMutation, useGetJobQuery, useLazyGetJobQuery, useGetJobDetailsQuery, useLazyGetJobDetailsQuery, useGetJobsQuery, useLazyGetJobsQuery, useGetInspectorOnboardingQuery, useLazyGetInspectorOnboardingQuery, useGetSurveyorOnboardingQuery, useLazyGetSurveyorOnboardingQuery, useGetAllDownloadLinksForOrderQuery, useLazyGetAllDownloadLinksForOrderQuery, useGetOrderByTokenQuery, useLazyGetOrderByTokenQuery, useGetOrderPropertyPhotoQuery, useLazyGetOrderPropertyPhotoQuery, useGetOrderStakeholderInformationQuery, useLazyGetOrderStakeholderInformationQuery, useGetPermitReportQuery, useLazyGetPermitReportQuery, useGetPermitsSummaryQuery, useLazyGetPermitsSummaryQuery, useGetProjectHistoryQuery, useLazyGetProjectHistoryQuery, useGetRehabProjectQuery, useLazyGetRehabProjectQuery, useGetRehabProjectReadOnlyQuery, useLazyGetRehabProjectReadOnlyQuery, useGetRehabProjectsQuery, useLazyGetRehabProjectsQuery, useGetTemplateWorkItemsQuery, useLazyGetTemplateWorkItemsQuery, useGetInspectionFloorplansQuery, useLazyGetInspectionFloorplansQuery, useGetInspectionScopeItemsQuery, useLazyGetInspectionScopeItemsQuery, useGetPhotoSphereAttachmentsQuery, useLazyGetPhotoSphereAttachmentsQuery, useGetReportQuery, useLazyGetReportQuery, useGetReportLeanQuery, useLazyGetReportLeanQuery, useGetReportPrintHeaderInfoQuery, useLazyGetReportPrintHeaderInfoQuery, useGetReportsQuery, useLazyGetReportsQuery, useGetAllowsInitialUserCreationQuery, useLazyGetAllowsInitialUserCreationQuery, useGetAvailableOrderReportsQuery, useLazyGetAvailableOrderReportsQuery, useGetContractorDetailsQuery, useLazyGetContractorDetailsQuery, useGetContractorScoreCardQuery, useLazyGetContractorScoreCardQuery, useGetCurrentUserContractorDetailsQuery, useLazyGetCurrentUserContractorDetailsQuery, useGetCurrentUserQuery, useLazyGetCurrentUserQuery, useGetCurrentUserContractorQuery, useLazyGetCurrentUserContractorQuery, useGetFullContractorDetailsQuery, useLazyGetFullContractorDetailsQuery, useGetManageableUsersQuery, useLazyGetManageableUsersQuery, useGetManagedUserQuery, useLazyGetManagedUserQuery } = injectedRtkApi;

